/* eslint-disable */
export default {
  actions: {
    add: 'add',
    addAdditionalTargetingCriteria: 'add additional targeting criteria',
    addAllChildren: 'add all children',
    addAudienceFile: 'add audience file',
    addAudienceGeofenceGroupLayer: 'Add an audience geofence layer',
    addAudienceLogic: 'add a custom audience',
    addAvailsFile: 'Add Avails File',
    addCampaign: 'add a campaign',
    addCreative: 'add a creative',
    addCreativeTrackingUrl: 'Add tracking URL',
    addCustomEvent: 'add custom event',
    addDeal: 'add a deal',
    addDeviceIDSegmentRule: 'Add Device ID segment rule',
    addDiscount: 'add discount',
    addExternalEvent: 'add custom event',
    addFilter: 'add filter',
    addFilters: 'add filters',
    addGeofence: 'add a geofence',
    addGeofenceGroup: 'add a geofence group',
    addGeofenceGroupFilter: 'add geofence group filter',
    addGeofenceGroupLayer: 'Add a geofence layer',
    addGroup: 'add group',
    addLayer: 'add layer',
    addLiftDashboard: 'add a lift analysis',
    addLineItem: 'add a line item',
    addMargin: 'add a margin',
    addMobileCreative: 'add a mobile creative',
    addOrganizationCustomField: 'add custom field',
    addPointOnMap: 'add a point',
    addPolygonToExistingGeofence: 'Append the polygon to a nearby geofence',
    addPreSaleHeatmap: 'add a proposal heatmap',
    addPreSaleHeatmapLayer: 'add a layer',
    addPredefinedDemographicRules: 'Add demographics rule',
    addPredefinedSegmentRule: 'add pre-defined segment rule',
    addProperty: 'add property',
    addReportDefinition: 'add a report definition',
    addReportExecution: 'add a report execution',
    addRule: 'add geofence rule',
    addRuleDemo: 'add audience segment',
    addSSP: 'add SSP',
    addSegmentRule: 'add segment rule',
    addSite: 'add a site',
    addTargeting: 'add targeting',
    addToFilters: 'add to filters',
    addToSelection: 'add to selection',
    addUnit: 'add a screen',
    addUnitPack: 'add pack',
    addVASTTag: 'Add VAST tag',
    addView: 'add view',
    advertise: 'advertise',
    apply: 'apply',
    approve: 'approve',
    approveCreativeFiles: 'approve creative files',
    approveCreativePrefetchSizes: 'approve screen sizes',
    approveCreatives: 'approve creatives',
    approveDeals: 'approve deals',
    approveForSpecificNetworks: 'approve for specific networks',
    approveLineItem: 'approve line item',
    approveLineItems: 'approve line items',
    archive: 'archive',
    archiveLineItem: 'Archive line item',
    archiveLineItems: 'archive line items',
    avoid: 'avoid',
    back: 'back',
    batchUpload: 'batch upload',
    browse: 'browse',
    browseMediaOwners: 'Browse media owners',
    bulkEdit: 'bulk edit',
    bulkUpdate: 'bulk update',
    bulkUpload: 'bulk upload',
    buy: 'buy',
    calculate: 'calculate',
    cancel: 'cancel',
    cancelLineItems: 'cancel line items',
    change: 'change',
    changeOrganization: 'change organization',
    changePassword: 'change password',
    changeProfilePicture: 'change profile picture',
    changeToPolygon: 'change to polygon',
    checkAvailability: 'check availability',
    checkAvails: 'check availability',
    checkMissingCreativeDimensions: 'check missing creative dimensions',
    checkRequiredCreativeDimensions: 'check required creative dimensions',
    clear: 'clear',
    clearAll: 'clear all',
    clearGeofence: 'clear geofence',
    close: 'close',
    combineSearchResults: 'Combine search results with previous results',
    confirmDeleteLineItemLinks: 'Are you sure you want to delete the link to the selected line item(s)?',
    confirmDeleteNetwork: 'Are you sure you want to delete the selected network?',
    confirmDeletePlan: 'Are you sure you want to delete the selected plan?',
    confirmDeletePlans: 'Are you sure you want to delete the selected plans?',
    confirmDeleteUnitPack: 'Are you sure you want to delete the selected pack?',
    contendingLineItemsReport: 'contending line items report',
    continue: 'continue',
    convertPackageToExternalDspLineitem: 'create line item from deal',
    convertPlanToCampaign: 'Save as a Campaign',
    copy: 'copy',
    copyGeofencesToClipboard: 'copy geofences to clipboard',
    copyInventoryTargeting: 'copy inventory targeting',
    copyPollenTargeting: 'copy pollen targeting',
    copyPublicLink: 'copy public link',
    copyTargeting: 'copy targeting',
    copyWeatherTargeting: 'copy weather targeting',
    create: 'create',
    createAFirstCustomEvent: 'create a first custom event',
    createAFirstNetwork: 'create a first network',
    createAFirstPlan: 'Create a first plan',
    createAFirstScreenPack: 'create a first screen pack',
    createCopy: 'create a copy',
    createLineItem: 'create line item',
    createNewAccount: 'create a new account',
    createNewAdvertiser: 'create a new advertiser',
    createSSP: 'create SSP',
    createUser: 'create user',
    cropImage: 'crop image',
    customizeDaypart: 'Customize daypart',
    delete: 'delete',
    deleteAll: 'delete all',
    deleteAudienceFile: 'delete audience file',
    deleteAudienceFiles: 'delete audience files',
    deleteAudienceLogic: 'delete custom audience',
    deleteAudienceLogics: 'delete custom audiences',
    deleteAudienceRules: 'delete custom audiences',
    deleteCampaign: 'delete campaign',
    deleteCampaigns: 'delete campaigns',
    deleteCreative: 'delete creative',
    deleteCreativeFiles: 'delete creative files',
    deleteCreatives: 'delete creatives',
    deleteCustomEvent: 'delete custom event',
    deleteCustomEvents: 'delete custom events',
    deleteGeofence: 'delete geofence',
    deleteGeofenceGroup: 'delete geofence group',
    deleteGeofenceGroups: 'delete geofence groups',
    deleteGeofences: 'delete geofences',
    deleteJourneyAnalyses: 'delete journeys',
    deleteLiftDashboard: 'delete lift dashboard',
    deleteLiftDashboards: 'delete lift analysis',
    deleteLineItem: 'delete line item',
    deleteLineItemLinks: 'Delete link to line item(s)',
    deleteLineItems: 'delete line items',
    deleteMargin: 'delete margin',
    deleteMargins: 'delete margins',
    deleteMobileLineItems: 'delete mobile line items',
    deleteNetwork: 'delete Network',
    deleteOrganizationCustomField: 'delete custom field',
    deleteOrganizationCustomFields: 'delete custom fields',
    deletePackages: 'delete deals',
    deletePlan: 'delete plan',
    deletePreSaleHeatmap: 'delete proposal heatmap',
    deletePreSaleHeatmaps: 'delete proposal heatmaps',
    deleteReportDefinitions: 'delete report definitions',
    deleteReportExecution: 'delete report execution',
    deleteReportExecutions: 'delete report executions',
    deleteSSPs: 'delete SSPs',
    deleteSite: 'delete site',
    deleteSites: 'delete sites',
    deleteUnit: 'delete screen',
    deleteUnitPack: 'delete pack',
    deleteUnits: 'delete screens',
    deleteUser: 'delete user',
    disableDebugMode: 'Disable debug mode',
    discardChanges: 'discard changes',
    discardNewEntity: 'discard new item',
    dismiss: 'dismiss',
    dontImport: 'don\'t import',
    download: 'Download',
    downloadATemplate: 'download a template',
    downloadAsCSV: 'Download as CSV',
    downloadCSVTemplate: 'Download CSV template',
    downloadGeofences: 'download geofences',
    downloadHourlyReport: 'Download hourly report',
    downloadLineItemsCSV: 'Download line items CSV file',
    downloadLineItemsXLSX: 'Download line items Excel file',
    downloadReports: 'download reports',
    downloadRowsCausingErrors: 'download rows causing errors',
    downloadScreens: 'download screens',
    downloadSites: 'download sites',
    downloadTargetedScreens: 'download targeted screens',
    downloadTargetedSites: 'download targeted sites',
    downloadUnitsMissingAudienceData: 'Download missing screens',
    downloadXLSXTemplate: 'Download Excel template',
    downloadingScreens: 'downloading screens',
    downloadingTargetedScreens: 'downloading targeted screens',
    drawPolygon: 'draw polygon',
    drawSelection: 'draw selection',
    duplicate: 'duplicate',
    edit: 'edit',
    editAdvancedReport: 'Edit Advanced Report',
    editApprovedLineItem: 'Edit line item',
    editAudienceFile: 'edit audience file',
    editAudienceGeofenceGroup: 'edit audience geofence group',
    editAudienceLogic: 'edit custom audience',
    editCampaign: 'edit campaign',
    editCreative: 'edit creative',
    editCreativeWeights: 'edit creative weights',
    editCreativeWeightsAndDates: 'edit creative weights / dates',
    editCustomEvent: 'edit custom event',
    editDeal: 'edit deal',
    editExternalCreative: 'edit external creative',
    editGeofence: 'edit geofence',
    editGeofenceGroup: 'edit geofence group',
    editHeaderBidderPreset: 'edit header bidder preset',
    editJourneyAnalysis: 'edit journey analysis',
    editLiftDashboard: 'edit lift dashboard',
    editLineItem: 'edit line item',
    editMargin: 'edit margin',
    editMobileCreative: 'edit mobile creative',
    editMobileLineItem: 'Edit mobile line item',
    editMovieAudience: 'edit movie audience',
    editNetwork: 'edit Network',
    editNonDraftCreative: 'edit creative',
    editNonDraftLineItem: 'edit line item',
    editNonDraftPackage: 'edit deal',
    editOnMap: 'edit on map',
    editOrganizationCustomField: 'edit custom field',
    editPackage: 'edit package',
    editPlan: 'edit plan',
    editPreSaleHeatmap: 'edit proposal heatmap',
    editPresaleHeatmap: 'edit proposal heatmap',
    editProximityGeofenceGroup: 'edit proximity geofence group',
    editReportDefinition: 'edit report definition',
    editReportExecution: 'edit report execution',
    editRole: 'edit role',
    editSite: 'edit site',
    editUnit: 'edit screen',
    editUnitPack: 'edit pack',
    enableCustomEvents: 'enable custom events',
    enableDebugMode: 'Enable debug mode',
    enableExternalEvents: 'enable external events',
    enableHivestackLogo: 'enable hivestack logo',
    enableLogo: 'enable logo',
    enableMinimumAudienceConcentration: 'enable min. audience concentration',
    enableScreenSizeApproval: 'enable screen size approval',
    enableScreenThumbnail: 'Enable screens thumbnails',
    enableTopLeftLogo: 'enable top left logo',
    enableTopRightLogo: 'enable top right logo',
    exclude: 'exclude',
    excludeAllChildren: 'exclude all children',
    excludeList: 'exclude list',
    exitFullscreen: 'exit fullscreen',
    export: 'export',
    exportInventoryFoundInGeofences: 'Export inventory found in geofences',
    exportProposalToPdf: 'export proposal to PDF',
    faster: 'faster',
    fitAllGeofencesIntoView: 'fit all geofences into view',
    forgotYourPassword: 'Forgot Your Password?',
    generateDealId: 'generate Deal ID',
    getAvailabilityByScreen: 'get availability by screen',
    getRateCardCPM: 'get rate card CPM',
    hide: 'hide',
    hideFilters: 'hide filters',
    hideScreensWithNoData: 'hide screens with no data',
    high: 'high',
    iUnderstand: 'I understand',
    importDailyStats: 'import daily stats',
    importPOIs: 'import points of interest',
    importValidRows: 'import valid rows',
    include: 'include',
    includeLiftAnalysis: 'include lift analysis',
    includeList: 'include list',
    includeScreensWithNoData: 'include screens with no data',
    invert: 'invert',
    linkPolygonToExistingGeofence: 'Replace the polygon of a nearby geofence',
    linkToCreative: 'link to creative',
    linkToFallbackCreatives: 'link to fallback creatives',
    linkToLineItem: 'link to line item',
    linkToMobileCreative: 'link to mobile creative',
    linkToMobileLineItem: 'link to mobile line item',
    loadMoreResults: 'load more results',
    loadingCreativeSizes: 'loading creative sizes',
    login: 'log in',
    logout: 'log out',
    low: 'low',
    maxFloorCPMIncrease: 'max floor CPM increase',
    medium: 'medium',
    moreFilters: 'more filters',
    new: 'new',
    newAudienceFile: 'new audience file',
    newAudienceGeofenceGroup: 'new audience geofence group',
    newAudienceLogic: 'new custom audience',
    newAvailsFile: 'New Avails File',
    newCampaign: 'new campaign',
    newCreative: 'new creative',
    newCreativeFile: 'new creative file',
    newCustomEvent: 'new custom event',
    newDeal: 'new deal',
    newExternalCreative: 'new external creative',
    newExternalEvent: 'new external event',
    newFallbackCreative: 'new fallback creative',
    newGeofence: 'new geofence',
    newGeofenceFromPolygon: 'Create a new geofence from the polygon',
    newGeofenceGroup: 'new geofence group',
    newJourneyAnalysis: 'new journey analysis',
    newLiftDashboard: 'new lift dashboard',
    newLineItem: 'new line item',
    newMargin: 'new margin',
    newMobileLineItem: 'New mobile line item',
    newMovieAudience: 'new movie audience',
    newNetwork: 'new network',
    newOrganizationCustomField: 'new custom field',
    newPack: 'new pack',
    newPackage: 'new deal',
    newPlan: 'new  plan',
    newPreSaleHeatmap: 'new proposal heatmap',
    newProximityGeofenceGroup: 'new proximity geofence group',
    newReportDefinition: 'new report definition',
    newReportExecution: 'new report execution',
    newSite: 'new site',
    newUnit: 'new screen',
    next: 'next',
    no: 'no',
    none: 'none',
    ok: 'OK',
    pause: 'pause',
    pauseCreative: 'pause creative',
    pauseCreatives: 'pause creatives',
    pauseLineItem: 'pause line item',
    pauseLineItems: 'pause line items',
    pickAnExistingAccount: 'pick an existing account',
    pickAnExistingAdvertiser: 'pick an existing advertiser',
    planning: 'planning',
    playLineItems: 'play line items',
    preview: 'preview',
    previewScreens: 'preview screens',
    previous: 'previous',
    publish: 'publish',
    publishLineItems: 'publish line items',
    publishPackage: 'publish deal',
    publishPackages: 'publish deals',
    refresh: 'refresh',
    reject: 'reject',
    rejectCreative: 'reject creative',
    rejectCreativeFiles: 'reject creative files',
    rejectCreativePrefetchSizes: 'reject screen sizes',
    rejectCreatives: 'reject creatives',
    rejectDeals: 'reject deals',
    rejectLineItem: 'reject line item',
    rejectLineItems: 'reject line items',
    reload: 'reload',
    reloadFromLineItem: 'reload from line item',
    remove: 'remove',
    removeAll: 'remove All',
    removeFilter: 'remove filter',
    removeFromFilters: 'remove from filters',
    removeFromSelection: 'remove from selection',
    removePhoto: 'Remove photo',
    requestLiftAnalysis: 'request lift analysis',
    resendEmail: 'resend email',
    resendVerificationEmail: 'resend verification email',
    reset: 'reset',
    resetColumns: 'reset columns',
    resetMyPassword: 'reset my password',
    resetPassword: 'reset password',
    resetYourPassword: 'reset your password',
    restoreDefault: 'restore default',
    resume: 'resume',
    retire: 'retire',
    retireCreative: 'retire creative',
    retirePackage: 'retire deal',
    retirePackages: 'retire deals',
    retract: 'retract',
    retry: 'retry',
    revertChanges: 'revert changes',
    review: 'review',
    run: 'run',
    runReport: 'run report',
    save: 'save',
    saveAndNewLineItem: 'save & create new line item',
    saveAndRun: 'save and run',
    saveChanges: 'save changes',
    saveCreativeWeights: 'save creative weights',
    saveNewEntity: 'save new item',
    search: 'search',
    searchForCategoriesAndSegments: 'Search for categories, segments',
    searchForPostalCodesEtc: 'Search for postal codes, etc...',
    searchInventoryLocationsMarkets: 'search inventory, locations, markets',
    searchLocations: 'search locations',
    searchMediaOwners: 'Search media owners',
    searchPlaces: 'Search places',
    searchScreenPacks: 'search packs',
    searchScreens: 'search screens',
    searchScreensSiteLocationsMarkets: 'search screens, sites, locations, markets',
    searchSites: 'search sites',
    seeNextRevision: 'see next revision',
    seePreviousRevision: 'see previous revision',
    select: 'select',
    selectAll: 'select all',
    selectExistingAccount: 'select existing account',
    selectNone: 'select none',
    selectYourAudience: 'select your audience',
    sendEmail: 'Send Email',
    sendToDraft: 'Return to draft',
    setAsDefaultFilters: 'Set as default filters',
    share: 'share',
    showAll: 'show All',
    showAllScreenSizes: 'show all screen sizes',
    showLayer: 'show layer',
    showLess: 'Show less',
    showMore: 'Show more',
    skip: 'Skip',
    slower: 'slower',
    startOver: 'start over',
    startSlideshow: 'start slideshow',
    startStop: 'start / stop',
    stay: 'stay',
    stop: 'stop',
    stopSlideshow: 'stop slideshow',
    submit: 'submit',
    submitCreativeForApproval: 'Submit creative for approval',
    submitForApproval: 'Submit for approval',
    submitLineItemForApproval: 'Submit line item for approval',
    submitLineItems: 'Submit line item(s) for approval',
    switchMapStyle: 'switch map style',
    ungroup: 'ungroup',
    unlinkCreatives: 'unlink creatives',
    unlinkLineItems: 'unlink line items',
    unlinkMobileCreatives: 'unlink mobile creatives',
    unlinkMobileLineItems: 'unlink mobile line item',
    unpause: 'resume',
    unpauseCreative: 'resume creative',
    unpauseCreatives: 'resume creatives',
    unpauseLineItem: 'resume line item',
    unpublish: 'unpublish',
    unpublishPackage: 'unpublish deal',
    unpublishPackages: 'unpublish deals',
    update: 'update',
    updateLineItem: 'update line item',
    upload: 'upload',
    uploadAScreenPhoto: 'upload a screen photo',
    uploadCSV: 'upload CSV file',
    uploadCreativeFiles: 'upload creative files',
    uploadFile: 'upload a file',
    uploadLogo: 'upload logo',
    uploadPhoto: 'Upload photo',
    uploadScreensFile: 'Upload screens file',
    uploadSitesFile: 'Upload sites file',
    uploadSpreadsheet: 'Upload spreadsheet',
    verify: 'Verify',
    verifyEmail: 'verify email',
    viewAuditTrail: 'view audit trail',
    viewSummary: 'view summary',
    yes: 'yes'
  },
  adverbs: {
    ago: 'ago',
    from: 'from',
    no: 'no',
    through: 'through',
    to: 'to',
    until: 'until',
    yes: 'yes'
  },
  conjuctions: {
    and: 'and',
    anyOf: 'any of',
    in: 'in',
    noneOf: 'none of',
    not: 'not',
    or: 'or'
  },
  durations: {
    overall: 'overall duration',
    weekly: 'weekly'
  },
  errors: {
    e_00bbde82_995f_4cbb_b487_03e2650018ee: 'You cannot reuse a previously used password.',
    e_1e210471_980c_4f95_84c9_ba792d55a786: 'There is already a file with these dimensions and format within this creative. A Creative is meant to bring together multiple size / format variations of the same overall design. To upload a different design, create a new Creative for it.',
    e_1f3e6bdd_c6ac_409f_9f8e_af2e692c40ab: 'The creative has been previously approved. It cannot be deleted, but it can be retired.',
    e_27e4df99_3125_4f6a_aa1c_4803ad930fba: 'Reusing an old password is not permitted.',
    e_4b68b4c5_2c81_4db2_930c_8b9763d9f7e3: 'This campaign already has a line item with this name.',
    e_56473b92_c9be_4bb4_8e5c_eee586d708f3: 'One of the selected media owners (Ströer) cannot be booked together with other media owners in the same line item.',
    e_74ad12c1_ca0c_452b_a2bd_0961410bd395: 'The campaign has one or more line items.',
    e_91fbadf0_e9eb_45be_a722_603148e5015f: 'The archive does not have an index.html file at the root of the archived folder',
    e_beabbb03_5042_448b_9237_e225e6584a47: 'Package value error',
    'e_c62bf378-693c-4391-b80f-002109313867': 'Invalid SSP domain.',
    e_c8e4afdf_7c4c_434e_9eb8_56275e125e8c: 'The line item cannot be updated because it already started running.',
    e_ef3656db_2b7d_4fc5_9946_4dfdde2bd4bc: 'A report cannot have more than 10 delivery emails. A mailing list can be used to reach additional people.',
    e_fe9d26d4_86f1_46f9_8392_0520387f1556: 'An advertiser with the same name already exists.'
  },
  messages: {
    aCampaignBudgetCapCanOnlyBeSetIfAllLineItemsHaveABudgetGoal: 'A campaign budget cap can only be set if all line items deliver on budget.',
    aCreativeNameCannotEmpty: 'A creative name cannot be empty.',
    accessDenied: 'Access denied',
    accessDeniedDescription: 'Sorry, you don\'t have access to the requested resource.',
    accountAlreadyExists: 'An account with the same name already exists.',
    activeScreens: 'active screens',
    actualPlaysPerHourVsTargetedPlaysPerHour: 'actual plays per hour / targeted plays per hour',
    adDurationFromUnit: 'Use the screen\'s ad duration',
    adDurationOverride: 'Override the screen\'s ad duration',
    adDurationTooltip: 'Enabling Fixed Ad duration will override Screen’s maximum ad duration',
    adRequestPerHour: 'Ad request per hour',
    adRequestedInTheLastHour: 'ad requested in the last hour',
    adServerGuaranteed: 'Ad server guaranteed',
    adServerNonGuaranteed: 'Ad server non-guaranteed',
    addFilters: 'add filters',
    addSSPAndDealIDs: 'add SSP and Deal IDs',
    addToInvite: 'Add to invite',
    additionalLocations: 'additional locations',
    additionalTargetingCriteria: 'additional targeting criteria',
    advertiserDomainShouldNotStartWithHttpOrWww: 'The advertiser domain should not start with "http://", "https://" or "www.".',
    afterDate: 'after {0}',
    ageGender: 'age & gender',
    ageGenderIncome: 'Age / Gender / Income',
    alLocations: 'All locations',
    allAgeGroups: 'All age groups',
    allAudiences: 'All audiences',
    allCreativeFormats: 'All creative formats',
    allDemographics: 'All demographics',
    allEligibleBuyers: 'All eligible buyers',
    allGenders: 'All genders',
    allGood: 'all good',
    allHours: 'All hours',
    allHoursOfTheDayAllWeek: 'All hours of the day, all week.',
    allInventory: 'all inventory',
    allLineItemsAlreadyChosen: 'All possible line items have already been linked',
    allLocations: 'All locations',
    allNetworks: 'All networks',
    allRecommendedCreativeSizesHaveBeenUploaded: 'All recommended creative sizes have been uploaded.',
    allSSPs: 'all SSPs',
    allSites: 'All sites',
    allSources: 'all sources',
    allTags: 'All tags',
    allUnitsHaveAudienceData: 'All screens have audience data.',
    allXItemsMatchingThisSearchAreSelected: 'All {0} items matching this search are selected.',
    allXItemsOnThisPareAreSelected: 'All {0} items on this page are selected.',
    allowAudio: 'allow audio-only files',
    allowAudioOnlyFiles: 'Allow audio-only files',
    allowBuyerToChoose: 'Allow buyer to choose',
    allowBuyerToChooseAdDuration: 'Allow buyer to choose ad duration',
    allowBuyerToChooseDayparts: 'Allow buyer to choose dayparts',
    allowBuyerToChooseDemographics: 'Allow buyer to choose demographics',
    allowBuyerToChooseImpressionsAndBudget: 'Allow buyer to choose impressions / budget',
    allowBuyerToChooseLocations: 'Allow buyer to choose locations',
    allowBuyerToChooseMinSecondsBetweenPlays: 'Allow buyer to choose minimum seconds between plays',
    allowBuyerToChooseNetworks: 'Allow buyer to choose networks',
    allowBuyerToChooseNumberOfDays: 'Allow buyer to choose number of days',
    allowBuyersToChooseLocations: 'allow buyers to choose markets, sites, cities and regions',
    allowBuyersToChooseNetworks: 'allow buyers to choose networks',
    allowBuyersToChooseScreens: 'allow buyers to choose screens',
    allowBuyersToChooseVenueTypes: 'allow buyers to choose venue types',
    allowHtml: 'allow HTML',
    allowImage: 'Allow Image',
    allowImages: 'allow images',
    allowPlaybackOfAdsOfDifferentDurations: 'allow playback of ads of different durations',
    allowToOverrideSpotLength: 'Allow to override spot length',
    allowVideo: 'Allow Video',
    allowVideos: 'allow videos',
    allowViewerToToggleLayerVisibility: 'allow viewer to toggle layer visibility',
    allowZip: 'allow zip',
    andInsideOf: 'and inside of',
    anyAgeGroups: 'All age groups',
    anyCountriesRegionsCitiesSites: 'Any countries / regions / cities / sites',
    anyGenders: 'All genders',
    anyMediaTypes: 'All media types',
    anyNetworks: 'All networks',
    anyOf: 'any of',
    appliesTo: 'applies to',
    applyChanges: 'Apply changes',
    applyRadiusToAllGeofences: 'apply radius to all geofences',
    approvalsAndRejections: 'approvals & rejections',
    approveCreativesForSpecificNetworksDescription: 'Choose the networks you would like to approve the selected creative(s) for:',
    approvedOn: 'Approved on',
    approvedOrRejectedBy: 'Approved / Rejected by',
    areImpressionsFixed: 'Are impressions fixed?',
    atLeastOneCreativeFileCloseEnoughToBePlayed: 'Close enough to be played',
    atLeastOneCreativeFilePerfectlyMatchesTheScreenSizes: 'Perfect match',
    audienceAvailableImpressions: 'Audience available impressions',
    audienceConcentrationLevelDefaultDescription: 'Higher than average population around selected screens (higher than an index of 100)',
    audienceConcentrationRatio: 'audience concentration ratio',
    audienceConcentrationRatioDescription: 'You can choose to play this line item when your concentration is at least: market average (1), below market average (between 0.02 and 0.99) or above market average (>1). For example, a ratio of 0.50 will prevent the line item to run if the observed concentration is 50% below market average whereas a ratio of 1.50 will prevent the line item to run if the observed concentration is not at least 50% above market average.',
    audienceConcentrationThreshold: 'audience concentration threshold',
    audienceFileSavedSuccessfully: 'Audience file saved successfully',
    audienceImpressionCapacity: 'audience impression capacity',
    audienceImpressions: 'audience impressions',
    audienceLogicEmptyGroup: 'Please add rules to your group',
    audienceLogicEmptyRules: 'Please add rules to your custom audience',
    audienceLogicExpressionEmptyStateDescription: 'Adding a group will also add a rule inside it.',
    audienceLogicExpressionEmptyStateTitle: 'Start by adding a rule or a group',
    audienceLogicNotYetSubmittedDescription: 'This custom audience will be reviewed once a line item gets submitted.',
    audienceLogicSavedSuccessfully: 'Custom audience saved successfully.',
    audienceStats: 'audience stats',
    audienceTargetingIsIgnoredForCompanionAds: 'Audience targeting is ignored for secondary companion ads.',
    audio: 'audio',
    audioToolTip: 'This feature is used to play audio only creatives. Currently supported formats are .mp3, .wav, .ogg and .flac.',
    auditTrailAddedEntity: 'Added',
    auditTrailCreatedEntity: 'Created',
    auditTrailFor: 'Audit trail for',
    auditTrailModifiedEntity: 'Modified',
    auditTrailRemovedEntity: 'Removed',
    auditTrailTimeZoneInfo: 'All times are in your local time zone.',
    automatedSystem: 'Automated System',
    automaticallyApproveExternalCreativeForAllScreenSizes: 'Automatically approve for all screen sizes',
    automaticallyCreatedFromTheCreativeEditScreen: 'Automatically created from the creative edit screen.',
    automaticallyCreatedFromTheLineItemEditScreen: 'Automatically created from the line item edit screen.',
    autopilot: 'autopilot',
    availableForAdServer: 'available for ad server',
    availableForDeals: 'available for deals',
    availableForOpenExchange: 'available for open exchange',
    availableForStoreFront: 'available for store front',
    availableFrom: 'available from',
    availableSecondsIsMissing: 'The column \'available_seconds\' is missing.',
    availableTo: 'available to',
    availsInfo: 'Head out to our [documentation] to find out how to manage and update your avails',
    availsURLDocument: 'https://support.hivestack.com/support/solutions/articles/67000701500-avails-publishers-only-',
    averageActualCadence: 'average actual cadence',
    averageActualCadenceTooltip: 'Cadence of play confirmations',
    averageAudienceConcentration: 'average audience concentration',
    averageDailyImpressions: 'avg daily impressions',
    averageDailySpend: 'avg daily spend',
    averagePaidCPM: 'Avg. Paid CPM',
    averageScheduledCadence: 'average scheduled cadence',
    averageScheduledCadenceTooltip: 'Cadence of ad responses',
    averageTimeBetweenPlays: 'average time between plays',
    backToCategories: 'back to categories',
    backToLineItem: 'back to line item',
    backToUnitResults: 'back to results',
    basedOnAdDurationOfX: 'Based on ad duration of {0}s.',
    basedOnAnAdDurationOf: 'Based on an ad duration of',
    basedOnIndividualScreenAdDuration: 'Based on individual screen ad durations.',
    basedOnScreen: 'based on screen',
    basedOnScreensAdDuration: 'Based on the screen\'s ad duration',
    beAwareThatTheseChangesCouldPotentiallyAffectAdDeliveryForYourCustomers: 'Be aware that these changes could potentially affect ad delivery for your customers.',
    beforeDate: 'before {0}',
    beta: 'beta',
    between: 'between',
    betweenStartDateAndEndDate: 'between {0} and {1}',
    bidStats: 'Bid stats',
    bidStrategy: 'bid strategy',
    bidWinRate: 'bid win %',
    bidderConfiguration: 'bidder configuration',
    biddingActivity: 'bidding activity',
    biddingAgent: 'Bidding Agent',
    blockUniqueAdvertisers: 'blocked advertisers',
    bothMinAndMaxAdDurationsMustBeSpecified: 'Both minimum and maximum ad durations must be specified.',
    bottomMargin: 'bottom margin',
    brandShopper: 'This category has been created based on the high intent of users in terms of their visits to Brand outlets in the real world.',
    bulkCreation: 'Bulk creation',
    bulkEditLineItems: 'bulk edit line items',
    bulkEditUnits: 'bulk edit screens',
    bulkLineItemCreationSystem: 'Bulk line item creation system',
    bulkLineItemsEditionValidationError_audienceFileDoesNotExist: 'The audience file ID does not exist.',
    bulkLineItemsEditionValidationError_cannotEnterImpressionsSinceTheCampaignIsDeliveringOnAdSpend: 'Cannot enter "Impressions" since the campaign is delivering on ad spend',
    bulkLineItemsEditionValidationError_cannotEnterTotalAmountSinceTheCampaignIsDeliveringOnImpressions: 'Cannot enter "Total Amount" since the campaign is delivering on impressions',
    bulkLineItemsEditionValidationError_creativeDoesNotExist: 'One or more creatives do not exist.',
    bulkLineItemsEditionValidationError_dealDemographicTargetingCannotBeModified: 'You cannot specify an audience file since the deal does not allow it.',
    bulkLineItemsEditionValidationError_dealDoesNotExist: 'The deal could not be found.',
    bulkLineItemsEditionValidationError_doesNotMatchPossibleValues: '"{0}" does not match any of the following options: {1}.',
    bulkLineItemsEditionValidationError_endDateMustBeWithinAllowedDealDates: 'The end date is outside the deal\'s valid date range.',
    bulkLineItemsEditionValidationError_impressionsCanOnlyBeInfiniteIfCampaignManagedBudgetIsEnabled: '"Impressions" can only be unlimited if campaign managed budget is enabled',
    bulkLineItemsEditionValidationError_impressionsDoNotMatchDealRestrictions: '"Impressions" does not match the deal restrictions.',
    bulkLineItemsEditionValidationError_impressionsOrTotalAmountIsRequired: 'Either "impressions" or "total amount" is required.',
    bulkLineItemsEditionValidationError_invalidDaypartRange: 'Invalid daypart range.',
    bulkLineItemsEditionValidationError_invalidSSP: 'Invalid SSP, possible values are: {0}.',
    bulkLineItemsEditionValidationError_lineItemGoalShouldBeImpressionsInOrderToMatchDealRestrictions: 'The deal requires impressions, "Total amount" should be empty.',
    bulkLineItemsEditionValidationError_lineItemGoalShouldBeTotalAmountInOrderToMatchDealRestrictions: 'The deal requires a total amount, "Impressions" should be empty.',
    bulkLineItemsEditionValidationError_mustBeANumericalValueOrInfinite: '"{0}" must be a numerical value or unlimited',
    bulkLineItemsEditionValidationError_noEditingWhenCreatingNewCampaign: 'You cannot edit an existing line item when creating a new campaign.',
    bulkLineItemsEditionValidationError_noMatchingLineItemInCampaign: 'Line item does not exist in the current campaign.',
    bulkLineItemsEditionValidationError_onlyOneHivestackDealIsAllowed: 'Can only have one Hivestack SSP deal per line item',
    bulkLineItemsEditionValidationError_priorityMustBeBetween1And9: 'Priority must be a numerical value between 1 and 9.',
    bulkLineItemsEditionValidationError_requiredColumn: '"{0}" is required.',
    bulkLineItemsEditionValidationError_startDateCannotBeBeforeToday: 'The start date cannot be before today',
    bulkLineItemsEditionValidationError_startDateMusBeBeforeEndDate: 'The line item start date must be before the end date.',
    bulkLineItemsEditionValidationError_startDateMustBeWithinAllowedDealDates: 'The start date is outside the deal\'s valid date range.',
    bulkLineItemsEditionValidationError_sumOfAllLineItemTotalAmountsIsExceedingTheCampaignBudgetCap: 'The sum of all line item "Total amount" values is exceeding the campaign budget cap.',
    bulkLineItemsEditionValidationError_totalAmountCanOnlyBeInfiniteIfCampaignManagedBudgetIsEnabled: '"Total Amount" can only be unlimited if campaign managed budget is enabled',
    bulkLineItemsEditionValidationError_totalAmountDoesNotMatchDealRestrictions: '"Total amount" does not match the deal restrictions.',
    bulkLineItemsEditionValidationError_totalAmountIsRequiredSinceTheCampaignHasABudgetCap: '"Total amount" is required since the campaign has a budget cap.',
    bulkLineItemsEditionValidationError_typeMismatch: '"{0}" is not valid.',
    bulkLineItemsEditionValidationError_youCannotChangeTheDealAfterTheLineItemHasBeenCreated: 'You cannot change the deal after the line item has been created.',
    bulkLineItemsEditionValidationError_youCannotSupplyBothImpressionsAndTotalAmount: 'You cannot supply both "impressions" and "total amount", only one is permitted.',
    bulkLineItemsEditionValidationError_youMustSupplyBothTheDealIDAndSPP: 'You must supply both the deal ID and SSP.',
    buyFromDeal: 'Buy from deal',
    buyFromDeals: 'buy from deals',
    buyingStrategy: 'buying strategy',
    buyingStrategyFixedCPM: 'fixed CPM',
    buyingStrategyOptimizedCPM: 'optimized',
    buyingStrategyTrueBid: 'TruBid™',
    bySearch: 'by search',
    cadenceAndHouseAdsPurchasTypesCannotHaveAPacingStrategy: 'Cadence and House ads purchase types cannot have a Pacing Strategy. Default value should be Optimized.',
    cadenceBuyCheckAvailsDescription: 'Checking availability will help you define the cadence according to your impression goal.',
    cadenceBuyCheckAvailsRequirements: 'Start date, end date and impressions goal are required to check availability.',
    cadenceExceedsMaximumCadenceAvailable: 'Your cadence exceeds the maximum cadence available.',
    cadenceLackAvailabilities: 'Lack of availabilities for cadence',
    cadenceOutOfDate: 'Cadence out of date',
    cadenceOutdated: 'Cadence outdated',
    cadenceSmoothCatchupTooltip: 'Smooth Catchup will ensure that plays that cannot be delivered for a given screen will be played on other screens. This ensures that average cadence remains as close to possible to the objective even if the cadence for a given screen dips for any reason.',
    cadenceWithUnreservedImpressions: 'Cadence with unreserved impressions',
    callForEvery: 'Call for every',
    campaignBudgetCapMustBeGreaterOfEqualToTheSumOfAllLineItemBudgets: 'Campaign budget cap must be greater or equal to the sum of all line item budgets.',
    campaignDuplicationSuccessful: 'Campaign has been successfully duplicated.',
    campaignManaged: 'campaign managed',
    campaignManagedBudget: 'campaign managed budget',
    campaignMarginHasBeenSetWhichOverridesLineItemMargin: 'Campaign margin has been set which overrides line item margin.',
    campaignMarginOverridesLineItemMargin: 'Campaign margin has been set which overrides changes to line item margin. Disable the campaign margin to set line item margin.',
    campaignPacing: 'campaign pacing',
    campaignPriorityOverridesLineItemPriority: 'Campaign priority has been set which overrides changes to line item priority. Disable the campaign priority to set line item priorities.',
    campaignSavedSuccessfully: 'Campaign saved successfully.',
    cannabisDispensaries: 'Cannabis dispensaries',
    cannotBuyPGDealsWithOtherDeals: 'Programmatic guaranteed deals cannot be bought with other deals',
    cannotDeleteCampaignThatHasBegun: 'Cannot delete a campaign that has already begun',
    cannotDeleteCampaignWithLineItemThatHasBegun: 'Cannot delete a campaign with line item that has already begun',
    cannotDeleteLineItemThatHasBegun: 'One or more line items already started and cannot be deleted.',
    cannotDeleteMobileLineItemThatHasBeenSubmitted: 'Cannot delete mobile line item(s) that have been submitted.',
    cannotEditAudienceLogic: 'Cannot edit custom audience',
    cannotEditAudienceLogicDescription: 'You cannot modify a custom audience which has already been assigned to a line item.',
    cannotEditLineItem: 'Cannot edit line item',
    cannotEditLineItemDemandSideDescription: 'You cannot edit a line item that has already ended.',
    cannotMaintainCadenceBody: 'Some of the targeted screens cannot maintain this cadence. Historical data shows that we cannot maintain a cadence greater than {cadence} plays per hour.',
    cannotMaintainCadenceTitle: 'Cannot maintain the cadence',
    cannotPauseLineItem: 'Cannot pause line item',
    cannotPauseLineItemDemandSideDescription: 'Only line items with a \'Non-guaranteed\' purchase type can be paused.',
    cannotPauseLineItemSupplySideDescription: 'Only line items with a \'Guaranteed\' purchase type can be paused.',
    cannotPublishLineItem: 'Cannot publish line item',
    cannotPublishLineItemDescription: 'Some warnings are preventing the line item to be published.',
    cannotSubmitLineItemForApproval: 'Cannot submit line item for approval',
    cannotSubmitLineItemForApprovalDescription: 'Some warnings are preventing the line item to be sent for approval.',
    categoryFrequencyCap: 'category frequency cap',
    categoryNameMustNotContainUppercaseLetters: 'Category name must not contain uppercase letters',
    celsius: 'celsius',
    changeAudience: 'Change audience',
    changeColumnOrderAndVisibility: 'Change column order and visibility',
    changeIconSizeBasedOnZoomLevel: 'change icon size based on zoom level',
    changePassword: 'Enter your new password',
    changesBeingApplied: 'Changes being applied...',
    changesComparedToPreviousPeriod: 'Changes compared to previous period.',
    changesHaveBeenApplied: 'Changes have been applied',
    chartGroupActionChartType: 'Chart types',
    chartGroupActionChartTypeArea: 'Area',
    chartGroupActionChartTypeBar: 'Bar',
    chartGroupActionChartTypeCandlestick: 'Candlestick',
    chartGroupActionChartTypeLine: 'Line',
    chartGroupActionChartTypePie: 'Pie',
    chartGroupActionDownload: 'Download as',
    chartGroupActionDownloadCsv: 'CSV',
    chartGroupActionDownloadExcel: 'Excel',
    chartGroupActionDownloadImage: 'Image',
    chartGroupActionInterval: 'Interval',
    chartGroupActionIntervalDay: 'Day',
    chartGroupActionIntervalHour: 'Hour',
    chartGroupActionIntervalMonth: 'Month',
    chartGroupActionIntervalYear: 'Year',
    chartGroupActionReset: 'Reset to default parameters',
    checkAvailsIsNotAvailable: 'Sorry, the checking of availability is not currently enabled.',
    checkLatestGuaranteedAvails: 'We recommend to check avails for the latest configuration of your guaranteed {0} before saving.',
    checkingAvailablitiesThisCouldTakeMoreThanAMinute: 'Checking availablities, this could take more than a minute',
    checkingAvails: 'Checking availabilities, this could take more than a minute.',
    checkingCustomCadenceIsSyncedWithYourGoalCouldTakeMoreThanAMinute: 'We are checking the custom cadence is synced with your goal, this could take more than a minute.',
    chooseAFileFormat: 'choose a file format',
    chooseAnOrganization: 'Choose an organization',
    chooseGenericGeofences: 'Search for generic geofences',
    chooseIABCAtegories: 'Choose IAB categories',
    chooseOnePurchaseType: 'Choose one',
    chooseOperation: 'Choose operation',
    clearSelection: 'Clear selection',
    clickHereToGetOurKnowledgeBase: 'Click here to get our knowledge base',
    clickThisLinkToSeeTheList: 'Click this link to see the list.',
    clickToComputeCadence: 'Click to compute cadence',
    clickToCopyTheIDToTheClipboard: 'Click to copy the ID to the clipboard.',
    clickToCopyToTheClipboard: 'Click to copy to the clipboard.',
    clickToRemove: 'Click to remove',
    clickToUploadCustomIcon: 'Click to upload a custom icon',
    clickToUploadLogo: 'Click to upload a logo',
    comingSoon: 'coming soon…',
    compareToPreviousPeriod: 'Compare to previous period',
    concentrationIndex: 'concentration index',
    concentrationPercentage: 'concentration %',
    confirm: 'Confirm',
    confirmApproveCreativeFiles: 'Are you sure you want to approve the selected creatives files?',
    confirmApproveCreativePrefetchSizes: 'Are you sure you want to approve the selected screen sizes?',
    confirmApproveCreatives: 'Are you sure you want to approve the selected creatives?',
    confirmApproveDeals: 'Are you sure you want to approve the selected deals?',
    confirmApproveLineItem: 'Are you sure you want to approve the selected line item?',
    confirmApproveLineItems: 'Are you sure you want to approve the selected line items?',
    confirmApprovedLineItem: 'This line item has already been approved, are you sure you want to edit it?',
    confirmArchiveLineItem: 'Once you archive a line item, it cannot be unarchived or reactivated. Are you sure you want to archive this line item?',
    confirmArchiveLineItems: 'Once you archive a line item, it cannot be unarchived or reactivated. Are you sure you want to archive this line item(s)?',
    confirmChanges: 'Confirm changes',
    confirmConvertPackageToExternalDspLineitem: 'Are you sure you want to create a line item from the deal?',
    confirmDeleteAudienceFiles: 'Are you sure you want to approve the selected audience files?',
    confirmDeleteAudienceLogic: 'Are you sure you want to delete the selected custom audience?',
    confirmDeleteAudienceLogics: 'Are you sure you want to delete the selected custom audience(s)?',
    confirmDeleteAudienceRules: 'Are you sure you want to delete the selected custom audience(s)?',
    confirmDeleteCampaign: 'Are you sure you want to delete the campaign?',
    confirmDeleteCampaigns: 'Are you sure you want to delete the selected campaign(s)?',
    confirmDeleteCreative: 'Are you sure you want to delete the selected creative?',
    confirmDeleteCreativeFiles: 'Are you sure you want to delete the selected creative file(s)?',
    confirmDeleteCreatives: 'Are you sure you want to delete the selected creative(s)?',
    confirmDeleteCustomEvent: 'Are you sure you want to delete the custom event?',
    confirmDeleteCustomEvents: 'Are you sure you want to delete the selected custom event(s)?',
    confirmDeleteGeofence: 'Are you sure you want to delete the selected geofence?',
    confirmDeleteGeofenceGroup: 'Are you sure you want to delete the selected geofence group?',
    confirmDeleteGeofenceGroups: 'Are you sure you want to delete the selected geofence group(s)?',
    confirmDeleteGeofences: 'Are you sure you want to delete the selected geofence(s)?',
    confirmDeleteJourneyAnalysis: 'Are you sure you want to approve the selected journeys?',
    confirmDeleteLiftDashboard: 'Are you sure you want to delete the selected lift dashboard(s)?',
    confirmDeleteLiftDashboards: 'Are you sure you want to delete the lift analyses?',
    confirmDeleteLineItem: 'Are you sure you want to permanently delete?',
    confirmDeleteLineItems: 'Are you sure you want to delete the selected line item(s)?',
    confirmDeleteMargins: 'Are you sure you want to delete the selected margin(s)?',
    confirmDeleteMobileLineItems: 'Are you sure you want to delete the selected mobile line item(s)?',
    confirmDeleteOrganizationCustomField: 'Are you sure you want to delete the selected custom field?',
    confirmDeleteOrganizationCustomFields: 'Are you sure you want to delete the selected custom fields?',
    confirmDeletePackages: 'Are you sure you want to delete the selected deals?',
    confirmDeletePreSaleHeatmap: 'Are you sure you want to delete the selected proposal heatmap?',
    confirmDeletePreSaleHeatmaps: 'Are you sure you want to delete the selected proposal heatmap(s)?',
    confirmDeleteReportDefinitions: 'Are you sure you want to delete the selected report definition(s)?',
    confirmDeleteReportExecution: 'Are you sure you want to delete the selected report execution?',
    confirmDeleteReportExecutions: 'Are you sure you want to delete the selected report execution(s)?',
    confirmDeleteSite: 'Are you sure you want to delete the selected site?',
    confirmDeleteSites: 'Are you sure you want to delete the selected site(s)?',
    confirmDeleteSsp: 'Are you sure you want to delete the selected SSP(s)?',
    confirmDeleteUnit: 'Are you sure you want to delete the selected screen?',
    confirmDeleteUnits: 'Are you sure you want to delete the selected screens?',
    confirmDeleteUser: 'Are you sure you want to delete the selected user(s)?',
    confirmDiscardChanges: 'Are you sure you want to discard your changes?',
    confirmDiscardNewEntity: 'Are you sure you want to discard the item being created?',
    confirmEditNonDraftLineItem: 'This line item will go back to the draft state if edited. Are you sure you want to edit it?',
    confirmEditNonDraftPackage: 'This deal will go back to the draft state if edited. Are you sure you want to edit it?',
    confirmLosingChangesDescription: 'You have pending changes, what would you like to do?',
    confirmLosingChangesTitle: 'You\'re about to lose your changes',
    confirmPauseCreative: 'Are you sure you want to pause this creative?',
    confirmPauseCreatives: 'Are you sure you want to pause creative(s)?',
    confirmPauseLineItem: 'Are you sure you want to pause this line item? There will be a delay of up to 20 minutes before the line item is actually stopped.',
    confirmPauseLineItems: 'Are you sure you want to pause line item(s)? There will be a delay of up to 20 minutes before the line item(s) is actually stopped.',
    confirmPlayLineItems: 'Are you sure you want to unpause this line item(s)? There will be a delay of up to 20 minutes before the line item(s) resumes execution.',
    confirmPublishLineItems: 'Are you sure you want to publish this line item(s)?',
    confirmPublishPackage: 'are you sure you want to publish the deal?',
    confirmPublishPackages: 'are you sure you want to publish the selected deals?',
    confirmRejectCreativeFiles: 'Are you sure you want to reject the selected creative files?',
    confirmRejectCreativePrefetchSizes: 'Are you sure you want to reject the selected screen sizes?',
    confirmRejectCreatives: 'Are you sure you want to reject the selected creatives?',
    confirmRejectDeals: 'Are you sure you want to reject the selected deals?',
    confirmRejectLineItem: 'Are you sure you want to reject the selected line item?',
    confirmRejectLineItems: 'Are you sure you want to reject the selected line items?',
    confirmResendVerificationEmail: 'Are you sure you want to resend verification emails to the selected users?',
    confirmRetireCreative: 'Are you sure you want to retire this creative?',
    confirmRetirePackage: 'are you sure you want to retire the deal?',
    confirmRetirePackages: 'are you sure you want to retire the selected deals?',
    confirmSaveChanges: 'Are you sure you want to save your changes?',
    confirmSaveChangesForNetwork: 'you updated the units in this network. Units can only be in one network at the time. As such, your changes will result in your units being removed from their previously assigned network and reassigned in this one.<br/>This can have an impact on your creative approval when creatives are approved per network as well for as for your Line Items and Deals (IF BELOW IS CONFIRMED)',
    confirmSaveNewEntity: 'Are you sure you want to save this new item?',
    confirmSaveNewEntityForNetwork: 'you updated the units in this network. Units can only be in one network at the time. As such, your changes will result in your units being removed from their previously assigned network and reassigned in this one. This can have an impact on your creative approval when creatives are approved per network as well for as for your Line Items and Deals (IF BELOW IS CONFIRMED)',
    confirmSendToDraft: 'Are you sure you want to send this line item back to draft mode?',
    confirmSubmitCreativeForApproval: 'Are you sure you want to submit this creative for approval?',
    confirmSubmitLineItemForApproval: 'Are you sure you want to submit this line item for approval?',
    confirmSubmitLineItems: 'Are you sure you want to submit the selected line item(s) for approval?',
    confirmUnlinkCreative: 'Are you sure you want to unlink the selected creative?',
    confirmUnlinkCreatives: 'Are you sure you want to unlink the selected creative(s)?',
    confirmUnlinkLineItem: 'Are you sure you want to unlink this line item?',
    confirmUnlinkLineItems: 'Are you sure you want to unlink the selected line item(s)?',
    confirmUnlinkMobileLineItems: 'Are you sure you want to unlink the selected mobile line item(s)?',
    confirmUnpauseCreative: 'Are you sure you want to unpause this creative?',
    confirmUnpauseCreatives: 'Are you sure you want to unpause creative(s)?',
    confirmUnpauseLineItem: 'Are you sure you want to unpause this line item? There will be a delay of up to 20 minutes before the line item resumes execution.',
    confirmUnpublishPackage: 'are you sure you want to unpublish the deal?',
    confirmUnpublishPackages: 'are you sure you want to unpublish the selected deals?',
    containsText: 'contains text',
    convertPlanWarningMessage: 'Creating a campaign requires an advertiser and an account. Please update your plan.',
    convertPlanWarningTitle: 'Missing mandatory fields',
    copiedDealIdToClipboard: 'The deal ID has been copied to the clipboard.',
    copiedGeofencesToClipboard: 'Copied geofences to clipboard.',
    copiedIdToClipboard: 'The ID has been copied to the clipboard.',
    copiedTargetingLogicToClipboard: 'The targeting logic has been copied to the clipboard.',
    copyDealID: 'Copy Deal ID',
    copyGeofences: 'Copy geofences',
    copyID: 'Copy ID',
    copyOf: 'Copy of',
    copyOfX: 'Copy of {0}',
    copyTargetingLogic: 'Copy targeting logic',
    copyTargetingSuccessful: 'The copy of the selected targeting was successful.',
    correctionMultiplier: 'correction multiplier',
    cpmMustBeSpecifiedInBudgetMode: 'You must specify a CPM when you are targeting a budget.',
    createExecutionSchedule: 'create execution schedule',
    createLineItemFromDealBody: 'Create a new line item to buy onto this deal. Associate this to an existing campaign, or create a brand new one.',
    createLineItemFromDealTitle: 'One more step to start buying on {deal_name}.',
    createLineItemFromMapSelection: 'New line item from map',
    createLineItemFromMapSelectionDescription: 'Your map selections have been applied to this new line item, just fill the missing details.',
    createNewCampaign: 'Create a new campaign?',
    createdBy: 'created by',
    createdByMe: 'Created by me',
    createdOn: 'created on',
    createdOnUTC: 'created on - UTC',
    creativeAdvertiserCannotBeEmpty: 'Creatives advertiser cannot be empty.',
    creativeBackToDraftWarning: 'Saving this creative will set its status back to Draft. You will have to submit it for approval again.',
    creativeCanBeMobileOrFallbackNotBoth: 'Creative can be for mobile or a fallback, not both.',
    creativeDeletedSuccessfully: 'Creative deleted successfully',
    creativeDraftNotSubmittedForApproval: 'This creative is in a "Draft" state and needs to be submitted for approval.',
    creativeFileNameTooBig: 'creative file name too long',
    creativeFileNameTooBigDescription: 'Upload failed, creative file name should be less than 100 characters',
    creativeFileSavedSuccessfully: 'Creative file saved successfully.',
    creativeFileTooBig: 'file too big',
    creativeFileTooBigDescription: 'Upload failed, the maximum file size is 500MB.',
    creativeFileUploadFailed: 'File upload failed',
    creativeGoodDescription: 'None of the creative files that are linked to this line item perfectly match the following screen sizes; however, at least one of them is close enough to be played.',
    creativeHasNotPlayedInTheLast12Hours: 'The creative has not played in the last 12 hours.',
    creativeHasNotPlayedInTheLast24Hours: 'The creative has not played in the last 24 hours.',
    creativeIABCategoriesCannotBeEmpty: 'Creatives IAB categories cannot be empty.',
    creativeIsRunningFine: 'The creative is running fine.',
    creativeLanguagesCannotBeEmpty: 'Creatives languages cannot be empty.',
    creativeLanguagesForItemIsEmpty: 'Creative languages for {0} is empty.',
    creativeMacrosInfo: 'Type in the name of the macros using the format: [UNITID]. You can also click on, or drag and drop the creative macros under the input field to include them in the URL',
    creativeMissingDescription: 'There are no creative files linked to this line item that match the following screen sizes.',
    creativeNamesCannotBeEmpty: 'Creatives names cannot be empty.',
    creativePausedSuccessfully: 'Creative paused successfully',
    creativePerfectDescription: 'At least one of the creatives files that are linked to this line item perfectly match the following screen sizes.',
    creativePropertyKeysCannotBeEmpty: 'Creative property keys cannot be empty.',
    creativePropertyValuesCannotBeEmpty: 'Creative property values cannot be empty.',
    creativeRunStateUpdatedSuccessfully: 'Creative run state updated successfully.',
    creativeSavedSuccessfully: 'Creative saved successfully.',
    creativeSizeUploadRecommendations: 'Creative size upload recommendations',
    creativeStatusUpdatedSuccessfully: 'Creative status updated successfully.',
    creativeUnpausedSuccessfully: 'Creative unpaused successfully',
    creativesBatchOperationFailed: 'Creative batch operation failed.',
    creativesDeletedSuccessfully: 'Creatives deleted successfully',
    creativesPausedSuccessfully: 'Creatives paused successfully',
    creativesRunStateUpdatedSuccessfully: 'Creatives run state updated successfully.',
    creativesStatusUpdatedSuccessfully: 'Creatives status updated successfully.',
    creativesUnpausedSuccessfully: 'Creatives unpaused successfully',
    currentDailyCap: 'current daily cap',
    custom: 'custom',
    customAudienceIsOutOfDate: 'This custom audience is using retired date segments. We suggest editing the custom audience to use the latest data.',
    customCadence: 'custom cadence',
    customEventInfo: 'Head out to our [documentation] to find out how to manage and update your events',
    customEventSavedSuccessfully: 'Custom event saved successfully.',
    customEventTargeting: 'custom event targeting',
    customEventURLDocument: 'https://docs.hivestack.com/reference/get-customevents',
    customGeofenceNameAndDescriptionCannotBeEmpty: 'The custom geofence name and description cannot be empty.',
    customSegmentIsOutOfDate: 'This segment has been retired since {0}.',
    dailyBudgetCap: 'daily spend cap',
    dailyCap: 'daily cap',
    dailyGoalCapWarningForCampaigns: 'The current daily cap will cause the campaign to underspend by at least {0}. Update the daily cap to {1} so that the total equals the campaign goal.',
    dailyGoalCapWarningForLineItems: 'The current daily cap will cause the line item to underspend by at least {0}. Update the daily cap to {1} so that the total equals the line item goal.',
    dailyImpressionsCap: 'daily impressions cap',
    dailyLift: 'Daily lift',
    dailySpendCap: 'daily spend cap',
    dailySpendPercentage: '% Daily spend Cap',
    dailyStats: 'daily stats',
    dataFullyUpdatedAsOf: 'Data fully updated as of',
    dataValidation: 'Data validation',
    dateFilterInRangeDescription: 'Filters using a relative range, "-3w 4d" to "3w 4d" means 3 weeks and 4 days ago until 3 weeks and 4 days from today. Possible times units are "w" for weeks, "d" for days, "m" for minutes and "s" for seconds.',
    datesShouldUseTheFollowingFormat: 'Dates should use the following format',
    datesVisibleToBuyers: 'dates visible to buyers',
    dayOfStartDate: 'day of the “starts on” date ({0})',
    dayOfTheMonth: 'day of the month',
    dealBuyersNoExternalDSPsAllowedOnBuyerDefinableDeals: 'No external buyers are allowed on buyer definable deals.',
    dealBuyersNoMixOfExternalAndInternalDSPs: 'External and internal DSP cannot be mixed. Either have one external DSP or multiple internal ones.',
    dealBuyersOnlyOneExternalDSPAllowed: 'Only one external DSP can be specified as a buyer.',
    dealCadenceGoalCannotBeReached: 'The deal’s cadence goal cannot be reached because of a lack of availabilities.',
    dealCadenceGoalReachedWithUnreservedImpressions: 'The deal’s cadence goal may only be reached with unreserved impressions combined with reserved impressions.',
    dealCheckAvailsNotAvailableBecauseNoGoalsHaveBeenSpecified: 'You need to specify a goal before you can check availability.',
    dealCheckAvailsNotAvailableBecauseStartDateIsInThePast: 'Check avails is not available for a deal who\'s start date is in the past. Please verify availability using the line item created from the deal.',
    dealRunPeriod: 'deal run period',
    dealVisibilityEndDateMustBeBeforeOrEqualToStartDate: 'The end date of the deal visibility period must be on or after the start date.',
    dealVisibilityEndDateMustBeBeforeOrEqualToTheDealEndDate: 'The end date of the deal visibility period must be on or before the deal end date.',
    dealVisibilityPeriod: 'deal visibility period',
    decidedOn: 'decided on',
    defaultAdDuration: 'Default ad duration',
    defaultFiltersSavedSuccessfully: 'Default filters saved successfully',
    defaultRadius: 'Default circle radius',
    defaultRadiusForPlacesWithoutPolygons: 'Default radius for places without polygons',
    deliverOn: 'deliver on',
    deliveryTypeNeedsToMatchCampaign: 'Delivery type needs to match campaign',
    descriptionIsMissing: 'the description column is missing.',
    destination: 'destination',
    devicesObservedInGeofences: 'devices observed in geofences',
    didNotRequestAnAdInTheLastHour: 'Did not request an ad in the last hour',
    directVsProgrammatic: 'Direct vs Programmatic',
    displayName: 'display name',
    domainIsNotValid: 'The domain name is not valid.',
    done: 'Done',
    downloadASpreadsheetOfYourLineItems: 'Download a spreadsheet of your line items. (Excel or CSV)',
    downloadATemplateBasedOnFilteringMethod: 'Download a template based on filtering method',
    downloadCSVReferences: 'Download CSV references',
    downloadCreativeFilesFromExternalAdServer: 'Download creative files from external ad server',
    downloadOneOfTheTwoTemplates: 'Download one of the two templates. (Excel or CSV)',
    downloadReportSuccessfully: 'Report downloaded successfully.',
    downloadTemplateCSVFile: 'Download CSV file template',
    downloadTemplateXLSFile: 'Download Excel template',
    downloadTemplateXLSXFile: 'Download Excel file template',
    downloadTheAvailsBreakdownByScreen: 'download the avails breakdown by screen',
    downloadTheAvailsBreakdownBySite: 'download the avails breakdown by site',
    dragAndDropImagesOnTheScreenToUploadCreatives: 'Drag and drop images, videos or zip files anywhere on the screen to upload creatives.',
    dropToUpload: 'drop to upload',
    dropYourExcelOrCsvFileHereOrBrowseYourComputer: 'Drop down your Excel or CSV file here, or&nbsp;<a>browse your computer</a>.',
    dspOrExchange: 'DSP / Exchange',
    duplicateCampaign: 'duplicate campaign',
    duplicateLineItems: 'duplicate line items',
    editUserOrganizationModalTitle: 'Edit user',
    efficiency: 'efficiency',
    emailVerificationLanding: 'One more step to verify your email',
    emailsSentSuccessfully: 'Emails sent successfully',
    empty: 'empty',
    enableCustomEventsMessageBody: 'Just click on the button below to enable them.',
    enableCustomEventsMessageTitle: 'Custom events are currently turned off',
    enableExecutionSchedule: 'enable execution schedule',
    enableExternalEventsMessageBody: 'Just click on the button below to enable them.',
    enableExternalEventsMessageTitle: 'External events are currently turned off',
    enableMargin: 'Enable margin',
    enableMaxBidCPM: 'enable max bid CPM',
    enableMinMaxBidCPM: 'enable min / max bid CPM',
    enableMobileRetargeting: 'enable mobile re-targeting',
    enableNetworkFrequencyCap: 'Per-network frequency cap',
    enableStrictIABCategoriesBlocking: 'strict categories blocking',
    endDateUTC: 'end date - UTC',
    endsOn: 'ends on',
    endsWith: 'ends with',
    enterKeywords: 'Enter keywords',
    enterNewPassword: 'Enter a new password:',
    estimatedDeliveryStats: 'Estimated delivery statistics',
    exactMatch: 'exact match',
    examplesBelow: 'Examples below',
    existingGeofences: 'existing geofences',
    exploreByCategory: 'explore by category',
    exploreBySegment: 'explore by segment',
    exportAsCSV: 'Export as CSV',
    exportAsExcel: 'Export as Excel',
    exportDate: 'Export date',
    exportingPlan: 'Exporting plan…',
    exportingPlanFailed: 'Exporting plan failed',
    exposedWalkins: 'Exposed Walk-ins',
    externalDSPBuyersOnly: 'External DSP buyers only',
    externalIDIsMissing: 'The column \'externalID\' is missing ',
    externalVASTLinking: 'External VAST linking',
    facingDirection: 'facing direction',
    fahrenheit: 'fahrenheit',
    failedSaveToHeaderBidderConfiguration: 'Failed to save header bidder configuration',
    failedToAddSSP: 'Failed to add new SSP',
    failedToApproveCreativeFiles: 'Failed to approve creative files.',
    failedToApproveLineItem: 'Failed to approve line item.',
    failedToApproveLineItems: 'Failed to approve line items.',
    failedToBulkUploadCreatives: 'Failed to bulk upload creatives.',
    failedToChangeLineItemsRunState: 'Failed to change line items run state.',
    failedToChangeLineItemsState: 'Failed to change line items state.',
    failedToConvertPlanToCampaign: 'Failed to convert plan to campaign.',
    failedToCreateAudienceLogic: 'Failed to create audience logic.',
    failedToCreateCampaign: 'Failed to create campaign.',
    failedToCreateCreative: 'Failed to create creative.',
    failedToCreateCreatives: 'Failed to create creatives.',
    failedToCreateCustomEvent: 'Failed to create custom event.',
    failedToCreateDemographic: 'Failed to create demographic.',
    failedToCreateExternalEvent: 'Failed to create external event.',
    failedToCreateJourneyAnalysis: 'Failed to create journey analysis.',
    failedToCreateLiftDashboard: 'Failed to create lift dashboard.',
    failedToCreateLineItems: 'Failed to create line items',
    failedToCreateMargins: 'Failed to create margins.',
    failedToCreateMobileLineItem: 'Failed to create mobile line item.',
    failedToCreateNetwork: 'Failed to create network.',
    failedToCreateNetworks: 'Failed to create network.',
    failedToCreateOrganizationCustomField: 'Failed to create organization custom field.',
    failedToCreateReportDefinition: 'Failed to create report definition',
    failedToCreateReportSchedule: 'Failed to create report schedule.',
    failedToCreateUnitPack: 'failed to create unit pack',
    failedToCreateUser: 'Failed to create user.',
    failedToDeleteAudienceFile: 'Failed to delete audience file.',
    failedToDeleteAudienceLogic: 'Failed to delete the custom audience.',
    failedToDeleteAudienceLogics: 'Failed to delete audience(s).',
    failedToDeleteCampaign: 'Failed to delete campaign.',
    failedToDeleteCampaigns: 'Failed to delete campaign(s).',
    failedToDeleteCreative: 'Failed to delete the creative.',
    failedToDeleteCreativeFiles: 'Failed to delete creative file(s).',
    failedToDeleteCreativeLineItems: 'Failed to delete creative line items.',
    failedToDeleteCreatives: 'Failed to delete creatives.',
    failedToDeleteCustomEvent: 'Failed to delete custom event.',
    failedToDeleteDemographic: 'Failed to delete demographic.',
    failedToDeleteGeofence: 'Failed to delete the geofence.',
    failedToDeleteGeofenceGroup: 'Failed to delete the geofence group.',
    failedToDeleteGeofenceGroups: 'Failed to delete geofence group(s).',
    failedToDeleteGeofences: 'Failed to delete geofence(s).',
    failedToDeleteJourneyAnalysis: 'Failed to delete journey analysis.',
    failedToDeleteLiftDashboard: 'Failed to save lift dashboard.',
    failedToDeleteLineItemCreative: 'Failed to delete line item creative.',
    failedToDeleteLineItemCreatives: 'Failed to delete line item creatives.',
    failedToDeleteLineItems: 'Failed to delete line item(s).',
    failedToDeleteMargins: 'Failed to delete margin(s).',
    failedToDeleteMobileLineItems: 'Failed to delete mobile line item(s).',
    failedToDeleteOrganizationCustomField: 'Failed to delete organization custom field.',
    failedToDeleteOwnerYieldManagerSsps: 'Failed to delete yield manager SSPs.',
    failedToDeletePackage: 'Failed to delete deal.',
    failedToDeletePackages: 'Failed to delete deals.',
    failedToDeletePreSaleHeatmap: 'Failed to delete the proposal heatmap.',
    failedToDeletePreSaleHeatmaps: 'Failed to delete proposal heatmap(s).',
    failedToDeleteReportDefinition: 'Failed to delete report definition(s).',
    failedToDeleteReportExecution: 'Failed to delete the report execution.',
    failedToDeleteReportExecutions: 'Failed to delete report execution(s).',
    failedToDeleteReportSchedule: 'Failed to delete report schedule.',
    failedToDeleteSite: 'Failed to delete the site.',
    failedToDeleteSites: 'Failed to delete site(s).',
    failedToDeleteUnit: 'Failed to delete screen.',
    failedToDeleteUnitFallbackCreatives: 'Failed to delete unit fallback creatives.',
    failedToDeleteUnitPacks: 'failed to delete unit packs.',
    failedToDeleteUnits: 'Failed to delete screen(s).',
    failedToDeleteUser: 'Failed to delete user.',
    failedToDownloadReport: 'Failed to download report.',
    failedToDownloadTargetedScreens: 'Failed to download targeted screens.',
    failedToGenerateProposalPDF: 'Failed to generate proposal PDF',
    failedToGeocodeAddress: 'Failed to geocode address',
    failedToGetAccounts: 'Failed to get accounts.',
    failedToGetAdvertisers: 'Failed to get advertisers.',
    failedToGetAudienceFiles: 'Failed to get audience files.',
    failedToGetAudienceLogic: 'Failed to get custom audience.',
    failedToGetAudienceLogicAudit: 'Failed to get audience logic audit.',
    failedToGetAudienceLogics: 'Failed to get audiences.',
    failedToGetAudienceRule: 'Failed to get audience rule',
    failedToGetAvailsFiles: 'Failed to get Avails Files.',
    failedToGetBidStats: 'Failed to get bid statistics.',
    failedToGetBuyers: 'Failed to get buyers.',
    failedToGetCadenceReport: 'Failed to get cadence report.',
    failedToGetCampaign: 'Failed to get campaign.',
    failedToGetCampaignAudit: 'Failed to get campaign audit.',
    failedToGetCampaignDetailsStats: 'Failed to get campaign details stats.',
    failedToGetCampaignSitesStats: 'Failed to get campaign sites stats.',
    failedToGetCampaignSummaryDeliveryStats: 'Failed to get campaign summary delivery stats.',
    failedToGetCampaignSummaryPanelStats: 'Failed to get campaign summary panel stats.',
    failedToGetCampaignUnitsStats: 'Failed to get campaign screens stats.',
    failedToGetCampaigns: 'Failed to get campaigns.',
    failedToGetChildrenLocations: 'Failed to get locations.',
    failedToGetCountries: 'Failed to get countries.',
    failedToGetCreative: 'Failed to get creative.',
    failedToGetCreativeAudit: 'Failed to get creative audit.',
    failedToGetCreativeLineItems: 'Failed to get creative line items.',
    failedToGetCreativeMediaOwnerApprovals: 'Failed to get creative media owner approvals.',
    failedToGetCreatives: 'Failed to get creatives.',
    failedToGetCreativesFiles: 'Failed to get creative files.',
    failedToGetCustomEvent: 'Failed to get custom events',
    failedToGetDashboardAlert: 'Failed to get dashboard alert.',
    failedToGetDataProviders: 'Failed to get data providers.',
    failedToGetDemographicAudit: 'Failed to get demographic audit.',
    failedToGetDemographicUnitsWithData: 'Failed to get demographic units with data.',
    failedToGetDemographics: 'Failed to get demographics.',
    failedToGetDiscountTypes: 'Failed to get discount types.',
    failedToGetEstimatedDeliveryStatistics: 'Failed to get estimated delivery statistics.',
    failedToGetExchangeSettings: 'Failed to get exchange settings.',
    failedToGetExternalDemographics: 'Failed to get external demographics.',
    failedToGetFilterChanges: 'Failed to get filter changes.',
    failedToGetFutureReportExecutions: 'Failed to get future report executions.',
    failedToGetGenericGeofences: 'Failed to get generic geofences.',
    failedToGetGeocodedUnitsAndSitesForTargets: 'Failed to get geocoded units and sites for targets.',
    failedToGetGeofence: 'Failed to get geofence.',
    failedToGetGeofenceGroup: 'Failed to get geofence group.',
    failedToGetGeofenceGroups: 'Failed to get geofence groups.',
    failedToGetGeofenceSiteMapping: 'Failed to get geofence site mapping.',
    failedToGetGeofenceSiteMappingForSites: 'Failed to get geofence site mapping for sites.',
    failedToGetGeofenceUnitMapping: 'Failed to get geofence unit mapping.',
    failedToGetGeofenceUnitMappingForUnits: 'Failed to get geofence unit mapping for units.',
    failedToGetGeofences: 'Failed to get geofences.',
    failedToGetIABCategories: 'Failed to get IAB categories.',
    failedToGetIsDealBought: 'Failed to get if the deal is bought.',
    failedToGetJourneyAnalyses: 'Failed to get journeys',
    failedToGetJourneyAnalysis: 'Failed to get journey analysis.',
    failedToGetLanguages: 'Failed to get languages.',
    failedToGetLatestPlays: 'Failed to get latest plays.',
    failedToGetLiftAnalysisData: 'Failed to get lift analysis data.',
    failedToGetLiftDashboards: 'Failed to get lift dashboards.',
    failedToGetLineItem: 'Failed to get line item.',
    failedToGetLineItemAudit: 'Failed to get line item audit.',
    failedToGetLineItemAvailabilities: 'Failed to get line item availabilities.',
    failedToGetLineItemCPM: 'Failed to get line item CPM.',
    failedToGetLineItemCreatives: 'Failed to get line item creatives.',
    failedToGetLineItemDemographicTargets: 'Failed to get line item demographic targets.',
    failedToGetLineItemDetailsStats: 'Failed to get line item details stats.',
    failedToGetLineItemHourlyDeliveryStats: 'Failed to get line item hourly delivery stats.',
    failedToGetLineItemHourlyStatsBySite: 'Failed to get line item hourly stats by site.',
    failedToGetLineItemHourlyStatsByUnit: 'Failed to get line item hourly stats by unit.',
    failedToGetLineItemIsApprovalRequired: 'Failed to get line item is approval required.',
    failedToGetLineItemMediaOwnerApprovals: 'Failed to get line item media owner approvals.',
    failedToGetLineItemSitesStats: 'Failed to get line item sites stats.',
    failedToGetLineItemSummaryDeliveryStats: 'Failed to get line item summary delivery stats.',
    failedToGetLineItemSummaryPanelStats: 'Failed to get line item summary panel stats.',
    failedToGetLineItemTimelineStats: 'Failed to get line item timeline stats.',
    failedToGetLineItemUnitsStats: 'Failed to get line item screens stats.',
    failedToGetLineItems: 'Failed to get line items.',
    failedToGetLocation: 'Failed to get location.',
    failedToGetLocationSites: 'Failed to get sites by location',
    failedToGetLocations: 'Failed to get locations.',
    failedToGetLoginAlert: 'Failed to get login alert.',
    failedToGetMargins: 'Failed to get margins',
    failedToGetMarkets: 'Failed to get markets.',
    failedToGetMediaOwners: 'Failed to get media owners.',
    failedToGetMediaTypes: 'Failed to get media types.',
    failedToGetMembership: 'Failed to get membership.',
    failedToGetMissingCreativeDimensionsForTargets: 'Failed to get missing creative dimensions for targets.',
    failedToGetMobileLineItem: 'Failed to get mobile line item.',
    failedToGetMobileLineItemAudit: 'Failed to get mobile line item audit.',
    failedToGetMobileLineItems: 'Failed to get mobile line items.',
    failedToGetNetworks: 'Failed to get networks.',
    failedToGetOrganizationCustomFields: 'Failed to get organization custom fields.',
    failedToGetOrganizationDSPBuyers: 'Failed to get organization buyers.',
    failedToGetOrganizationDSPs: 'Failed to get organization ps.',
    failedToGetOrganizationSettings: 'Failed to get organization settings.',
    failedToGetOrganizationTopScreenDimensions: 'Failed to get organization top screen dimensions.',
    failedToGetOwnerYieldManagerSsps: 'Failed to get yield manager SSPs.',
    failedToGetPackage: 'Failed to get package.',
    failedToGetPackageAudit: 'Failed to get package audit.',
    failedToGetPackageGroup: 'Failed to get package group.',
    failedToGetPackages: 'Failed to get packages.',
    failedToGetPermissions: 'Failed to get permissions.',
    failedToGetPlans: 'Failed to get plans.',
    failedToGetPreSaleHeatmap: 'Failed to get proposal heatmap.',
    failedToGetPreSaleHeatmaps: 'Failed to get proposal heatmaps.',
    failedToGetProducts: 'Failed to get products.',
    failedToGetReachAndFrequencyData: 'Failed to fetch reach and frequency data',
    failedToGetRecommendedCreatives: 'Failed to get recommended creatives.',
    failedToGetReportDefinition: 'Failed to get report definition.',
    failedToGetReportDefinitionAudit: 'Failed to get report definition audit.',
    failedToGetReportDefinitions: 'Failed to get report definitions.',
    failedToGetReportExecution: 'Failed to get report execution.',
    failedToGetReportExecutions: 'Failed to get report executions.',
    failedToGetReportSchedule: 'Failed to get report schedule.',
    failedToGetReportScheduleAudit: 'Failed to get report schedule audit.',
    failedToGetReportSchedules: 'Failed to get report schedules.',
    failedToGetReportSummaries: 'Failed to get report summaries.',
    failedToGetReportSummaryActiveFilters: 'Failed to get report summary active filters.',
    failedToGetRevenueSplit: 'Failed to get revenue split.',
    failedToGetRoles: 'Failed to get roles.',
    failedToGetSite: 'Failed to get site.',
    failedToGetSiteAudit: 'Failed to get site audit.',
    failedToGetSites: 'Failed to get sites.',
    failedToGetSubscriptions: 'Failed to get subscriptions.',
    failedToGetSuppliers: 'Failed to get suppliers.',
    failedToGetTargetingCriteria: 'Failed to get targeting criteria.',
    failedToGetUnit: 'Failed to get screen.',
    failedToGetUnitAudit: 'Failed to get unit audit.',
    failedToGetUnitDimensionsForTargets: 'Failed to get unit dimensions for targets.',
    failedToGetUnitFallbackCreatives: 'Failed to get unit fallback creatives.',
    failedToGetUnitPacks: 'failed to get unit packs.',
    failedToGetUnitRatioStatuses: 'Failed to get unit ratio statuses.',
    failedToGetUnits: 'Failed to get screens.',
    failedToGetUnitsAndSites: 'Failed to get unit and sites.',
    failedToGetUnitsAndSitesCount: 'Failed to get unit and sitescount.',
    failedToGetUnitsAudienceData: 'Failed to get units audience data.',
    failedToGetUnitsInUnitPack: 'failed to get units in unit pack.',
    failedToGetUsers: 'Failed to get users.',
    failedToLinkCreativesToLineItem: 'Failed to link creatives to line item.',
    failedToLinkFallbackCreativesToUnit: 'Failed to link fallback creatives to unit.',
    failedToLinkLineItemsToCreative: 'Failed to link line items to creatives.',
    failedToLoadUserSettings: 'Failed to load user settings.',
    failedToLogin: 'Login failed.',
    failedToLoginBecausePasswordHasExpired: 'Your password has expired',
    failedToLoginInvalidEmailOrPassword: 'Failed to login. Invalid email or password.',
    failedToLoginInvalidPassword: 'Failed to login. Invalid password.',
    failedToPreviewGeofenceGroup: 'Failed to preview geofence group.',
    failedToPublishPackages: 'Failed to publish packages.',
    failedToQueryForGeofence: 'Failed to query for geofence.',
    failedToRejectLineItem: 'Failed to reject line item.',
    failedToRejectLineItems: 'Failed to reject line items.',
    failedToResetPassword: 'Failed to reset your password',
    failedToRunReportDefinition: 'Failed to run report definition.',
    failedToSaveAccount: 'Failed to save account.',
    failedToSaveAdvertiser: 'Failed to save advertiser.',
    failedToSaveAudienceFile: 'Failed to save audience file.',
    failedToSaveAudienceLogic: 'Failed to save custom audience.',
    failedToSaveAudienceRule: 'Failed to save audience rule',
    failedToSaveCampaign: 'Failed to save campaign.',
    failedToSaveCreative: 'Failed to save creative.',
    failedToSaveCreativeFile: 'Failed to save creative file.',
    failedToSaveCreativeRunState: 'Failed to save creative run state.',
    failedToSaveCreativeState: 'Failed to save creative state.',
    failedToSaveCreativeStatus: 'Failed to save creative status.',
    failedToSaveCustomEvent: 'Failed to save custom event.',
    failedToSaveExternalCreative: 'Failed to save external creative.',
    failedToSaveExternalEvent: 'Failed to save external event.',
    failedToSaveGeofence: 'Failed to save geofence.',
    failedToSaveGeofenceGroup: 'Failed to save geofence group.',
    failedToSaveGeofences: 'Failed to save geofences.',
    failedToSaveLiftDashboard: 'Failed to save lift dashboard.',
    failedToSaveLineItem: 'Failed to save line item.',
    failedToSaveLineItemRunState: 'Failed to save line item run state.',
    failedToSaveLineItemState: 'Failed to save line item state.',
    failedToSaveLineItems: 'Failed to save line items.',
    failedToSaveLineItemsRunState: 'Failed to save line item(s) run state.',
    failedToSaveLineItemsState: 'Failed to save line item(s) state.',
    failedToSaveMargin: 'Failed to save margin.',
    failedToSaveMobileLineItem: 'Failed to save mobile line item',
    failedToSaveMovieAudience: 'Failed to save movie audience.',
    failedToSaveNetwork: 'Failed to save networks.',
    failedToSaveNewAvailsFile: 'Failed to save new Avails File.',
    failedToSaveOrganizationCustomField: 'Failed to save organization custom field.',
    failedToSaveOwnerYieldManagerSsp: 'Failed to save yield manager SSP.',
    failedToSaveOwnerYieldManagerSsps: 'Failed to save yield manager SSPs.',
    failedToSavePackage: 'Failed to save deal.',
    failedToSavePackageGroup: 'Failed to save package group.',
    failedToSavePlan: 'Failed to save plan.',
    failedToSavePreSaleHeatmap: 'Failed to save proposal heatmap.',
    failedToSaveReportDefinition: 'Failed to save report definition.',
    failedToSaveReportExecution: 'Failed to save report execution.',
    failedToSaveSite: 'Failed to save site.',
    failedToSaveUnit: 'Failed to save the screen.',
    failedToSaveUnitPack: 'failed to save unit pack.',
    failedToSaveUnitsInUnitPack: 'failed to save units in unit pack.',
    failedToSaveUser: 'Failed to save user.',
    failedToSaveUserSettings: 'Failed to save user settings.',
    failedToSendPasswordResetEmail: 'Failed to send the password reset email.',
    failedToSendVerificationEmail: 'Failed to send verification emails.',
    failedToSubscribeToOrganizationSubscriptions: 'Failed to subscribe to organization subscriptions.',
    failedToTargetingCriteria: 'Failed to targeting criteria.',
    failedToTreeSearchLocations: 'Failed to perform a tree search for locations.',
    failedToUnitDimensions: 'Failed to unit dimensions.',
    failedToUpdateAudienceFile: 'Failed to update audience file.',
    failedToUpdateAudienceLogic: 'Failed to update audience logic.',
    failedToUpdateAudienceRule: 'Failed to update audience rule',
    failedToUpdateCampaign: 'Failed to update campaign.',
    failedToUpdateCreative: 'Failed to update creative.',
    failedToUpdateCreativeMediaOwnerApprovals: 'Failed to update creative media owner approvals.',
    failedToUpdateCreativePrefetchSizeApproval: 'Failed to update creative prefetch size approval.',
    failedToUpdateCreatives: 'Failed to update creatives.',
    failedToUpdateCustomEvent: 'Failed to update custom event.',
    failedToUpdateDemographic: 'Failed to update demographic.',
    failedToUpdateJourneyAnalysis: 'Failed to update journey analysis.',
    failedToUpdateLiftDashboard: 'Failed to update lift dashboard.',
    failedToUpdateLineItemCreatives: 'Failed to update line item creatives.',
    failedToUpdateLineItems: 'Failed to update line items',
    failedToUpdateMargins: 'Failed to update margins.',
    failedToUpdateMobileLineItem: 'Failed to update mobile line item.',
    failedToUpdateNetwork: 'Failed to update network.',
    failedToUpdateOrganizationCustomField: 'Failed to update organization custom field.',
    failedToUpdatePackage: 'Failed to update package.',
    failedToUpdatePackageGroup: 'Failed to update package group.',
    failedToUpdatePlan: 'Failed to update plan.',
    failedToUpdateReportDefinition: 'Failed to update report definition',
    failedToUpdateReportSchedule: 'Failed to update report schedule.',
    failedToUpdateUnitPack: 'failed to update unit pack.',
    failedToUploadImage: 'Failed to upload image.',
    failedToUploadPhoto: 'Failed to upload photo.',
    failedToVerifyEmail: 'There was a problem verifying your email',
    failedTocreateCampaigns: 'Failed to campaigns.',
    fieldDescriptionAdvertiserDomain: 'Here are domain examples: apple.com, coca-cola.com, google.com',
    fieldDescriptionAdvertiserMinSecondsBetweenAdPlays: 'Prevents playback from same advertiser on same media owner during the specified time period.',
    fieldDescriptionCampaignMinSecondsBetweenPlays: 'Prevents plays from the same campaign during the specified time period.',
    fieldDescriptionCustomEventCategory: 'Name for the grouping of events',
    fieldDescriptionCustomEventCode: 'Unique identifier for an event',
    fieldDescriptionCustomEventName: 'Unique identifier for an event',
    fieldDescriptionDateRangeTimeZone: 'This time zone is<br/>only for date range<br/>and not for the metrics.',
    fieldDescriptionFrequencyCap: 'The minimum number of seconds between plays on every targeted screens.',
    fieldDescriptionLineItemExternalId: 'Optional field that may be used to reference an ID from an external system',
    fieldDescriptionLineItemMobileRetargetingExternalId: 'Enter a unique identifier to link playlog data for this line item to a related external mobile re-targeting campaign',
    fieldDescriptionLineItemNumberOfDaysFixed: 'The exact number of days the line item will run for.',
    fieldDescriptionLineItemNumberOfDaysRange: 'The number of days the line item will run for.',
    fieldDescriptionMarginName: 'Unique identifier for a margin',
    fieldDescriptionMaxBidCPM: 'The maximum amount you\'re willing to pay for 1,000 views of your ad.',
    fieldDescriptionMinMaxCPM: 'The CPM range you are willing to pay for.',
    fieldDescriptionPackageAvailability: 'Dates within which the deal will be available to buy.',
    fieldDescriptionPackageFlexible: 'Selecting "Buyer Definable" allows Buyers on the internal DSP to modify certain deal parameters. Choose "Predefined" if you wish to publish this deal on external DSPs.',
    fieldDescriptionPackageRunWindow: 'Dates within which the deal can be run.',
    fileIsEmpty: 'The file is empty.',
    fileTooBig: 'File too big',
    fileTooBigDescription: 'Upload failed, the maximum file size is {0}MB.',
    filenameMustOnlyContainWordsAndWhitespace: 'Name must only contain words and whitespace.',
    filterByName: 'filter by name',
    filterByNameOrDescription: 'filter by name or description',
    filterSettings: 'filter settings',
    filtersAreNotSupportedWhileYieldManagerIsActive: 'Since the data coming from external SSPs through Yield Manager cannot be filtered, it will not appear once you apply your selection.',
    finishedOn: 'Finished on',
    first: 'first',
    firstDayOfTheMonth: 'first day of the month',
    fixedCPM: 'fixed CPM',
    fixedCPMIsSetToZero: 'Fixed CPM is set to zero',
    floorCPMFieldIsRequired: 'Floor CPM field is required',
    forecastedBidGeoDistribution: 'forecasted bid geo-distribution',
    forecastedBidWinRate: 'forecasted bid win %',
    forecastedCadenceAccordingToImpressions: 'Forecasted cadence according to impressions.',
    forecastedImpressions: 'forecasted impressions',
    forecastedImpressionsAccordingToCadence: 'Forecasted impressions according to cadence.',
    formattedInputMustBeInteger: 'This value will automatically be rounded to the closest integer',
    foundExistingPlaceInBuilding: 'Are you trying to associate the building to this geofence?',
    foundExistingPlaceInPolygon: 'Are you trying to associate the newly drawned polygon to this geofence?',
    foundExistingPlaceNearBuilding: 'We found an existing geofence near the building, choose \'Yes\' to link the building to it or choose \'No\' to continue.',
    foundExistingPlaceNearPolygon: 'We found an existing geofence near the drawn polygon, choose \'Yes\' to link the polygon to it or choose \'No\' to continue.',
    foundExistingPlacesNearBuilding: 'We found existing geofences near the building, select the geofence you would like to link the building to and choose \'Yes\' or choose \'No\' to continue.',
    foundExistingPlacesNearPolygon: 'We found existing geofences near the drawn polygon, select the geofence you would like to link the polygon to and choose \'Yes\' or choose \'No\' to continue.',
    freqCapNetworkOverrides: 'per-network',
    frequencyCapPerNetwork: 'Frequency cap per network',
    fromRateCard: 'From rate card',
    fullscreen: 'fullscreen',
    genderAndAge: 'gender and age',
    generalInformation: 'general information',
    generalSettings: 'general settings',
    generatingPDF: 'generating PDF...',
    generatingProposal: 'Generating proposal…',
    geofenceCreationFromBuilding: 'Geofence from building',
    geofenceCreationFromCoordinate: 'Geofence from coordinate',
    geofenceCreationFromPolygon: 'Geofence from polygon',
    geofenceGroupBaiduMapSearchTooltip: '<p>To use this search box:</p> <ul> <li> <b>Search places in geographic location</b><br> Just type in the geographic location where you would like to search followed by a business name or type of place. <small>Examples: ”Walmart in Beijing”.</small> </li> </ul>',
    geofenceGroupCreatedWithTheToolToDrawSelectionOnTheMap: 'Geofence group created with the tool to draw selections on the map.',
    geofenceGroupMapSearchTooltip: '<p>There are 3 ways of using this search box:</p> <ul> <li> <b>Search geography</b><br> Searching a country, state or city will directly jump to the location.<br> <small>Examples: {0}.</small> </li> <li> <b>Search places in geographic location</b><br> Just type a business name or type of place followed by the geographic location where you would like to search.<br> <small>Examples: {1}.</small> <small>Do not pluralize brands or place types, {2} will yield weaker results than {3}.</small> </li> <li> <b>Search places in viewport</b><br> Just type a business name or type of place and the search will only occur in the visible viewport.<br> <small>Examples: "McDonald\'s", "Grocery store".</small> <small>Do not pluralize brands or place types, "Grocery stores" will yield weaker results than "Grocery store".</small> </li> </ul>',
    geofenceGroupSavedSuccessfully: 'Geofence saved successfully.',
    geofenceSavedSuccessfully: 'Geofence saved successfully.',
    getTimezoneFromCoordinates: 'Get timezone from coordinates',
    gettingReady: 'Getting ready…',
    gettingYourMapReady: 'Hang on, we’re getting your map ready…',
    goToStatusPage: 'Go to our status page',
    goalOutOfDate: 'Goal out of date',
    handDrawnMapSelections: 'Hand drawn map selections',
    hasImpressionData: 'has impression data',
    hasPolygons: 'Has polygons?',
    headerBidderSSPResponseTimeout: 'response timeout (ms)',
    headerBidderSSPResponseTimeoutDescription: 'Maximum duration (in milliseconds) that the SSP is required to respond with an ad.',
    headerSettings: 'header settings',
    headerText: 'header text',
    heatmapPagingFormattedMessage: 'Showing {start} – {end} of {total}',
    heatmapPublicLinkCopiedToClipboard: 'heatmap public link copied to clipboard',
    help: 'help',
    hideFilters: 'hide filters',
    hideScreenInformationInBidRequests: 'Hide screen information in bid requests',
    highlyConcentrated: 'highly concentrated',
    historicalAndForecastedBidCPM: 'historical + forecasted bid CPM',
    hivestackDSPBuyersOnly: 'Hivestack DSP buyers only',
    householdIncome: 'household income',
    howToBulkUploadCreatives: 'By clicking on the Yes button below, a new modal will pop up. From there, please drag and drop all of the images needed for the creatives on the browser. All of those images will be under one creative. The last step is to drag and drop any image below the current creative row in order to create more creatives.',
    html: 'HTML',
    htmlFileUpload: 'HTML file upload',
    iWouldLikeToAttachThePolygonToAnExistingGeofence: 'Link the polygon to an existing geofence.',
    iWouldLikeToCreateANewGeofenceFromBuilding: 'Create a new geofence from the building.',
    iWouldLikeToCreateANewGeofenceFromPolygon: 'Create a new geofence from the polygon.',
    iabBlockCategories: 'blocked categories',
    iabCategoryBlocking: 'IAB category blocking',
    iabCategoryFrequencyCap: 'IAB category frequency cap',
    iconSettings: 'icon settings',
    importPolygons: 'import polygons',
    importingAvails: 'Importing avails',
    importingAvailsFailed: 'Importing avails failed.',
    impressionGoal: 'impression goal',
    impressionsPerDay: 'impressions per day',
    impressionsPerPlay: 'Impressions per play',
    impressionsUnavailability: 'Target impressions cannot be lower than delivered.',
    inProgress: 'In progress',
    inRange: 'In range',
    inRangeBetween2Values: 'in range {0} to {1}',
    inactiveScreens: 'inactive screens',
    includes: 'includes',
    includesAScreensExternalID: 'includes a screen\'s external ID',
    includesAScreensLatAndLong: 'includes a screen\'s lat and long in the following format 51.004703,3.754806',
    includesAScreensUUID: 'includes a screen\'s UUID',
    includesAScreensUnitID: 'includes a screen\'s unit ID',
    includesASitesExternalIdOfTheScreensSite: 'includes a site\'s external ID of the screen\'s site',
    increaseInCover: 'Increase in cover',
    incrementalWalkins: 'Incremental Walk-ins',
    infinite: 'unlimited',
    infiniteBudget: 'unlimited budget',
    infiniteUpToCampaignBudget: 'Unlimited up to campaign budget',
    initializingMap: 'Initializing map…',
    interest: 'This category has been created based on visits to websites dedicated to specific subjects.',
    internalDSPBuyersOnly: 'Internal DSP buyers only',
    internalServerError: '500 Internal Server Error',
    invalidAudienceFileTypeMessage: 'All audience files must be one of CSV or XLSX file formats',
    invalidAudienceFileTypeTitle: 'Invalid file',
    invalidAvailableSeconds: 'The column \'available_seconds\' must contain 24 values separated by comma',
    invalidBulkLineItemCreationFileTypeMessage: 'All line item bulk creation files must be one of CSV or XLSX file formats',
    invalidBulkLineItemCreationFileTypeTitle: 'Invalid file',
    invalidCSVFile: 'The file is invalid or does not respect the expected format. You can download a file template below.',
    invalidCreativeDateRangeCombination: 'Some dates do not have scheduled content.',
    invalidCreativeDateRangeCombinationNote: 'The line item will not play on dates without scheduled content.',
    invalidCreativeFileTypeMessage: 'All creative files must be one of HTML, ZIP, JPEG, JPG, PNG, MOV, MP4, MP3, WAV, OGG or FLAC file formats',
    invalidCreativeFileTypeNoHTMLMessage: 'All creative files must be one of ZIP, JPEG, JPG, PNG, MOV, MP4, MP3, WAV, OGG or FLAC file formats',
    invalidCreativeFileTypeTitle: 'Invalid creative file type',
    invalidDateRange: 'Invalid Date Range',
    invalidDaypart: 'Invalid daypart',
    invalidFile: 'Invalid file',
    invalidGeoJSON: 'Invalid GeoJSON',
    invalidInput: 'invalid input',
    invalidLatitude: 'the latitude column is invalid, the value should be a number between -90 and 90.',
    invalidLatitudeValue: 'Invalid latitude value',
    invalidLongitude: 'the longitude column is invalid, the value should be a number between -180 and 180.',
    invalidLongitudeValue: 'Invalid longitude value',
    invalidMacrosInTheURL: 'Invalid macros in the URL',
    invalidMinMaxLatitudeValue: 'The minimum latitude value is -90 and the maximum is 90',
    invalidMinMaxLongitudeValue: 'The minimum longitude value is -180 and the maximum is 180',
    invalidMinMaxPitchValue: 'The minimum pitch value is 0 and the maximum is 60',
    invalidMinMaxZoomLevelValue: 'The minimum zoom level value is 1 and the maximum is 26',
    invalidPipeline: 'Invalid pipeline',
    invalidPitchValue: 'Invalid pitch value',
    invalidRadius: 'the radius column is invalid, the value should be a number between 0 and 100000.',
    invalidReservedSeconds: 'The column \'reserved_seconds\' must contain 24 values separated by comma',
    invalidSSPInformation: 'Invalid SSP information',
    invalidSearch: 'invalid search',
    invalidUserProfilePhotoFileTypeMessage: 'Profile photos must be one of JPEG, JPG, or PNG file formats',
    invalidUserProfilePhotoFileTypeTitle: 'Invalid profile photo file type',
    invalidXLSFile: 'Invalid Excel file',
    invalidZoomLevelValue: 'Invalid zoom level value',
    inventoryLocationsMarkets: 'inventory, locations, markets',
    isActive: 'Is active',
    isAdDurationFixed: 'Is ad duration fixed?',
    isBudgetFixed: 'Is budget fixed?',
    isCpmFixed: 'Is CPM fixed?',
    isEmpty: 'Is empty',
    isMinSecondsBetweenPlaysFixed: 'Are the number of seconds between plays fixed?',
    isNumberOfDaysFixed: 'Are the number of days fixed?',
    isUsedAsFallback: 'Used as a fallback creative',
    isUsedAsMobile: 'Used as a mobile creative',
    itWouldEnableYouToReachAMinimumOfXAdditionalScreens: 'It would enable you to reach a minimum of {0} additional screen(s). ({1} of total)',
    itWouldEnableYouToReachAnExtraXScreens: 'It would enable you to reach an extra {0} screen(s). ({1} of total)',
    itWouldResultInAScreenIncreaseOf: 'It would result in a screen increase of {0}.  ({1} of total)',
    itemCannotBeChanged: 'Item cannot be changed.',
    journeyAnalysisNoGeofences: 'Please select a geofence group from the drop down.',
    journeyAnalysisNoGeofencesDescription: 'Journey Analysis will then find where people visiting the various geofences are originating from.',
    journeyAnalysisSavedSuccessfully: 'Journey analysis saved successfully.',
    languages: 'languages',
    last: 'last',
    last24HoursOfTheLineItem: 'Last 24 hours of the line item.',
    lastAdRequest: 'last ad request',
    lastAdRequestUTC: 'last ad request - UTC',
    lastDayOfTheMonth: 'last day of the month',
    lastExecutedOn: 'last executed on',
    lastLogin: 'last login',
    lastModifiedOn: 'last modified on',
    lastModifiedOnUTC: 'last modified on - UTC',
    lastPlayedOn: 'last played on',
    lastPlayedOnUTC: 'last played on - UTC',
    lastSeen: 'last seen',
    lastUpdatedOn: 'last updated on',
    latestAdPlays: 'latest ad plays',
    layerSettings: 'layer settings',
    leftMargin: 'left margin',
    legacy: 'legacy',
    lifestyle: 'This category has been created based frequency of users visits to specific granular places of interest as well as their high interest in terms of content related to specific global events - sports, culture and gaming.',
    lifetimeStats: 'lifetime',
    lift: 'lift',
    liftAnalysisRequested: 'lift analysis requested',
    liftAnalysisSelection: 'Lift analysis selection',
    liftCPIV: 'CPIV',
    liftControl: 'control',
    liftControlDescription: 'Rate of store visitation by DOOH unexposed devices',
    liftDashboardPublicLinkCopiedToClipboard: 'lift dashboard public link copied to clipboard',
    liftDashboardSavedSuccessfully: 'Lift dashboard saved successfully',
    liftDescription: 'Exposed / Control',
    liftDisclaimer: 'Reminder: The total campaign impression goal needs to be at least 2M impressions for a lift study and 5M for a brand lift study.',
    liftExposed: 'exposed',
    liftExposedDescription: 'Rate of store visitation by DOOH exposed devices',
    liftIncrementalWalkins: 'incremental walk-ins',
    liftIncrementalWalkinsDescription: 'Estimated market population store visitation that was generated by the campaign',
    lineItemBackToDraftWarning: 'Saving this line item will set its status back to Draft. You will have to submit it for approval again.',
    lineItemCadenceGoalCannotBeReached: 'The line item’s cadence goal cannot be reached because of a lack of availabilities.',
    lineItemCadenceGoalReachedWithUnreservedImpressions: 'The line item’s cadence goal may only be reached with unreserved impressions combined with reserved impressions.',
    lineItemCanOnlyHaveOneDiscountPerDiscountType: 'A line item can only have one discount per discount type.',
    lineItemCheckAvailsNotAvailableBecauseEndDateIsInThePast: 'Check avails is not available for line items which have already ended.',
    lineItemCheckAvailsNotAvailableBecauseNoGoalsHaveBeenSpecified: 'You need to specify a goal before you can check availability.',
    lineItemDiscountLessThanOneHundredIfBudgetMode: 'Discount values must be less than 100 if it’s a budget-based campaign.',
    lineItemDiscountMustBeGreaterThanZeroAndLessThanOrEqualToOneHundred: 'Discount values must be greater than 0 and less than or equal to 100.',
    lineItemDurationCannotExceedMaxDays: 'The line item duration cannot exceed {0} days.',
    lineItemEndDateCannotBeChanged: 'The line item end date cannot be changed.',
    lineItemGoalCanBeReachedFromReservedImpressionsButNotAcrossAllDays: 'The line item goal can be reached from reserved impressions, but not across all days of the flight.',
    lineItemGoalCannotBeReachedFromReservedImpressions: 'The line item goal cannot be reached from reserved impressions.',
    lineItemHasBeenRejectedBySomeMediaOwners: 'This line item has been rejected by some media owners.',
    lineItemHasNotPlayedInTheLast12Hours: 'The line item has not played in the last 12 hours.',
    lineItemHasNotPlayedInTheLast24Hours: 'The line item has not played in the last 24 hours.',
    lineItemIsRunningFine: 'The line item is running fine.',
    lineItemMeasurementRequestCannotBeDisabledWhenImpressionsWereDelivered: 'Requesting measurement cannot be disabled since impressions have already been delivered.',
    lineItemMediaOwnersMustBeGreaterThanZero: 'One or more media owners must be selected.',
    lineItemPausedSuccessfully: 'Line item paused successfully.',
    lineItemSavedSuccessfully: 'Line item saved successfully.',
    lineItemStartDateCannotBeChangedAfterImpressionsAreDelivered: 'The line item start date cannot be changed after impressions are delivered.',
    lineItemStartDateCannotBeSetInThePast: 'The line item start date cannot be set in the past.',
    lineItemStartDateMustBeWithinTheNextXDays: 'The line item start date must be within the next {x} days.',
    lineItemTargetedImpressionsTooLow: 'Target impressions are too low, a minimum of {0} impressions is required.',
    lineItemTargetingMoreThanSpecifiedScreens: 'We don’t currently support line items that target more than {0} screens. Please check your targeting does not go beyond this limit.',
    lineItemUnpausedSuccessfully: 'Line item unpaused successfully.',
    lineItemWillTriggerWhenAllTheConditionsAreMet: 'This line item will trigger when all the conditions are met. We consider a condition to be met as soon as at least one criterion is met.',
    lineItemsArchivedSuccessfully: 'Line items archived successfully.',
    lineItemsBatchOperationFailed: 'lineItems batch operation failed.',
    lineItemsPausedSuccessfully: 'Line items paused successfully.',
    lineItemsPublishedSuccessfully: 'Line items published successfully .',
    lineItemsSavedSuccessfully: 'Line items saved successfully.',
    lineItemsSubmittedSuccessfully: 'Line items submitted successfully.',
    lineItemsUnPausedSuccessfully: 'Line items unpaused successfully.',
    live: 'live',
    liveBoardDSPBuyersOnly: 'Live Board DSP buyers only',
    loadingAudience: 'Loading audience...',
    loadingData: 'loading data',
    loadingGeofences: 'Loading geofences, this could take more than a minute.',
    loadingGroupedStats: 'Loading grouped statistics…',
    loadingInventory: 'loading inventory',
    loadingMoreResults: 'loading more results',
    loadingOfSelectionsIsInProgress: 'Loading of selections is in progress.',
    loadingSelection: 'Loading selection...',
    local: 'local',
    localDateIsMissing: 'The column \'local_date\' is missing.',
    locationsMatchingYourSearch: 'locations matching your search',
    lockedLocationDescription: 'Locking the geographical context will prevents any further automatic updates.',
    loginServiceDown: 'The login service is unresponsive.',
    logoSettings: 'logo settings',
    lookbackWindowCandidateFrequencyDescription: 'Mininum number of times observed within geofence during lookback window',
    lookingForScreensInsideGeofences: 'Looking for screens inside geofences',
    manageBudgetAtCampaign: 'manage budget at campaign',
    manageEmailNotifications: 'manage email notifications',
    manageMarginAtCampaignLevel: 'manage margin at campaign',
    managePriorityAtCampaignLevel: 'manage priority at campaign',
    managesBudget: 'manages budget',
    mapAudience: 'map audience',
    mapSelectionsApplied: 'map filters applied',
    marginSavedSuccessfully: 'Margin saved successfully.',
    margins: 'margin(s)',
    marketAverage: 'market average',
    marketPopulationMultiplier: 'Market population multiplier',
    marketPopulationMultiplierDescription: 'Total in-market devices / observed in-market devices',
    marketSettings: 'market settings',
    marketsMatchingYourSearch: 'markets matching your search',
    marksTheLocationOfTheScreenOnTheMap: 'Marks the location of the screen on the map',
    matchingCreativeFileSizes: 'Matching creative file sizes',
    maxAdDuration: 'maximum ad duration',
    maxBidCPM: 'max bid CPM',
    maxBidCPMIsRequired: 'Max bid CPM is required.',
    maxCadenceAvailable: 'max cadence available',
    maxCadenceAvailableIs: 'max cadence available is {0}.',
    maxCadenceImpressionsAvailable: 'max cadence impressions available',
    maxFloorCPMIncrease: 'max floor CPM increase',
    maxImpressionCapacity: 'Max impression capacity',
    maxScreenUploadLimitBody: 'Please select less than 10,000 screens.',
    maxScreenUploadLimitTitle: 'Max screen upload limit reached',
    maximumCreativeFileSize: 'The maximum creative file size is 250MB.',
    maximumGooglePlacesSearchResultsReached: 'You have reach the maximum number of results for a search. Try narrowing down your search, for example, instead of searching for "McDonald\'s in New York", make multiples searches within the borrows.',
    measurementCanOnlyBeRequestedWhenTargetedImpressionsAreTwoMillionOrMore: 'Lift analysis can only be requested when targeted impressions are {0} or more.',
    minAdDuration: 'minimum ad duration',
    minAdDurationMustBeLessThanMaxAdDuration: 'Minimum ad duration must be less than maximum ad duration.',
    minAudienceConcentrationDescription: 'When enabled, the line item will not play on screens where the audience concentration index is below the market average, even if the line item is underpacing.',
    minBidCPM: 'min bid CPM',
    minMaxBidCPM: 'min / max bid CPM',
    minMaxCPM: 'min / max CPM',
    minSecondsBetweenAdDomainPlays: 'advertiser frequency cap',
    minimumAudienceConcentration: 'minimum audience concentration',
    missingCreativeFileSizes: 'Missing creative file sizes',
    missingLineItemSelection: 'You must select at least one line item',
    missingRequiredValue: 'Missing Required Value',
    missingScreenIDs: 'Missing Screen IDs',
    missingScreenIDsBody: 'The following screen IDs could not be found:',
    missingScreenIDsOrUnitIDs: 'Missing or inactive screen IDs or unit IDs',
    missingScreenIDsOrUnitIDsBody: 'The following screen IDs or unit IDs could not be found or are inactive',
    missingSiteIDs: 'Missing Site IDs',
    missingSiteIDsBody: 'The following site IDs could not be found:',
    mobileAppUsage: 'This category has been created based on the mobile apps that the user has installed on their device and the user\'s mobile carrier.',
    mobileCreativeFileMandatorySizeInfo: 'The mandatory size requirement for a mobile creative is:  {0}.',
    mobileCreativeFileOptionalSizesInfo: 'Additionally you can supply the following sizes: {0}.',
    mobileFrequencyCappingDescription: 'Prevents plays on the same mobile device (or to the same user) within the time period.',
    mobileLineItemSavedSuccessfully: 'Mobile line item saved successfully',
    mobileRetargetingEnabled: 'mobile re-targeting enabled',
    modeledIncrementalWalkins: 'Modeled Incremental Walk-ins',
    modifyingCreativeFilesWillSetTheCreativeStatusBackToDraft: 'Modifying creative files will set the creative status back to "Draft". It will need to be re-submited for approval.',
    monitoring: 'monitoring',
    more: 'more',
    moreFilters: 'more filters',
    moreTargeting: 'more targeting',
    moreThan: 'more than',
    moreThanTimePeriodAgo: 'more than  {0} {1} ago',
    mustHaveALatLongOrAnAddress: 'Must have a latitude and longitude or an address.',
    nameAndAddress: 'name & address',
    nameIsMissing: 'the name column is missing.',
    namesSeparatedByCommaNewline: 'All names should be separated by commas or new lines.',
    needAtLeastOneCreativeForBulkCreativeUpload: 'You need to upload at least one creative in order to save the bulk creatives upload.',
    needCreativeFilesToSubmitForApproval: 'You need to upload at least one file in order to submit this creative for approval.',
    needToLinkToLineItemAndUploadCreativeFileToSubmitForApproval: 'You need to link this creative to one line item and upload at least one file in order to submit it for approval.',
    needToLinkToLineItemToSubmitForApproval: 'You need to link this creative to one line item in order to submit it for approval.',
    needToSelectAdvertiserAndCreativeForBulkCreativeUpload: 'You need to need to select an advertiser and upload at least one creative in order to save the bulk creatives upload.',
    needToSelectAdvertiserForBulkCreativeUpload: 'You need to need to select an advertiser in order to save the bulk creatives upload.',
    networkSavedSuccessfully: 'Network saved successfully.',
    newAdvertiserDomainAlreadyInUse: 'Domain already in use by another advertiser.',
    newMobileLineItemForCampaignX: 'new mobile line item for "{0}"',
    newVersionAvailable: 'A new version is available, please refresh your browser to get the latest and greatest.',
    noAdRequestFoundForSelectedTimePeriod: 'No Ad request found for selected time period',
    noAudienceDataExistSoSampleDataWasGeneratedForThisLocation: 'No audience data was found for this location, sample data will be used.',
    noAuditTrail: 'No audit trail',
    noAuditTrailDescription: 'Sorry, we could not find any audit trail for this item.',
    noAvailableUnitpacks: 'No packs are available for targeting at the moment',
    noCadenceReportFound: 'No cadence report found',
    noCategoriesMatchYourSearch: 'No categories match your search.',
    noChanges: 'No changes',
    noChangesDetected: 'Everything is up to date. No changes have been detected.',
    noCreativeFilesMatchingScreenSizes: 'No match',
    noCreativePreviewAvailable: 'No creative preview available',
    noDashboardData: 'No data available.',
    noDashboardDataDescription: 'Try changing your date range or removing some filters.',
    noDataAvailable: 'No data available.',
    noDataIsAvailableForTheSelectedDateRange: 'No data is available for the selected time period.',
    noDemographicsAvailable: 'No demographics are available.',
    noDiscounts: 'No discounts',
    noExternalDataProvidersAvailable: 'No audience data segments are available.',
    noFieldsMatchYourSearch: 'No fields match your search.',
    noFiltersInLineItemsTab: 'Filters do not affect the line item list and are disabled while in this tab.',
    noGeofences: 'No geofences',
    noGeofencesDescription: 'Use the search box above to add geofences.',
    noLanguagesSelected: 'The creative will not be played if no languages are selected.',
    noLiftDataAvailable: 'No lift data available',
    noLiftDataAvailableDescription: 'Threre is no lift data available, this is required in order to create lift dashboards.',
    noLineItemsLinkedMobileLineItem: 'No line items have been linked to this mobile line item.',
    noLocationsFound: 'Oops! No locations found. Consider changing the search query.',
    noMissingDimensions: 'No missing dimensions.',
    noPendingSubmissionsDescription: 'There are no line items pending approval from media owners.',
    noPendingSubmissionsTitle: 'No pending submissions',
    noPlacesFound: 'no places found',
    noPlacesWereFoundNearCoordinate: 'No places were found near the coordinate',
    noPlacesWereFoundTrySpecifyingAnMoreAccurateAddress: 'No places were found, try specifying a more accurate address or widen your search terms.',
    noPlacesWereFoundWithinTheBuilding: 'No places were found within the selected building.',
    noPlacesWereFoundWithinThePolygon: 'No places were found within the drawn polygon.',
    noPredefinedSegmentSelected: 'No predefined segments selected',
    noPredefinedSegments: 'There is no predefined segments available for your organisation. Please choose another type of rules.',
    noRecommendationsAvailable: 'no recommendations available',
    noRecordsFound: 'No records found.',
    noRecordsMatchYourFilters: 'No records match your filters.',
    noRejectionCommentWasProvided: 'No rejection comment was provided',
    noReportIsAvailableForTheSelectedTimeLine: 'No report is available for the selected time line.',
    noRestrictions: 'No restrictions',
    noResultsFound: 'no results found',
    noScreensFromThisMediaOwnerAreMatchingTheTargetingCriteria: 'No screens from this media owner are matching the line item targeting criteria.',
    noScreensSelected: 'No Screen(s) selected.',
    noSearchResults: 'No results match your search',
    noSegmentsFound: 'No segments found.',
    noSegmentsMatchYourSearch: 'No segments match your search.',
    noSelection: 'No selection',
    noSitesFound: 'Oops! No sites found. Consider changing the search query.',
    noSitesUnitsInGeofenceGroupMessage: 'The geofence group does not encompass any sites or screens.',
    noSitesUnitsInGeofenceGroupTitle: 'No sites or screens found',
    noSpecificLanguage: 'No specific language',
    noStatsAvailableToGenerateHourlyReport: 'No data is available for the generation of the hourly report.',
    notApplicable: 'N/A',
    notCalculatedYet: 'not yet calculated',
    notPublished: 'Not published',
    notRequested: 'not requested',
    notSeenInTheLastHour: 'Not seen in the last hour',
    notVisibleToBuyers: 'not visible to buyers',
    noteThatTheLineItemWillStillDeliverOnAllScreensHavingAudienceData: 'Note that the line item will still deliver on all screens having audience data.',
    nothingLeftToImport: 'Nothing left to import.',
    nothingToDisplay: 'Nothing to display.',
    numberOfEvents: 'Number of events',
    numberOfLocationsMatchingYourSearch: 'Number of locations matching your search:',
    numberOfScreensByAspectRatioAndLanguages: 'Number of screens by aspect ratio and languages',
    offline: 'You seem to be offline, check your internet connection.',
    oneOrMoreRowsHaveErrors: 'One or more rows have errors.',
    oneOrMoreTrackingURLsAreInvalid: 'One or more tracking URLs are invalid.',
    oneScreenFromThisMediaOwnerIsActivelyTargeted: 'One screen from this media owner is being actively targeted.',
    oneUnitIsMissingAudienceData: 'One screen is missing audience data.',
    only: 'only',
    onlyLocationsWithInventoryWillAppearInTheTree: 'Only locations with inventory will appear in the tree.',
    onlyOneOfBudgetOrTargetImpressionsCanBeSupplied: 'Only one of budget or target impressions can be supplied.',
    onlyTheFollowingSupportedMacrosWereKept: 'Only the following supported macros were kept: {0}',
    openTheDownloadedFileAndAddSomeLineItems: 'Open the downloaded file and add some line items.',
    openTheDownloadedFileAndEditOrAddSomeLineItems: 'Open the downloaded file and edit or add some line items.',
    openrtbUUID: 'OpenRTB UUID',
    operatingHoursAreNotValid: 'Operating hours are not valid. Valid examples are "Mon-Tue 9-18", "Sat 12-13", "Mon-Sun 10-11". ',
    operationDetails: 'Operation details',
    optimized: 'optimized',
    orInputACustomCadence: 'or input a custom cadence',
    organizationCustomFieldSavedSuccessfully: 'Custom field saved successfully',
    organizeYourFilesIntoCreatives: 'Organize your files into creatives',
    otherDSPBuyersOnly: 'Other DSP buyers only',
    outOf: 'out of',
    overallImpressions: 'overall impressions',
    overallSummary: 'overall summary',
    overriddenScreenCountListTooltip: 'This value has been overridden to represent the physical number of screens in this site',
    overrideAutopilot: 'override Autopilot',
    overrideExistingDemographics: 'Override existing demographic targeting?',
    overrideScreenCountHelpTooltip: 'Use this field to represent the number of physical screens that this screen stands for. We recommend using this if you sell sites instead of units.',
    paceBudgetAtCampaignAndLineItemLevel: 'Pace budget(s) at campaign and line item level ',
    pacingEnabled: 'pacing enabled',
    pacingStrategy: 'pacing strategy',
    pacingStrategyAhead: 'ahead',
    pacingStrategyAheadDescription: 'Ahead pacing is best if your priority is to spend your budget by applying a faster delivery rate at the beginning and gradually lowering the rate of delivery as the campaign progresses.',
    pacingStrategyAsap: 'ASAP',
    pacingStrategyAsapDescription: 'ASAP pacing is best if your priority is to spend all of your budget as quickly as possible.',
    pacingStrategyEven: 'even',
    pacingStrategyEvenDescription: 'Even pacing is best if your priority is to spend a consistent amount of money every day and your inventory availability is consistent day to day. Keep in mind that if there is less inventory or more competition toward the end of your campaign, you might not spend your full budget.',
    pacingStrategyLinear: 'linear',
    pacingStrategyLinearDescription: 'Linear pacing is best if your priority is to distribute your budget evenly across all available hours in the campaign, regardless of audience density and concentration.',
    pacingStrategyOptimized: 'optimized',
    pacingStrategyOptimizedDescription: 'Optimized pacing is best if your priority is to distribute your budget according to audience density and concentration, and to distribute spend evenly across weeks.',
    pacingVsEven: 'Pacing vs. Even',
    pacingVsExpected: 'Pacing vs. Expected',
    packageConvertedToLineitemSuccessfully: 'External DSP lineitem successfully created from deal',
    packageIDUseTheFollowingFormat: 'Format: \'SSP:DealID;\' For internal deals please use \'Hivestack\' or an empty field for SSP and for external deals use the external ssps name.',
    packageSavedSuccessfully: 'Package saved successfully.',
    pageAccessDenied: 'You don’t have the permissions to see this page.',
    parallelAuctionRequireTwoOrMoreSSPs: 'Parallel auctions require two or more SSPs.',
    passwordChangeError: 'password change error',
    passwordChanged: 'You have successfully changed your password',
    passwordEmptyError: 'Password cannot be empty',
    passwordMismatchError: 'Passwords do not match',
    passwordRequirements: 'Password Requirements',
    passwordRequirementsLength: 'At least 8 characters in length',
    passwordRequirementsVariety: 'Must contain all 4 of the following types of characters',
    passwordRequirementsVarietyLower: 'Lower case letters (a-z)',
    passwordRequirementsVarietyNumber: 'Digits (0-9)',
    passwordRequirementsVarietySymbol: 'Symbols',
    passwordRequirementsVarietyUpper: 'Upper case letters (A-Z)',
    passwordResetInstructions: 'Enter your email address to reset your password.',
    pastApprovalsAndRejections: 'past approvals & rejections',
    pausedCreativesDoNotAffectTheTotalWeight: 'Creative paused, weighting ignored.',
    perHour: 'per hour',
    perImpression: 'Per Impression',
    perPlay: 'Per Play',
    percentageOfBudgetDelivered: '% of budget delivered',
    percentageOfTotal: '% of total',
    percentagePacingBasedOnPacingStrategyAndDayparts: '% pacing based on pacing strategy and dayparts',
    percentagePacingForEvenBudgetDeliveryExcludingDayparts: '% pacing for even budget delivery excluding dayparts',
    permissionDenied: 'User not allowed to navigate to requested route according to permissions.',
    physicalScreenHeight: 'physical screen height',
    physicalScreenWidth: 'physical screen width',
    pickACountry: 'Pick a country',
    pickAType: 'Pick a type',
    pickOneOrMoreOptional: 'Pick one or more (optional)',
    placeVisitor: 'This category has been created based on the high intent of users visiting specific places of interest in the real world.',
    placesFound: 'places found',
    planCheckAvailsNotAvailableBecauseEndDateIsInThePast: 'Check avails is not available for plans which have already ended.',
    planSavedSuccessfully: 'Plan saved successfully',
    planStartDateCannotBeSetInThePast: 'The pkan start date cannot be set in the past.',
    plannedDeliveryAvailableIfTimezoneChanged: 'To see planned delivery select different timezone.',
    pleaseProvideAMeaningfulRejectionComment: 'Please provide a meaningful rejection comment.',
    pleaseSelectACampaignMarginNameForAllRows: 'Please select a line item margin name for all rows',
    pleaseSelectACampaignMarginTypeForAllRows: 'Please select a campaign margin type for all rows',
    pleaseSelectALanguage: 'Please select a language',
    pleaseSelectALiftAnalysis: 'Please select a lift analysis.',
    pleaseSelectALineItemMarginNameForAllRows: 'Please select a line item margin name for all rows',
    pleaseSelectALineItemMarginTypeForAllRows: 'Please select a line item margin type for all rows',
    pleaseSelectALocationFromTheTreeBelow: 'Please select a location from the tree below.',
    pleaseSelectAMonth: 'Please select a month',
    pleaseSelectARainAccumulationComparator: 'Please select a comparator for the rain accumulation',
    pleaseSelectAReportType: 'Please select a report type',
    pleaseSelectASSPForAllRows: 'Please select a SSP for all rows.',
    pleaseSelectASnowAccumulationComparator: 'Please select a comparator for the snow accumulation',
    pleaseSelectATemperatureLimitAndComparator: 'Please select a temperature limit and comparator.',
    pleaseSelectAYear: 'Please select a year',
    pleaseSelectAnAdvertiser: 'Please select an advertiser.',
    pleaseSelectAnAdvertiserForEachCreative: 'Please select an advertiser for each creative.',
    pleaseSelectAnExistingPlaceOrSpecifyYourOwn: 'Please select a place or specify your own name and description.',
    pleaseSelectAtLeastOneColumn: 'Please select at least one column.',
    pleaseSelectAtLeastOneWeatherCondition: 'Please select at least one weather condition.',
    pleaseSelectGeofence: 'Please select a geofence.',
    pleaseSelectNearbyGeofence: 'Please select a nearby geofence.',
    pleaseSelectedOneOrMoreScreensToAdd: 'Please select one or more screens to add in this pack.',
    pleaseSpecifyATargetRainAccumulation: 'Please select a target rain accumulation',
    pleaseSpecifyATargetSnowAccumulation: 'Please select a target snow accumulation',
    pleaseSpecifyATargetTemperature: 'Please specify a target temperature.',
    pleaseSpecifyAValidWeatherDestinationLocation: 'Please specify a valid weather destination location',
    pleaseSupplyOneOrMoreCampaignMarginValuesForAllRows: 'Please supply one or more campaign margin values for all rows.',
    pleaseSupplyOneOrMoreDealIDsForAllRows: 'Please supply one or more deal IDs for all rows.',
    pleaseSupplyOneOrMoreLineItemMarginValuesForAllRows: 'Please supply one or more line item margin values for all rows.',
    pleaseWaitWhileWeAreExportingYourPlan: 'Please wait while we are exporting your plan…',
    pleaseWaitWhileWeAreGettingYourDataReady: 'Please wait while we\'re getting your data ready...',
    pmpDeal: 'PMP deal',
    pollenTargeting: 'Pollen targeting',
    poweredBy: 'Powered by',
    preSaleHeatmapSavedSuccessfully: 'Proposal heatmap saved successfully',
    presaleHeatmapNameDescription: 'This is the name showing up in the proposal heatmap lists.',
    previouslyRanked: 'previously ranked',
    pricingStrategy: 'pricing strategy',
    priorityChangesMade: 'Changes made to a campaigns or line item priority will impact its delivery',
    priorityStateSet: 'Enabling or disabling priority will change your campaign or line item’s delivery',
    priorityTooltip: 'Prioritize a campaign or line item over others',
    processingFiles: 'Processing files...',
    profilePicture: 'profile picture',
    programmaticImpressionsDelivered: 'Programmatic impressions delivered',
    programmaticRevenue: 'Programmatic revenue',
    proposalGenerationFailed: 'Proposal generation failed.',
    purchaseIntent: 'This category has been created based on users’ shopping intent. We collect data from sources connected to the ecommerce sector and we also receive data connected to online transactions from affiliate networks.',
    radius: 'radius',
    randomUnit: 'random screen',
    reach: 'Total number of unique devices that are part of the segment',
    reachAndFrequency: 'Reach and Frequency',
    recommendedCreativeSize: 'Recommended creative size',
    recommendedCreativeSizes: 'Recommended creative sizes',
    recommendedCreativeSizesDescription: 'Breakdown of the recommended sizes by language and aspect ratio combination according to the inventory being targeted',
    refineYourDemographicsParameters: 'Please your refine your demographics parameters.',
    rejectedOn: 'Rejected on',
    relativeTimePeriodTemplate: 'Last {0}',
    relativeToDateOfProcessingByDMP: 'Relative to date of processing by DMP',
    remainingCampaignBudget: 'Remaining campaign budget',
    removeCreativeFileFromBulkUpload: 'Remove file',
    removePreviouslyAddedFilesToUploadCreatives: 'Remove all previously added files to start a new batch upload.',
    removeUnitsFromNetworkWarningModalDescription: 'Instead, you can add them to the network you want those units to be included in. This action will also remove them from this network.',
    removeUnitsFromNetworkWarningModalDetails: 'Because we require units to be part of a network, we could not remove the following units from the network:',
    removedUnsupportedMacros: 'Removed Unsupported Macros',
    reportDefinitionSavedSuccessfully: 'Report definition saved successfully.',
    reportDefinitionWarningWhenSelectingCreativeRelatedDimensions: 'WARNING! Selecting “Creative” or “Creative File” as a dimension will significantly increase the report generation time. Please refrain from selecting date ranges longer than a month.',
    reportEndDateMustBeGreaterThanReportStartDate: 'The report end date must be greater than the report start date.',
    reportExecutionSavedSuccessfully: 'Report saved successfully.',
    reportExecutionSchedule: 'report execution schedule',
    reportScheduleDescriptionDaily: 'daily at {0} starting on {1}.',
    reportScheduleDescriptionDailyUntil: 'daily at {0} starting on {1} until {2}.',
    reportScheduleDescriptionMonthOnFirstDayUntil: 'monthly on the first day of the month starting on {0} until {1}.',
    reportScheduleDescriptionMonthOnLastDayUntil: 'monthly on the last day of the month starting on {0} until {1}.',
    reportScheduleDescriptionMonthUntil: 'monthly on day {0} of the month starting on {1} until {2}.',
    reportScheduleDescriptionMonthly: 'monthly on day {0} of the month starting on {1}.',
    reportScheduleDescriptionMonthlyOnFirstDay: 'monthly on the first day of the month starting on {0}.',
    reportScheduleDescriptionMonthlyOnLastDay: 'monthly on the last day of the month starting on {0}.',
    reportScheduleDescriptionOneTime: 'one time on {0}.',
    reportScheduleDescriptionWeekly: 'weekly starting on {1} at {0}.',
    reportScheduleDescriptionWeeklyUntil: 'weekly starting on {1} at {0} until {3} at {2}.',
    requestBlockedByClient: 'Request blocked by browser',
    requestBlockedByClientDescription: 'It looks like the browser blocked us from reaching our API. Please make sure your ad blocker is disabled and try again.',
    requestTooLarge: 'Request too large',
    requestTooLargeDescription: 'Try reducing the number of filters.',
    requestedAnAdInTheLastHour: 'Requested an ad in the last hour',
    reservedSecondsIsMissing: 'The column \'reserved_seconds\' is missing.',
    restrictDealToSpecificBuyers: 'Restrict deal to specific buyers',
    resultsForCategories: 'Search results for categories',
    resultsForSegments: 'Search results for segments',
    revenuePercentSplit: 'Revenue Split',
    reviewChanges: 'Review changes',
    reviewSelection: 'Review selection',
    rightMargin: 'right margin',
    riskAverse: 'risk averse',
    riskSeeking: 'risk seeking',
    ruleShouldOnlyHaveOneId: 'Rule should only have one id (geofence, device id or external id)',
    runOn: 'run on',
    s3PathFieldIsRequired: 'S3 path field is required',
    s3PathURLIsInvalid: 'S3 path URL is invalid.',
    samplePlanName: 'Sample plan name',
    save: 'Save.',
    scheduleReportExecution: 'schedule report execution',
    scheduling: 'scheduling',
    screenAvailableReservedImpressions: 'screen available impressions - reserved',
    screenAvailableTotalImpressions: 'screen available impressions - total',
    screenAvailableUnreservedImpressions: 'screen available impressions - unreserved',
    screenBookedImpressionsBonus: 'screen booked impressions - bonus',
    screenBookedImpressionsCadenceBuy: 'screen booked impressions - cadence buy',
    screenBookedImpressionsGuaranteedDeals: 'screen booked impressions - guaranteed deals',
    screenBookedImpressionsGuaranteedLineItems: 'screen booked impressions - guaranteed line items',
    screenBookedImpressionsHouseAd: 'screen booked impressions - house ad',
    screenBookedImpressionsUnguaranteed: 'screen booked impressions - unguaranteed',
    screenCount: 'screen count',
    screenCreativeFileCompatibility: 'Screen-creative file compatibility',
    screenDistanceFromGeofenceCenterInMeters: 'screen distance from geofence center (meters)',
    screenIdVsUnitIdDefinition: 'Screen ID - Media owner’s screen ID<br>Unit ID - Hivestack unique screen ID',
    screenLineOfSightDrawingToolHelp: 'Lets you draw a polygon representing the geofence from which the screen can be seen.',
    screenLocationAndGeofence: 'Screen location and geofence',
    screenLocationCity: 'screen location (city)',
    screenMaxImpressionsCapacity: 'screen max impressions capacity',
    screenNetwork: 'screen network',
    screenOverbookedReservedImpressions: 'screen overbooked reserved impressions',
    screenRegion: 'screen region (state)',
    screenSizeApprovalNotRequiredDescription: 'Screen size approval is not required',
    screenTotalImpressions: 'screen total impressions',
    screensAtThisSite: 'screens at this site',
    screensBySites: 'Screens by sites',
    screensMatchYourSearch: 'screens match your search',
    screensMatchingYourSearch: 'screens matching your search',
    searchCampaignsDescription: 'Start typing to search campaigns.',
    searchCategories: 'Search categories',
    searchFields: 'Search fields',
    searchInNamesAndAddresses: 'Search in names & addresses',
    searchLineItems: 'Search line items',
    searchLineItemsDescription: 'Start typing to search line items.',
    searchOrAddEmailAddress: 'search or add email address',
    searchPackages: 'Search deals',
    searchPackagesDescription: 'Start typing to search deals.',
    searchPlaces: 'Search places',
    searchPlacesExample: 'e.g.: {0}',
    searchPlacesExampleBaidu: 'e.g.: Walmart in Beijing',
    searchingLocations: 'Searching locations...',
    seeOptimizedVersion: 'see optimized version',
    seenInTheLastHour: 'Seen in the last hour',
    segmentIsRequired: 'Selecting a segment is required',
    selectABuyer: 'Select a buyer',
    selectACampaign: 'Select a campaign',
    selectACampaignOrStartTypingToSearch: 'Select a campaign or start typing to search',
    selectACategory: 'Select a category',
    selectADiscountType: 'Select a discount type',
    selectAFormat: 'Select a format',
    selectAFreqCapPeriod: 'Select a frequency cap period',
    selectAGoal: 'Select a goal',
    selectAMediaTypeOrLeaveEmpty: 'Select a media type or leave empty',
    selectANetwork: 'Select a network',
    selectAPackage: 'Select a deal',
    selectAPurchaseType: 'Select a purchase type',
    selectARole: 'Select a role',
    selectASite: 'Select a site',
    selectATimezone: 'Select a timezone',
    selectAdvertisers: 'Select advertisers',
    selectAllItemsThatMatchThisSearch: 'Select all items that match this search',
    selectAnAccount: 'Select an account',
    selectAnAccountOptional: 'Select an account (optional)',
    selectAnAdvertiser: 'Select an advertiser',
    selectAtLeastOneItem: 'Select at least one item',
    selectByGeofenceGroup: 'by geofence group',
    selectByLocation: 'by location',
    selectCategories: 'Select categories',
    selectDSP: 'select a DSP',
    selectDate: 'Select a date',
    selectDateOrLeaveBlankToRunIndefinitely: 'select a date or leave blank to run indefinitely.',
    selectDates: 'Select dates',
    selectDimensions: 'select dimensions',
    selectExistingAdvertiser: 'Select existing advertiser',
    selectFacingDirection: 'select facing direction',
    selectGeofenceGroup: 'Select a geofence group',
    selectGeofenceGroupsPlaceholder: 'Select one or more geofence groups. (Targeting all locations if no selection)',
    selectIABCategories: 'Select IAB categories',
    selectItemsPerPage: 'Select items per page',
    selectLanguages: 'Select languages',
    selectLineItem: 'Select a line item',
    selectLineItemsToRetarget: 'select line items to retarget',
    selectMetrics: 'select metrics',
    selectOne: 'Select an option',
    selectOneOrMoreAudienceLogics: 'Choose one or more audiences.',
    selectOneOrMoreCreatives: 'Choose one or more creatives.',
    selectOneOrMoreGeofenceGroups: 'Choose one or more geofence groups.',
    selectOneOrMoreGeofences: 'Choose one or more geofences.',
    selectOneOrMoreLanguages: 'Select one or more languages',
    selectOneOrMoreLineItems: 'Select one or more line items.',
    selectOneOrMoreOptions: 'Select one or more options',
    selectOneOrMorePlaces: 'Select one or more places',
    selectOneOrMorePreSaleHeatmaps: 'Choose one or more proposal heatmaps.',
    selectOneOrMoreReportExecutions: 'Choose one or more report executions.',
    selectOneOrMoreSites: 'Choose one or more sites.',
    selectOneOrMoreTags: 'Select one or more tags',
    selectPlaceFromListOrSpecifyCustomNameAndDescription: 'Select a place from the following list or specify your own name and description.',
    selectPlaces: 'Select places',
    selectPreSaleHeatmap: 'select a proposal heatmap',
    selectStartAndEndDateToEnableEstimatedDeliveryStats: 'Pick a start and end date to enable estimated delivery stats.',
    selectStatuses: 'Select statuses...',
    sentPasswordResetEmail: 'An email to reset your password has been sent to you if the email you provided is linked to an account. Please follow the instructions in the email to reset your password.',
    serverDown: 'We\'re on it!',
    serverDownDescription: 'We are currently experiencing technical difficulties and are working to bring the platform back up as quickly as possible.',
    showAllTargetedScreens: 'Show all targeted screens',
    showAllTargetedSites: 'Show all targeted sites',
    showExpandedListOfLocationsToUser: 'show expanded list of locations to user',
    showScreenInformationInBidRequests: 'Show screen information in bid requests',
    showTrendExponential: 'Exponential Regression',
    showTrendFalse: 'None',
    showTrendLinear: 'Linear Regression',
    showTrendLogarithmic: 'Logarithmic Regression',
    showTrendPolynomial: 'Polynomial Regression',
    showTrendTrue: 'Rolling Average (beta)',
    siteAvailableReservedImpressions: 'site available impressions - reserved',
    siteAvailableTotalImpressions: 'site available impressions - total',
    siteAvailableUnreservedImpressions: 'site available impressions - unreserved',
    siteBookedImpressionsBonus: 'site booked impressions - bonus',
    siteBookedImpressionsCadenceBuy: 'site booked impressions - cadence buy',
    siteBookedImpressionsGuaranteedDeals: 'site booked impressions - guaranteed deals',
    siteBookedImpressionsGuaranteedLineItems: 'site booked impressions - guaranteed line items',
    siteBookedImpressionsHouseAd: 'site booked impressions - house ad',
    siteBookedImpressionsUnguaranteed: 'site booked impressions - unguaranteed',
    siteCanBeTargeted: 'Can be targeted',
    siteCanBeTargetedDescription: 'This defines if the site will be visible in the location tree when creating line items and deals.',
    siteDistanceFromGeofenceCenterInMeters: 'site distance from geofence center (meters)',
    siteDoesNotExist: 'The site does not exist.',
    siteHasAtLeastOneEnabledScreen: 'Site has at least one enabled screen',
    siteHasNoEnabledScreen: 'Site has no enabled screens',
    siteOverbookedReservedImpressions: 'site overbooked reserved impressions',
    siteSavedSuccessfully: 'Site saved successfully.',
    siteTotalImpressions: 'site max impressions capacity',
    sitesMatchYourSearch: 'sites match your search',
    sitesMatchingYourSearch: 'sites matching your search',
    skipSendingEmailsBody: 'Would you like to skip sending emails for this report execution?',
    skipSendingEmailsTitle: 'Skip sending emails',
    someColumnsAreMissing: 'Some columns are missing.',
    someRecordsHaveValidationErrorsAndWillNotBeSaved: 'Some records have validation errors and will not be saved.',
    someRowsFailedDataValidation: 'Some rows failed data validation.',
    somethingIsWrong: 'Something is wrong…',
    somethingWentWrong: 'Oops, something went wrong.',
    somethingWentWrongDescription: 'Something went wrong, please refresh the page or try again later.',
    sorryAnErrorOccured: 'Sorry, an error occurred',
    spotLength: 'default ad duration',
    sspDomainsMustBeUnique: 'SSP domains must be unique, you currently have an existing record with the same domain.',
    startDateUTC: 'start date - UTC',
    startTypingToFilter: 'Start typing to filter',
    startTypingToSearch: 'Start typing to search',
    startTypingToSearchForAdvertisers: 'Start typing to search advertisers…',
    startTypingToSearchLocations: 'Start typing to search locations.',
    startTypingToSearch_3charactersMinimum: 'Start typing to search (3 characters minimum)',
    startedOn: 'Started on',
    startingFromScratchDownloadATemplate: 'Starting from scratch? Download a template',
    startsOn: 'starts on',
    startsWith: 'starts with',
    statsLastRefreshedOn: 'Stats last refreshed on',
    statsLastRefreshedOnUTC: 'stats last refreshed on - UTC',
    strict: 'strict',
    strictBlocking: 'strict blocking',
    strictFrequencyCapping: 'strict frequency capping',
    strictFrequencyCappingExplaination: 'Frequency capping will be enforced when no IAB category is specified for a creative, or its parent category matches blocked categories but no sub-category is specified.',
    strictIABCategoryBlocking: 'Strict IAB category blocking',
    strictIABCategoryBlockingExplaination: 'Blocking will be enforced when no IAB category is specified for a creative, or its parent category matches blocked categories but no sub-category is specified.',
    strictIABFrequencyCapping: 'Strict IAB frequency capping',
    submittedBy: 'Submitted by',
    submittedOn: 'Submitted on',
    successfullyResetPassword: 'Your password has been reset',
    successfullyVerifiedEmail: 'Successfully verified your email',
    supportedContent: 'supported content',
    syncToDV360Tooltip: 'Deactivating a screen pack will delete the associated DV360 product on DV360’s side.',
    syncWithSpreadsheet: 'Sync with spreadsheet',
    tablePlaceholderNoAudienceFilesDescription: '',
    tablePlaceholderNoAudienceFilesTitle: 'Looks like there are no audience files here.',
    tablePlaceholderNoAudienceGeofenceGroupsDescription: 'Audience geofence groups allow you to geography target audiences.',
    tablePlaceholderNoAudienceGeofenceGroupsTitle: 'Looks like there are no geofence groups here.',
    tablePlaceholderNoAudienceLogicsDescription: 'Audiences allow you to geography target audiences.',
    tablePlaceholderNoAudienceLogicsTitle: 'Looks like there are no audiences here.',
    tablePlaceholderNoAvailsFilesDescription: 'Upload your available impressions, guaranteed or unguaranteed to ensure that you always have the necessary reserves when creating a programmatic guaranteed line item or deals.',
    tablePlaceholderNoAvailsFilesTitle: 'Access programmatic guaranteed, free of headaches',
    tablePlaceholderNoCampaignsDescription: 'You\'ll need a campaign to start scheduling content.',
    tablePlaceholderNoCampaignsTitle: 'Looks like there are no campaigns here.',
    tablePlaceholderNoCreativeFilesDescription: 'Files need to be associated to your creative in order to fit on the different screen sizes.',
    tablePlaceholderNoCreativeFilesTitle: 'Looks like there are no creative files here.',
    tablePlaceholderNoCreativeTrackingUrlsDescription: 'Creative tracking URLs are called whenever the creative is displayed on a screen.',
    tablePlaceholderNoCreativeTrackingUrlsTitle: 'Looks like there are no tracking URLs here.',
    tablePlaceholderNoCreativesDescription: 'Creatives need to be assigned to line items so that they can be broadcasted to the screens.',
    tablePlaceholderNoCreativesMobileLineItemDescription: 'Creatives need to be linked to this mobile line item in order for it to be played.',
    tablePlaceholderNoCreativesTitle: 'Looks like there are no creatives here.',
    tablePlaceholderNoCustomEventsDescription: 'Create and populate your own events to get real-time rule based triggering. You can create rules for individual screens, sites, a location or for your organization as a whole. It’s up to you.',
    tablePlaceholderNoCustomEventsTitle: 'Enhance your line item triggering capabilities',
    tablePlaceholderNoDealsDescriptionDemandSize: 'No deals matching your search filters could be found. If you are expecting to see something here contact the media owner and ask them to make sure the deal is published.',
    tablePlaceholderNoDealsDescriptionSupplySide: 'Deals are a way to package part of your inventory at special rates.',
    tablePlaceholderNoDealsDescriptionSupplySideDemandSize: 'If you expect to see a particular deal available to you, it could be that the deal has not been published yet.',
    tablePlaceholderNoDealsTitleDemandSize: 'No deals available.',
    tablePlaceholderNoDealsTitleSupplySide: 'Looks like there are no deals here.',
    tablePlaceholderNoDealsTitleSupplySideDemandSize: 'Looks like there are no deals available.',
    tablePlaceholderNoExternalCreativesDescription: 'External creatives are created when an external DSP responds to a bid request with an unknown creative, they can also be created manually by users of the SSP in order to pre-approve them.',
    tablePlaceholderNoExternalCreativesTitle: 'Looks like there are no external creatives here.',
    tablePlaceholderNoExternalEventsDescription: '',
    tablePlaceholderNoExternalEventsTitle: 'Looks like there are no external events here.',
    tablePlaceholderNoJourneyAnalysesDescription: 'Journey analysis are used to target audiences during their commute for example.',
    tablePlaceholderNoJourneyAnalysisTitle: 'Looks like there are no journey analysis here.',
    tablePlaceholderNoLiftDashboardsDescription: 'Lift analyses allow you to visualize the impact your campaign had on the number of visits on a defined set of points of interest.',
    tablePlaceholderNoLiftDashboardsTitle: 'Looks like there are no lift analyses here.',
    tablePlaceholderNoLineItemsDemandSideDescription: 'Line items are required to run your campaigns, they define the dates, budget, demographics and location you\'d like to target.',
    tablePlaceholderNoLineItemsDemandSideTitle: 'Looks like there are no line items here.',
    tablePlaceholderNoLineItemsForAudienceLogicDescription: 'No line items are using this custom audience.',
    tablePlaceholderNoLineItemsForAudienceLogicTitle: 'No line items here',
    tablePlaceholderNoLineItemsSupplySideDescription: 'It seems your clients have not created line items yet.',
    tablePlaceholderNoLineItemsSupplySideTitle: 'Looks like there are no line items here.',
    tablePlaceholderNoMarginsTitle: 'Looks like there are no margins here.',
    tablePlaceholderNoMatchingAudienceFilesTitle: 'No audience files match your filters.',
    tablePlaceholderNoMatchingAudienceLogicsTitle: 'No audiences match your filters.',
    tablePlaceholderNoMatchingAvailsFileTitle: 'No avails file match your filters.',
    tablePlaceholderNoMatchingCampaignsTitle: 'No campaigns match your filters.',
    tablePlaceholderNoMatchingCreativeFilesTitle: 'No creative files match your filters.',
    tablePlaceholderNoMatchingCreativeTrackingUrlsTitle: 'No creative tracking URLs match your filters.',
    tablePlaceholderNoMatchingCreativesTitle: 'No creatives match your filters.',
    tablePlaceholderNoMatchingCustomEventsTitle: 'No custom events match your filters.',
    tablePlaceholderNoMatchingDealsTitle: 'No deals match your filters.',
    tablePlaceholderNoMatchingExternalCreativesTitle: 'No creatives match your filters.',
    tablePlaceholderNoMatchingGeofenceGroupsTitle: 'No geofence groups match your filters.',
    tablePlaceholderNoMatchingGeofencesTitle: 'No geofences match your filters.',
    tablePlaceholderNoMatchingItemsDescription: 'Try changing or removing some of your filters.',
    tablePlaceholderNoMatchingJourneyAnalysisTitle: 'No journeys match your filters.',
    tablePlaceholderNoMatchingLiftDashboardsTitle: 'No lift analyses match your filters.',
    tablePlaceholderNoMatchingLineItemsTitle: 'No line items match your filters.',
    tablePlaceholderNoMatchingMarginsTitle: 'No margins match your filters.',
    tablePlaceholderNoMatchingMobileLineItemsTitle: 'No mobile line items match your filters.',
    tablePlaceholderNoMatchingNetworksTitle: 'No networks match your filters.',
    tablePlaceholderNoMatchingOrganizationCustomFieldsTitle: 'No custom fields match your filters.',
    tablePlaceholderNoMatchingPlansTitle: 'No plans match your filters.',
    tablePlaceholderNoMatchingPreSaleHeatmapsTitle: 'No proposal heatmaps match your filters.',
    tablePlaceholderNoMatchingReportDefinitionsTitle: 'No report definitions match your filters.',
    tablePlaceholderNoMatchingReportExecutionsTitle: 'No generated reports match your filters.',
    tablePlaceholderNoMatchingSSPsTitle: 'No SSPs match your filters.',
    tablePlaceholderNoMatchingSitesTitle: 'No sites match your filters.',
    tablePlaceholderNoMatchingUnitPacksTitle: 'No packs match your filters.',
    tablePlaceholderNoMatchingUnitsTitle: 'No screens match your filters.',
    tablePlaceholderNoMatchingUsersDescription: 'No users match your filters.',
    tablePlaceholderNoMobileCreativesTitle: 'Looks like there are no mobile creatives here.',
    tablePlaceholderNoMobileLineItemsDescription: 'Mobile line items are used to retarget those exposed to one or multiple line items.',
    tablePlaceholderNoMobileLineItemsTitle: 'No mobile line items.',
    tablePlaceholderNoNetworksDescription: '',
    tablePlaceholderNoNetworksTitle: 'Looks like there are no networks here.',
    tablePlaceholderNoOrganizationCustomFieldsDescription: 'Custom fields allow you to capture additional information for campaigns, line items and deals.',
    tablePlaceholderNoOrganizationCustomFieldsTitle: 'Looks like there are no custom fields here.',
    tablePlaceholderNoPendingApprovalsForCreativesDescription: 'Pending approvals will appear here whenever your clients submit creatives.',
    tablePlaceholderNoPendingApprovalsForCreativesTitle: 'You\'re all done.',
    tablePlaceholderNoPendingApprovalsForExternalCreativesDescription: 'Pending approvals will appear here whenever DSPs bid with new creatives.',
    tablePlaceholderNoPendingApprovalsForExternalCreativesTitle: 'You\'re all done.',
    tablePlaceholderNoPendingApprovalsForFallbackCreativesDescription: 'Pending approvals will appear here whenever fallback creatives are submitted.',
    tablePlaceholderNoPendingApprovalsForFallbackCreativesTitle: 'You\'re all done.',
    tablePlaceholderNoPendingApprovalsForLineItemsDescription: 'Pending approvals will appear here whenever your clients submit line items or buy deals.',
    tablePlaceholderNoPendingApprovalsForLineItemsTitle: 'You\'re all done.',
    tablePlaceholderNoPlansDescription: 'Looks like there are no plans here.',
    tablePlaceholderNoPlansTitle: 'No plans',
    tablePlaceholderNoPreSaleHeatmapsDescription: 'Proposal heatmaps provide a simulation of the delivery including previously created geofence groups, they can be easily shared with your client.',
    tablePlaceholderNoPreSaleHeatmapsTitle: 'Looks like there are no proposal heatmaps here.',
    tablePlaceholderNoProximityGeofenceGroupsDescription: 'Proximity geofence groups allow you to target screens around points of interest or within polygons.',
    tablePlaceholderNoProximityGeofenceGroupsTitle: 'Looks like there are no proximity geofence groups here.',
    tablePlaceholderNoReportDefinitionsDescription: 'Report definitions are a great way to look at your delivery data.',
    tablePlaceholderNoReportDefinitionsTitle: 'Looks like there are no report definitions here.',
    tablePlaceholderNoReportExecutionsDescription: 'Generated reports will show up here when you run report definitions.',
    tablePlaceholderNoReportExecutionsTitle: 'Looks like there are no generated reports here.',
    tablePlaceholderNoSSPsDescription: 'You\'ll need to add SSPs before you can setup your optimization pipeline.',
    tablePlaceholderNoSSPsTitle: 'Looks like there are no SSPs here.',
    tablePlaceholderNoScreenSizeApprovalsTitle: 'No screen sizes pending approval.',
    tablePlaceholderNoSitesDescription: '',
    tablePlaceholderNoSitesTitle: 'Looks like there are no sites here.',
    tablePlaceholderNoUnitPacksTitle: 'Screen Packs is a new way to sell your inventory',
    tablePlaceholderNoUnitsDescription: 'This feature empowers you to create groupings of screens that buyers can target or that you can use to create deals against. Finally, a screen can be in multiple packs at the same time allowing you to package your inventory in more flexible ways than ever.',
    tablePlaceholderNoUnitsTitle: 'Looks like there are no screens here.',
    tablePlaceholderYieldManagerNoBidsDescription: 'No bid statistics could be found for the specified time period.',
    tablePlaceholderYieldManagerNoBidsTitle: 'No bids',
    targetImpressionsAreExceedingTheTotalCapacity: 'Impressions are exceeding the total capacity.',
    targetImpressionsLowerThanDeliveredImpressions: 'Can\'t save Lineitem due to the fact that the number of impressions delivered is greater than the target goal.',
    targetRainAccumulation: 'Target rain accumulation',
    targetSnowAccumulation: 'Target snow accumulation',
    targetTemperature: 'target temperature',
    targetWeatherConditions: 'target specific weather conditions',
    targetedCadence: 'targeted cadence',
    targetedCadenceTooltip: 'The cadence that was input by the user during LI creation.',
    targeting: 'targeting',
    templateFileIsOutdated: 'Your uploaded file seems to be outdated. You can download the newer version by clicking on the download button below. It will contain all of the entered information from the uploaded file.',
    theBudgetCapCannotBeLowerThanTheSumOfAllLineItemBudgets: 'The budget cap cannot be lower than the sum of all line item budgets.',
    theCampaignBudgetHasAlreadyBeenExceeded: 'The campaign budget has already been exceeded.',
    theCampaignBudgetHasNotBeenFullyAllocated: 'The campaign budget has not been fully allocated.',
    theColumnContainsUnsupportedValues: 'The column contains unsupported values',
    theCreativeWouldHaveToConformToTheFollowingLanguage: 'The creative would have to conform to the following language',
    theFollowingRowsContainErrors: 'The following rows contain errors:',
    theLanguagesFieldIsMandatory: 'The Languages field is mandatory.',
    theLineItemBudgetExceedsTheRemainderOfTheCampaignBudgetCap: 'The line item budget exceeds the remainder of the campaign budget cap.',
    theLineItemBudgetExceedsTheRemainingCampaignBudget: 'The line item budget exceeds the remaining campaign budget.',
    theLocationBeingAdvertised: 'The location being advertised',
    thisCouldTakeSomeTime: 'This could take some time, you can monitor the status of your changes by using the progress indicator in the lower left corner of the application.',
    thisCreativeWillBeEligibleDuringTheFollowingForecastedWeatherConditions: 'This creative will be active when the forecast weather conditions in the next 9 to 12 hours match the selected conditions.',
    thisCreativeWillBeEligibleWhenTheForecastedTemperatureMatchesTheExpressionBelow: 'This creative will be eligible when the forecasted temperature matches the expression below',
    thisCreativeWillBeEligibleWhenTheRainAccumulationForTheLast12HoursMatchesTheExpressionBelow: 'This creative will be eligible when the rain accumulation for the last 12 hours matches the expression below',
    thisCreativeWillBeEligibleWhenTheSnowAccumulationForTheLast12HoursMatchesTheExpressionBelow: 'This creative will be eligible when the snow accumulation for the last 12 hours matches the expression below',
    thisDealWillBeActiveDuringTheFollowingForecastedWeatherConditions: 'This deal will be active during when the forecast weather conditions in the next 9 to 12 hours match the selected conditions.',
    thisDealWillBeActiveWhenTheForecastedRainAccumulationMatchesTheExpressionBelow: 'This deal will be active when the forecasted rain accumulation matches the expression below.',
    thisDealWillBeActiveWhenTheForecastedSnowAccumulationMatchesTheExpressionBelow: 'This deal will be active when the forecasted snow accumulation matches the expression below.',
    thisDealWillBeActiveWhenTheForecastedTemperatureMatchesTheExpressionBelow: 'This deal will be active when the forecasted temperature matches the expression below',
    thisDealWillBeActiveWhenTheRainAccumulationMatchesTheExpressionBelow: 'This deal will be active when the rain accumulation for the last 12 hours matches the expression below',
    thisDealWillBeActiveWhenTheSnowAccumulationMatchesTheExpressionBelow: 'This deal will be active when snow accumulation for the last 12 hours matches the expression below',
    thisFilterIsReadOnly: 'This filter is read-only',
    thisIsACustomCadenceThatMayNotBeOptimzed: 'This is a custom cadence that may not be optimized.',
    thisItemWillNotBeSavedAsThereAreOneOrMoreValidationErrors: 'This item will not be saved as there are one or more validation errors.',
    thisLineItemHasInfiniteBudgetAndIsPartOfACampaigManagingTheBudget: 'This line item has unlimited budget and is part of a campaign managing the budget.',
    thisLineItemIsPartOfACampaigManagingTheBudget: 'This line item is part of a campaign managing the budget.',
    thisLineItemWillBeActiveDuringTheFollowingPollenConditions: 'This line item will be active during the following pollen conditions.',
    thisLineItemWillBeActiveDuringTheFollowingSelectedPollenConditions: 'This line item will be active during the following selected pollen conditions.',
    thisLineItemWillBeActiveDuringTheFollowingSelectedUVConditions: 'This line item will be active during the following selected UV conditions.',
    thisLineItemWillBeActiveDuringTheFollowingWeatherConditions: 'This line item will be active during when the forecast weather conditions in the next 9 to 12 hours match the selected conditions.',
    thisLineItemWillBeActiveWhenTheRainAccumulationMatchesTheExpressionBelow: 'This line item will be active when the rain accumulation for the last 12 hours matches the expression below',
    thisLineItemWillBeActiveWhenTheSnowAccumulationMatchesTheExpressionBelow: 'This line item will be active when snow accumulation for the last 12 hours matches the expression below',
    thisLineItemWillBeActiveWhenTheTemperatureMatchesTheExpressionBelow: 'This line item will be active when the forecasted temperature matches the expression below',
    thisLineItemWouldPlayVeryOftenWhichMayCauseProblemsWithPlayout: 'This line item would play very often, which may cause problems with playout',
    thisNumberWouldIncreaseTo: 'This number would increase to',
    thisReportDefinitionIsLockedAndCannotBeEdited: 'This report definition is locked and cannot be edited.',
    thisSettingCanLongerBeChangedBecauseTheLineItemHasAlreadyDeliveredImpressions: 'This setting can no longer be changed because the line item has already delivered impressions.',
    thisViewOnlyShowsActiveScreens: 'This view only shows active screens.',
    thisWillIncreaseTheLineItemEffectiveCPM: 'This will incur a CPM increase.',
    timezone: 'timezone',
    tooManyItemsToDisplay: 'Too many items to display.',
    topLeftLogoSettings: 'top left logo settings',
    topMargin: 'top margin',
    topRightLogoSettings: 'top right logo settings',
    totalAvailableImpressions: 'Total available impressions',
    totalDailyCapAmount: 'total daily cap amount',
    totalDailyCapImpressions: 'total daily cap impressions',
    totalImpressionCapacity: 'total impression capacity',
    totalImpressionsOverbooked: 'Only contains available impressions. Therefore, it doesnt contain overbooked impressions.',
    totalPlaysTooltip: 'How many times the LI actually played',
    totalReservedAvailableImpressions: 'Reserved available impressions',
    totalUnreservedAvailableImpressions: 'Unreserved available impressions',
    totalWalkins: 'Total Walk-ins',
    trend: 'Analysis',
    triggerLineItemsBasedOn: 'Trigger line items based on',
    truBidAutopilot: 'TruBid™ uses the right balance between the risk averse agent and the risk seeking agent in order to deliver the maximum of impressions at the lowest cost.',
    truBidRiskAverse: 'The risk averse agent will adopt a safe strategy in order to guarantee the delivery of the target impressions, but it will do so at the cost of a higher CPM.',
    truBidRiskSeeking: 'The risk seeking agent will do it absolute best to minimize the CPM, however the risk of under-delivering impressions is much higher.',
    tryChangingTheDateRange: 'Try changing your date range.',
    typeToSearch: 'Type to search',
    unableToGetAvailabilities: 'Unable to get availabilities',
    uniqueLineItem: 'Unique line item',
    unitFloorCPMDescription: 'Line items created from the ad server without a CPM will use this as the default CPM',
    unitPackSavedSuccessfully: 'Unit pack saved successfully.',
    unitSavedSuccessfully: 'Screen saved successfully.',
    unitUUID: 'ad request API UUID',
    unitsAreMissingAudienceData: 'screens are missing audience data.',
    unknownAccount: 'Unknown Account',
    unknownDeal: 'Unknown Deal',
    unknownError: 'Unknown error.',
    unsupportedFileFormat: 'unsupported file format.',
    unsupportedVideo: 'Unsupported video',
    upNext: 'Up next',
    upcomingReportExecutions: 'upcoming report executions',
    updateCadence: 'update cadence',
    updateGoal: 'update goal',
    updateOrCreateGeofenceGroupCopy: 'Warning! This geofence group is used by one or more line items. Would you like to update it or create a copy?',
    updateSelectedScreens: 'Update selected screens',
    updateUsingCurrentViewport: 'update using current viewport',
    updatedSuccessfully: 'updated successfully',
    updatingCampaigns: 'Updating campaigns...',
    updatingCampaignsFailed: 'Updating campaigns failed.',
    updatingCreatives: 'Updating creatives...',
    updatingCreativesFailed: 'Updating creatives failed.',
    updatingDeals: 'Updating deals...',
    updatingDealsFailed: 'Updating deals failed.',
    updatingLineItems: 'Updating line items...',
    updatingLineItemsFailed: 'Updating line items failed.',
    updatingMap: 'updating map',
    updatingScreens: 'Updating screens...',
    updatingScreensFailed: 'Updating screens failed.',
    updatingSites: 'Updating sites...',
    updatingSitesFailed: 'Updating sites failed.',
    updatingUnitPacks: 'Updating unit packs…',
    updatingUnitPacksFailed: 'Updating unit packs failed.',
    updatingUnits: 'Updating screens...',
    updatingUnitsFailed: 'Updating screens failed.',
    uploadAListOfScreenIDsOrUnitIDs: 'Upload a list of screen IDs or unit IDs',
    uploadAListOfSiteIDs: 'Upload a list of site IDs',
    uploadAvails: 'Upload Avails',
    uploadAvailsCSVFile: 'Upload a CSV file containing a list of availablities.',
    uploadFiles: 'upload files',
    uploadLocationsCSVFile: 'Upload a CSV or Excel file containing a list of places.',
    uploadPlacesInstructions: 'Note that you can leave the latitude and longitude fields blank if you are providing an address, and vice versa.',
    uploadScreensCSVFile: 'Upload a CSV or Excel file containing a list of screen IDs or unit IDs.',
    uploadSitesCSVFile: 'Upload a CSV or Excel file containing a list of site IDs.',
    uploadTheSpreadsheet: 'Upload the spreadsheet.',
    uploadingFiles: 'uploading files',
    urlIsRequired: 'URL is required.',
    useCustomIcon: 'use a custom icon',
    useLegacyReportGeneration: 'Use legacy report generation',
    useMySQLRatherThanRedshift: 'Use MySQL rather than Redshift',
    useStartsOn: 'use “starts on” ({0})',
    userCreatedSuccessfully: 'User created successfully',
    userUpdatedSuccessfully: 'User updated successfully',
    usersDeletedSuccessfully: 'Users deleted successfully',
    uvTargeting: 'UV targeting',
    validateLineItemInformation: 'Validate line item information.',
    validatingData: 'Validating data…',
    validatingFile: 'Validating file…',
    validationErrors: 'Validation errors',
    validationFailed: 'Validation failed',
    valuesInThisColumnCanBeEditedInline: 'Values in this column can be edited inline.',
    vastURLEditorPlaceholder: 'http://hivestack.com/?uuid=[UUID] ...',
    veryHighlyConcentrated: 'very highly concentrated',
    video: 'video | videos',
    videoFileCannotBePlayed: 'Video file "{0}" cannot be played, this could be due to the way it was encoded.',
    viewDetails: 'view details',
    viewErrorReport: 'View error report',
    viewOnMap: 'view on map',
    visibility: 'visibility',
    visibleInMarketplaceEndDate: 'visible in marketplace until',
    visibleInMarketplaceStartDate: 'visible in marketplace from',
    visibleToBuyers: 'visible to buyers',
    visibleToBuyersFrom: 'Visible to buyers from',
    warnAboutDeletingCustomAudienceWithLineItemData: 'Please remove the following custom audiences from being targeted in any line item before deleting them:',
    warnAboutUncompletedBackgroundOperations: 'It looks like some background operations have yet to complete. If you leave before saving, your changes will be lost.',
    warnAboutUnitsWithoutCustomAudienceData: 'Some of the screens you are targeting do not have custom audience data available, processing the data could take up to a few days.',
    weatherTargeting: 'weather targeting',
    whatAreTheDimensionsOfTheCreativeReturnedByTheVAST: 'What are the dimensions of the creative file returned by the VAST?',
    whatAreTheDimensionsOfTheHTMLFile: 'What are the dimensions of the HTML file?',
    whatAreTheDimensionsOfTheZipFile: 'What are the dimensions of the Zip file?',
    whereTheScreenIsLocated: 'Where the screen is located',
    willHideScreenInformationInBidRequests: 'Will hide screen information in bid requests',
    willShowScreenInformationInBidRequests: 'Will show screen information in bid requests',
    withinTheLast: 'within the last',
    withinTheLastTimePeriod: 'within the last  {0} {1}',
    wouldYouLikeToContinue: 'Would you like to continue?',
    wouldYouLikeToImportTheValidRows: 'Would you still like to import the valid rows',
    xIfTheCreativeLanguageIsY: '{0} if the creative language is {1}.  ({2} of total)',
    xIsTheTopRecommendedCreativeSizeToUpload: '{0} is the top recommended creative size to upload',
    xOutOfYItemsOnThisPageAreSelected: '{0} out of {1} items on this page are selected.',
    xOutOfYRecordsCouldNotBeUpdated: '{0} out of {1} records could not be updated.',
    xResultsFound: '{0} results found',
    xScreensFromThisMediaOwnerAreActivelyTargeted: '{0} screens from this media owner are being actively targeted.',
    xScreensWereFoundWithinYourGeofences: '{count} screens were found within your geofences.',
    yieldManager: 'yield manager',
    yieldManagerDashboard: 'Yield Manager Dashboard',
    yieldOptimization: 'yield optimization',
    youAreTargetingAMediaOwnerThatCannotBeBoughtViaTheOpenExchange: 'You are targeting a media owner that cannot be bought via the open exchange',
    youDoNotHaveAccessToSomeOfTheTargetingInformation: 'You do not have access to some of the targeting information.',
    youMustSelectAMininumOfOneNetwork: 'You must select a minimum of one network.',
    youShouldHaveReceivedAnEmailDescribingTheModificationsThatWerePerformed: 'You should have received an email describing the modifications that were performed.',
    youWillNotBeAbleToChangeThisSettingOnceTheLineItemStartsDeliveringImpressions: 'You will not be able to change this setting once the line item starts delivering impressions.',
    youWillReceiveAnEmailOnceTheModificationsAreCompleted: 'You will receive an email once they the modifications are completed.',
    youWouldGetAccessToAnAdditionalXImpressions: 'You would get access to an additional {0} impressions. ({1} of total)',
    yourCadenceDoesNotMatchYourLatestTargetingRequirements: 'Your cadence does not match your latest targeting requirements, please update it before saving',
    yourCadenceIsNoLongerOptimizedForTheTargetingYouSelected: 'Your cadence is no longer optimized for the targeting you selected. We\'ll advise you again before saving your line item',
    yourChangesAreBeingApplied: 'Your changes are being applied.',
    yourChangesHaveBeenApplied: 'Your changes have been applied.',
    yourChangesHaveBeenFailed: 'Your changes failed to apply.',
    yourCreativeWasRejectedWithTheFollowingComments: 'Your creative was rejected with the following comments',
    yourCustomAudienceDataIsNotYetReady: 'Your custom audience is not yet ready.',
    yourCustomAudienceDataIsOnlyPartiallyReady: 'Your custom audience is only partially ready.',
    yourCustomAudienceDataIsReady: 'Your custom audience data is ready',
    yourGoalIsNoLongerOptimizedForTheTargetingYouSelected: 'Your goal is no longer optimized for the targeting you selected. We\'ll advise you again before saving.',
    yourLineItemWasRejectedWithTheFollowingComments: 'Your line item was rejected with the following comments',
    yourPrivateDeals: 'Your private deals',
    zip: 'ZIP',
    zipArchive: 'Zip archive',
    zipFileUpload: 'Zip file upload',
    zipToolTip: 'This feature cannot be used in combination with our Chameleon file'
  },
  names: {
    account: 'Account',
    action: 'action | actions',
    activated: 'activated',
    active: 'active',
    adDuration: 'ad duration | ad durations',
    adDurationMax: 'maximum ad duration | maximum ad durations',
    adDurationMin: 'minimum ad duration | minimum ad durations',
    adExchange: 'ad exchange | ad exchanges',
    adRequest: 'ad request | ad requests',
    adRequestHealthCheck: 'Ad request health check | Ad request health checks ',
    adServer: 'ad server | as servers',
    adServerCampaign: 'ad server campaign | ad server campaigns',
    adSpend: 'ad spend | ads spend',
    addRequest: 'add request | add requests',
    additionalBehavioralTargeting: 'behavioral targeting | behavioral targetings',
    additionalSize: 'additional size | additional sizes',
    advancedReport: 'advanced report | advanced reports',
    advancedSetting: 'advanced setting | advanced settings',
    advertiser: 'advertiser | advertisers',
    advertiserDomainName: 'advertiser domain name | advertiser domain names',
    advertiserFrequencyCap: 'advertiser frequency cap | advertiser frequency caps',
    age: 'age | ages',
    ageGroup: 'age group | age groups',
    all: 'all | all',
    allowHTML: 'allow HTML | allow HTML',
    allowImage: 'allow Image | allow Images',
    allowVideo: 'allow Video | allow Videos',
    allowZip: 'Allow ZIP',
    allowedContent: 'allowed content | allowed content',
    allowedLanguage: 'allowed language | allowed languages',
    allvision: 'AllVision billing',
    apiKey: 'API key | API keys',
    appCategory: 'app category | app categories',
    appDomain: 'app domain | app domains',
    approval: 'approval | approvals',
    aspectRatio: 'aspect ratio | aspect ratios',
    auctionType: 'auction type | auction types',
    audience: 'audience | audiences',
    audienceFile: 'audience file | audience files',
    audienceGeofence: 'audience geofence | audience geofences',
    audienceGeofenceGroup: 'audience geofence group | audience geofence groups',
    audienceImpression: 'audience impression | audience impressions',
    audienceLogic: 'custom audience | custom audiences',
    audienceRule: 'rule | rules',
    audienceSegment: 'audience segment | audience segments',
    audio: 'audio',
    auditTrail: 'audit trail | audit trails',
    availability: 'availability | availabilities',
    availableFrom: 'available starting | available starting',
    availableImpression: 'available impression | available impressions',
    availablePredefinedSegmentInCategory: 'available predefined segment in this category | available predefined segments in this category',
    availableTo: 'available until | available until',
    availsFileID: 'Avails FileID | Avails File IDs',
    availsImport: 'avails Import | avails Imports',
    availsResults: 'avails result | avails results',
    average: 'average | averages',
    averageCPM: 'average CPM | average CPMs',
    averageResponseTime: 'average response time | average response times',
    banner: 'banner | banners',
    bid: 'bid | bids',
    bidRate: 'bid rate | bid rates',
    bidRequest: 'bid request | bid requests',
    bidResponse: 'bid response | bid responses',
    blockedAdvertiser: 'blocked advertiser | blocked advertisers',
    blockedCategory: 'blocked category | blocked categories',
    blockedIABCategory: 'blocked IAB category | blocked IAB categories',
    brand: 'brand | brands',
    brandShopper: 'brand shopper | brand shoppers',
    breakdown: 'breakdown | breakdowns',
    budget: 'budget | budgets',
    budgetCap: 'budget cap | budget caps',
    budgetMax: 'maximum budget | maximum budgets',
    budgetMin: 'minimum budget | minimum budgets',
    buyer: 'buyer | buyers',
    buyerCampaign: 'buyer campaign | buyer campaigns',
    buyerRestriction: 'buyer restriction | buyer restrictions',
    buyingPlatform: 'buying platform | buying platforms',
    cadence: 'cadence | cadences',
    campaign: 'campaign | campaigns',
    campaignCustomField: 'campaign custom field | campaign custom fields',
    campaignFrequencyCap: 'campaign frequency cap | campaign frequency caps',
    campaignID: 'campaign ID | campaign IDs',
    campaignType: 'campaign type | campaign types',
    cappedImpression: 'capped impression | capped impressions',
    category: 'category | categories',
    categoryName: 'category name | category names',
    change: 'change | changes',
    chart: 'chart | charts',
    city: 'city | cities',
    code: 'code | codes',
    column: 'column | columns',
    columnsOrder: 'column order | column orders',
    comment: 'comment | comments',
    companionAd: 'companion ad | companion ads',
    companionAdGroupName: 'group name | group names',
    companionAdOrder: 'position | positions',
    concentration: 'concentration | concentrations',
    concentrationLevel: 'concentration level | concentration levels',
    confirmPassword: 'confirm password',
    contendingLineitem: 'contending line item | contending line items',
    content: 'content | contents',
    control: 'control | controls',
    coordinate: 'coordinate | coordinates',
    country: 'country | countries',
    coveredScreenSize: 'covered screen size | covered screen sizes',
    cpm: 'CPM | CPMs',
    createdOn: 'date created',
    creative: 'creative | creatives',
    creativeApproval: 'creative approval | creative approvals',
    creativeDimension: 'creative dimension | creative dimensions',
    creativeFile: 'creative file | creative files',
    creativeFormat: 'creative format | creative formats',
    creativeFormatExclusion: 'creative format exclusion | creative format exclusions',
    creativeID: 'creative ID | creative IDs',
    creativeRecommandation: 'creative recommandation | creative recommandations',
    creativeRejection: 'creative Rejection | creative rejections',
    creativeSize: 'creative size | creative sizes',
    creativeTrackingUrl: 'creative tracking URL | creative tracking URLs',
    csv: 'CSV | CSVs',
    currentPassword: 'current password',
    currentUser: 'current user | current users',
    currentlyAvailable: 'currently available',
    customAudience: 'custom audience | custom audiences',
    customEvent: 'custom event | custom events',
    customIcon: 'custom icon | custom icons',
    customProperty: 'custom property | custom properties',
    customization: 'customization | customizations',
    dashboard: 'dashboard | dashboards',
    dataPoint: 'data point | data points',
    date: 'date | dates',
    dateRange: 'date range | date ranges',
    dateRangeTimeZone: 'date range time zone | date range time zones',
    day: 'day | days',
    dayOfTheWeek: 'day of the week | days of the week',
    daypart: 'daypart | dayparts',
    deal: 'deal | deals',
    dealAvailability: 'deal availability | deals availability',
    dealID: 'deal ID | deal IDs',
    dealRevision: 'deal revision | deal revisions',
    dealScope: 'deal scope | deal scopes',
    dealTemplate: 'deal template | deal templates',
    dealTemplateSetting: 'deal template setting | deal template settings',
    decision: 'decision | decisions',
    default: 'default | defaults',
    deliveredImpressions: 'delivered impressions',
    delivery: 'delivery | deliveries',
    deliveryEmail: 'delivery email | delivery emails',
    deliveryObjective: 'delivery objective | delivery objectives',
    demographic: 'demographic | demographics',
    description: 'description | descriptions',
    detail: 'detail | details',
    device: 'device | devices',
    deviceCarrier: 'device carrier | device carriers',
    deviceIDSegment: 'Device ID segment | Device ID segments',
    dimension: 'dimension | dimensions',
    direct: 'direct',
    discount: 'discount | discounts',
    discountedAmount: 'discounted amount | discounted amounts',
    discountedCPM: 'discounted CPM | discounted CPMs',
    domain: 'domain | domains',
    dsp: 'DSP | DSPs',
    dspSelfServed: 'DSP self-served | DSP self-served',
    duration: 'duration | durations',
    eCPM: 'eCPM | eCPM',
    email: 'email | emails',
    end: 'end | ends',
    endDate: 'end date | end dates',
    endDateMax: 'maximum end date | maximum end dates',
    endDateMin: 'minimum end date | minimum end dates',
    endDateRange: 'end date range | end date ranges',
    error: 'error | errors',
    errorReport: 'error report | error reports',
    estimatedAmount: 'estimated amount | estimated amount',
    estimatedCPM: 'estimated audience CPM | estimated audience CPMs',
    estimatedEnd: 'estimated end',
    estimatedImpressions: 'estimated impressions | estimated impressions',
    estimatedStart: 'estimated start',
    event: 'event | events',
    events: 'event | events',
    example: 'example | examples',
    excel: 'Excel | Excel',
    exchange: 'exchange | exchanges',
    exchangeFeeOverride: 'exchange fee override',
    existingAdvertiser: 'existing advertiser | existing advertisers',
    externalCreative: 'external creative | external creatives',
    externalCreativeID: 'external creative ID | external creative IDs',
    externalDealId: 'deal ID | deal IDs',
    externalDspName: 'DSP name | DSP names',
    externalEvent: 'external event | external events',
    externalID: 'external ID | external IDs',
    externalSSPs: 'External SSP',
    facingDirection: 'facing direction | facing directions',
    failedToGetUnitPack: 'failed to get unit pack.',
    failure: 'failure | failures',
    fallbackCreative: 'fallback creative | fallback creatives',
    female: 'female | females',
    file: 'file | files',
    filePendingApproval: 'file pending approval | files pending approval',
    fileSize: 'file size | file sizes',
    filename: 'file name | file names',
    fillRate: 'Fill Rate',
    filter: 'filter | filters',
    fixedRate: 'fixed rate | fixed rates',
    flexibility: 'flexibility | flexibilities',
    floorCPM: 'floor CPM | floor CPMs',
    format: 'format | formats',
    freqCapCount: 'frequency cap count',
    freqCapPeriod: 'frequency cap period',
    frequency: 'frequency | frequencies',
    frequencyCap: 'frequency cap | frequency caps',
    gender: 'gender | genders',
    generatedReport: 'generated report | generated reports',
    geoBehaviour: 'geo behavior | geo behaviors',
    geoJSON: 'geoJSON | geoJSON',
    geofence: 'geofence | geofences',
    geofenceDescription: 'geofence description | geofence descriptions',
    geofenceGroup: 'geofence group | geofence groups',
    geofenceGroupName: 'geofence group name | geofence group names',
    geofenceID: 'geofence ID | geofence IDs',
    geofenceLatitude: 'geofence latitude | geofence latitudes',
    geofenceLongitude: 'geofence longitude | geofence longitudes',
    geofenceName: 'geofence name | geofence names',
    geofenceRadius: 'geofence radius (meters) | geofence radii (meters)',
    geographicContext: 'geographic context | geographic contexts',
    geography: 'geography | geographies',
    goal: 'goal | goals',
    grossCPM: 'gross CPM | gross CPMs',
    group: 'group | groups',
    groupName: 'group Name | group Names',
    hash: 'hash | hashes',
    heat: 'heat | heats',
    heatmap: 'heatmap | heatmaps',
    height: 'height | heights',
    high: 'high | highs',
    hour: 'hour | hours',
    hourlyReport: 'hourly report | hourly reports',
    iabCategory: 'IAB category | IAB categories',
    id: 'id | ids',
    image: 'image | images',
    importedAudience: 'imported audience | imported audiences',
    impression: 'impression | impressions',
    impressionAbbr: 'imp | imps',
    impressionDelivered: 'impression delivered | impressions delivered',
    impressionPer: 'impression per | impressions per',
    impressionsBased: 'impressions-based',
    impressionsMax: 'maximum impression | maximum impressions',
    impressionsMin: 'minimum impression | minimum impressions',
    inactive: 'inactive | inactive',
    intent: 'intent | intents',
    interest: 'interest | interests',
    internalNote: 'internal note | internal notes',
    internalSSPs: 'Internal',
    inventory: 'inventory | inventories',
    inventoryMap: 'inventory map | inventory maps',
    is: 'is | are',
    itemPerPage: '{0} item per page | {0} items per page',
    journeyAnalysis: 'journey analysis | journeys',
    key: 'key | keys',
    landscapeOrientation: 'landscape | landscapes',
    language: 'language | languages',
    lastGeneratedContendingLineItemReport: 'last generated contending line item report | last generated contending line item reports',
    lastGeneratedReport: 'last generated report | last generated reports',
    latitude: 'latitude | latitudes',
    legacyOption: 'legacy option | legacy options',
    legend: 'legend | legends',
    library: 'library | libraries',
    lifesightSegmentId: 'segment id | segment ids',
    lifestyle: 'lifestyle | lifestyles',
    lifetime: 'lifetime | lifetimes',
    liftDashboard: 'lift dashboard | lift dashboards',
    limit: 'limit | limits',
    lineItem: 'line item | line items',
    lineItemApproval: 'line item approval | line item approvals',
    lineItemCreative: 'line item creative | line item creatives',
    lineItemCustomField: 'line item custom field | line item custom fields',
    lineItemID: 'line item ID | line item IDs',
    lineItemUnitAssignment: 'screen / site assignment | screen / site assignments',
    list: 'list | lists',
    location: 'location | locations',
    locationExclusion: 'location exclusion | location exclusions',
    locationMap: 'location map | location maps',
    logo: 'logo | logos',
    longitude: 'longitude | longitudes',
    lookbackWindow: 'lookback window | lookback windows',
    loopBased: 'loop-based',
    loopLength: 'loop length | loop lengths',
    low: 'low | lows',
    male: 'male | males',
    manualUpload: 'manual upload | manual uploads',
    map: 'map | maps',
    margin: 'margin | margins',
    market: 'market | markets',
    marketExclusion: 'market exclusion | market exclusions',
    marketplace: 'marketplace | marketplaces',
    max: 'max | maxs',
    maxBidCPM: 'max bid CPM | max bid CPM',
    maxCPM: 'max CPM | max CPMs',
    maxCadence: 'max cadence | max cadences',
    maxSpotLength: 'max spot length',
    maximum: 'maximum | maximums',
    measurement: 'measurement | measurements',
    mediaOwner: 'media owner | media owners',
    mediaOwnerApproval: 'media owner approval | media owner approvals',
    mediaType: 'media type | media types',
    mediaTypeExclusion: 'media type exclusion | media type exclusions',
    metric: 'metric | metrics',
    min: 'min | mins',
    minAudienceConcentration: 'min. audience concentration | min. audience concentrations',
    minBudget: 'minimum budget | minimum budgets',
    minCPM: 'min CPM | min CPMs',
    minImpression: 'minimum impression | minimum impressions',
    minSecondsBetweenAdDomainPlays: 'Advertiser frequency cap',
    minSecondsBetweenIABCategoryPlays: 'IAB category frequency cap',
    minSecondsBetweenPlays: 'minimum seconds between plays | minimum seconds between plays',
    minSecondsBetweenPlaysMax: 'minimum seconds between plays upper limit | minimum seconds between plays upper limit',
    minSecondsBetweenPlaysMin: 'minimum seconds between plays lower limit | minimum seconds between plays lower limit',
    minSpotLength: 'min spot length',
    minimum: 'minimum | minimums',
    minute: 'minute | minutes',
    missingDimension: 'missing dimension | missing dimensions',
    mobileAppUsage: 'mobile usage | mobile usages',
    mobileCampaign: 'mobile campaign | mobile campaigns',
    mobileCreative: 'mobile creative | mobile creatives',
    mobileLineItem: 'mobile line item | mobile line items',
    month: 'month | months',
    name: 'name | names',
    nameAndExternalID: '[External ID] Name | [External IDs] Names',
    nautilus: 'Nautilus',
    network: 'network | networks',
    networkExclusion: 'network exclusion | network exclusions',
    networkName: 'network name | network names',
    newAccount: 'new account | new accounts',
    newAdvancedReport: 'new advanced report | new advanced reports',
    newAdvertiser: 'new advertiser | new advertisers',
    newAudienceFile: 'new audience file | new audience files',
    newAudienceLogic: 'new custom audience | new custom audiences',
    newCampaign: 'new campaign | new campaigns',
    newCreative: 'new creative | new creatives',
    newDeal: 'new deal | new deals',
    newDealAvailable: 'new deal available',
    newExternalCreative: 'new external creative | new external creatives',
    newFallbackCreative: 'new fallback creative | new fallback creatives',
    newGeofence: 'new geofence | new geofences',
    newGeofenceGroup: 'new geofence group | new geofence groups',
    newLineItem: 'new line item | new line items',
    newMobileCreative: 'new mobile creative | new mobile creatives',
    newOrganizationCustomField: 'new custom field',
    newPackage: 'new deal',
    newPassword: 'new password',
    newPlan: 'new plan | new plans',
    newPreSaleHeatmap: 'new proposal heatmap | new proposal heatmaps',
    newReportDefinition: 'new report definition | new report definitions',
    newSite: 'new site | new sites',
    newUnit: 'new screen | new screens',
    noBid: 'no bid | no bids',
    noReport: 'no report | no reports',
    notes: 'note | notes',
    notification: 'notification | notifications',
    numberOfDays: 'number of days | number of days',
    numberOfDaysMax: 'maximum number of days | maximum number of days',
    numberOfDaysMin: 'minimum number of days | minimum number of days',
    observedSignal: 'observed signal | observed signals',
    onlineBrand: 'online brand | online brands',
    operatingHour: 'operating hour | operating hours',
    oracleAudienceSegment: 'Oracle audience segment | Oracle audience segments',
    organization: 'organization | organizations',
    organizationCustomField: 'custom field | custom fields',
    organizationDSP: 'organization DSP | organization DSPs',
    organizationSetting: 'organization setting | organization settings',
    orientation: 'orientation | orientations',
    orientationLandscape: 'landscape | landscapes',
    orientationPortrait: 'portrait | portraits',
    origin: 'origin | origins',
    other: 'other | others',
    otherCampaign: 'other campaign | other campaigns',
    otherUser: 'other user | other users',
    outputFormat: 'output format',
    overriddenScreenCount: 'Overridden screen count',
    overrideScreenCount: 'Override screen count',
    overview: 'overview | overviews',
    pacing: 'pacing | pacings',
    pack: 'pack | packs',
    package: 'deal | deals',
    password: 'password | passwords',
    pendingApproval: 'pending approval | pending approvals',
    pendingDeal: 'pending deal | pending deals',
    pendingSubmission: 'pending submission | pending submissions',
    perRateCard: 'per rate card | per rate cards',
    percentage: 'percentage | percentages',
    pitch: 'pitch | pitches',
    pixel: 'pixel | pixels',
    place: 'place | places',
    placeFound: '{0} place found | {0} places found',
    placeVisitor: 'place visitor | place visitors',
    plan: 'plan | plans',
    planID: 'plan ID | plans IDs',
    plannedAdSpend: 'planned ad spend | planned ads spend',
    plannedImpressions: 'planned impressions',
    play: 'play | plays',
    playPerDay: 'play per day | plays per day',
    playPerHour: 'play per hour | plays per hour',
    playPerMonth: 'play per month | plays per month',
    playback: 'playback | playbacks',
    pmp: 'pmp | pmp',
    pollen: 'pollen | pollen',
    preSaleHeatmap: 'proposal heatmap | proposal heatmaps',
    predefinedSegment: 'predefined segment | predefined segments',
    prefetchID: 'creative ID | creative IDs',
    prefetchSource: 'DSP | DSPs',
    preloadedExternalCreative: 'preloaded external creative | preloaded external creatives',
    preview: 'preview | previews',
    primary: 'primary | primary',
    priority: 'priority | priorities',
    programmaticBuyer: 'programmatic buyer | programmatic buyers',
    programmaticDeal: 'programmatic deal | programmatic deals',
    progress: 'progress | progresses',
    property: 'property | properties',
    proposal: 'Proposal',
    proximity: 'proximity | proximities',
    proximityGeofence: 'proximity geofence | proximity geofences',
    proximityGeofenceGroup: 'proximity geofence group | proximity geofence groups',
    publicDeal: 'public deal | public deals',
    publishing: 'publishing',
    purchaseIntent: 'purchase intent | purchase intents',
    purchaseType: 'purchase type | purchase types',
    purchasedDeal: 'purchased deal | purchased deals',
    reach: 'reach',
    recurrence: 'recurrence | recurrences',
    region: 'region | regions',
    remainingBudget: 'remaining budget | remaining budgets',
    report: 'report | reports',
    reportDefinition: 'report definition | report definitions',
    reportExecution: 'report execution | report executions',
    reportType: 'report type | report types',
    request: 'request | requests',
    required: 'required | required',
    requiredDimension: 'required dimension | required dimensions',
    responseRate: 'response rate | response rates',
    retargetedLineItem: 'retargeted line item | retargeted line items',
    revenue: 'revenue | revenues',
    revenueSourceDirect: 'direct',
    revenueSourceManaged: 'managed',
    revenueSourceOpenExchange: 'open exchange',
    revenueSourcePrivateDeals: 'private deals',
    revenueSourceProgrammatic: 'programmatic',
    revenueSourceStorefront: 'storefront',
    revenueSplit: 'revenue split | revenue splits',
    revenueStream: 'revenue stream | revenue streams',
    revision: 'revision | revisions',
    role: 'role | roles',
    row: 'row | rows',
    rule: 'rule | rules',
    ruleGroup: 'rule group | rule groups',
    runDateRange: 'run date range | run date ranges',
    runWindow: 'run window | run windows',
    s3Path: 'S3 path | S3 paths',
    saturday: 'saturday | saturdays',
    schedule: 'schedule | schedules',
    screen: 'screen | screens',
    screenCount: 'screen count',
    screenCovered: 'screen covered | screens covered',
    screenFrequencyCap: 'screen frequency cap | screen frequency caps',
    screenHeightPx: 'screen height (px)',
    screenID: 'screen ID | screen IDs',
    screenImage: 'screen photo | screen photos',
    screenLatitude: 'screen latitude',
    screenLocation: 'screen location | screen locations',
    screenLongitude: 'screen longitude',
    screenName: 'screen name',
    screenNetwork: 'screen network',
    screenPack: 'pack | packs',
    screenPackID: 'pack ID | pack IDs',
    screenPackName: 'pack name | pack names',
    screenSize: 'screen size | screen sizes',
    screenSizeApproval: 'screen size approval | screen size approvals',
    screenSizePendingApproval: 'screen size pending approval | screen sizes pending approval',
    screenWidthPx: 'screen width (px)',
    second: 'second | seconds',
    secondAbbr: 'sec | secs',
    segmentName: 'segment name | segment names',
    selection: 'selection | selections',
    selectiveListing: 'selective listing',
    setting: 'setting | settings',
    site: 'site | sites',
    siteID: 'site ID | site IDs',
    siteLatitude: 'site latitude | site latitudes',
    siteLocation: 'site location | site locations',
    siteLocationCity: 'site location (city) | site locations (city)',
    siteLongitude: 'site longitude | site longitudes',
    siteName: 'site name | site names',
    siteRegion: 'site region (state) | site regions (states)',
    size: 'size | sizes',
    slideshow: 'slideshow | slideshows',
    smoothCatchup: 'smooth catchup | smooth catchup',
    sorting: 'sorting | sortings',
    speed: 'speed | speeds',
    spotLength: 'spot length | spot lenghts',
    ssp: 'SSP | SSPs',
    sspDeal: 'SSP deal | SSP deals',
    start: 'start | starts',
    startDate: 'start date | start dates',
    startDateMax: 'maximum start date | maximum start dates',
    startDateMin: 'minimum start date | minimum start dates',
    startDateRange: 'start date range | start date ranges',
    status: 'status | statuses',
    submission: 'submission | submissions',
    success: 'success | successes',
    suggestedCadence: 'suggested cadence | suggested cadences',
    summary: 'summary | summaries',
    sunday: 'sunday | sundays',
    tactic: 'tactic | tactics',
    tag: 'tag | tags',
    targeting: 'targeting | targetings',
    targetingSummary: 'targeting summary | targeting summaries',
    temperature: 'temperature | temperatures',
    thumbnail: 'thumbnail | thumbnails',
    time: 'time | times',
    timeBetweenPlays: 'time between plays | times between plays',
    timeline: 'timeline | timelines',
    timezone: 'timezone | timezones',
    timezoneSuggested: 'suggested timezone | suggested timezones',
    title: 'title | titles',
    topAccount: 'top account | top accounts',
    topAdvertiser: 'top advertiser | top advertisers',
    topBuyer: 'top buyer | top buyers',
    total: 'total | totals',
    totalAmount: 'total amount | total amounts',
    totalImpression: 'total impression | total impressions',
    totalPlay: 'total play | total plays',
    type: 'type | types',
    underDeliveringLineItem: 'under delivering line item | under delivering line items',
    uniqueDevice: 'unique device | unique devices',
    unit: 'screen | screens',
    unitDimension: 'screen dimension | screen dimensions',
    unitID: 'unit ID | unit IDs',
    unitName: 'screen name | screen names',
    unitPack: 'pack | packs',
    unitPackExclusion: 'pack exclusion | pack exclusions',
    unitPackID: 'pack ID | pack IDs',
    unitPackName: 'pack name | pack names',
    unitSiteExclusion: 'unit and site exclusion | unit and site exclusions',
    unitpacks: 'pack | packs',
    unknown: 'unknown | unknowns',
    url: 'url | urls',
    user: 'user | users',
    userSetting: 'user setting | user settings',
    uuid: 'UUID | UUIDs',
    value: 'value | values',
    venueType: 'venue type | venue types',
    venueTypeExclusion: 'venue type exclusion | venue type exclusions',
    verifyPassword: 'verify password',
    video: 'video | videos',
    view: 'view | views',
    weatherCondition: 'weather condition | weather conditions',
    week: 'week | weeks',
    weekday: 'weekday | weekdays',
    weekend: 'weekend',
    weeklyImpression: 'weekly impression | weekly impressions',
    weight: 'weight',
    width: 'width | widths',
    winRate: 'win rate | win rates',
    year: 'year | years',
    yourSelection: 'your selection | your selections',
    zip: 'zip | zip',
    zoomLevel: 'zoom level | zoom levels'
  },
  options: {
    advancedReport: {
      reportType: {
        allVision: 'AllVision Billing Report',
        cappedImpressions: 'Capped Impressions',
        contendingLineitems: 'Contending Line Items',
        fillRate: 'Fill Rate',
        nautilus: 'Nautilus'
      }
    },
    audienceLoopbackWindowPeriodType: {
      days: 'days',
      months: 'months',
      years: 'years'
    },
    customEvents: {
      aCryptoOrAStockReachedANewHigh: 'A crypto or a stock reached a new high',
      flashSales: 'flash sales',
      metroStatus: 'metro status',
      sportsResults: 'sports results'
    },
    dateRangePicker: {
      dateRange: {
        custom: 'custom',
        last12Months: 'last 12 months',
        last14Days: 'last 14 days',
        last24Hours: 'last 24 hours',
        last28Days: 'last 28 days',
        last30Days: 'last 30 days',
        last3Months: 'last 3 months',
        last4Hours: 'last 4 hours',
        last60Days: 'last 60 days',
        last6Months: 'last 6 months',
        last7Days: 'last 7 days',
        last90Days: 'last 90 days',
        lastHour: 'last hour',
        lastMonth: 'last month',
        lastWeek: 'last week',
        lastYear: 'last year',
        lifetime: 'lifetime',
        monthToDate: 'month to date',
        quarterToDate: 'quarter to date',
        thisMonth: 'this month',
        thisWeek: 'this week',
        today: 'today',
        yearToDate: 'year to date',
        yesterday: 'yesterday'
      }
    },
    dealTypes: {
      automatedGuaranteed: 'automated guaranteed',
      openAuction: 'Open auction',
      privateAuction: 'Private auction',
      unreservedFixedRate: 'Unreserved fixed rate'
    },
    distanceUnits: {
      feet: 'feet',
      feetAbbr: 'ft',
      foot: 'foot',
      kilometer: 'kilometer',
      kilometers: 'kilometers',
      kilometersAbbr: 'km',
      meter: 'meter',
      meters: 'meters',
      metersAbbr: 'm',
      mile: 'mile',
      miles: 'miles',
      milesAbbr: 'mi'
    },
    frequencyCap: {
      day: '{count} time per day | {count} times per day',
      hour: '{count} time per hour | {count} times per hour',
      lifetime: '{count} time in total | {count} times in total',
      month: '{count} time per month | {count} times per month',
      week: '{count} time per week | {count} times per week'
    },
    genericGeofenceTypes: {
      postal: 'Postal Codes'
    },
    goals: {
      driveAppInstallsOrEngagements: 'Drive app installs or engagements',
      driveOfflineOrInStoreSales: 'Drive offline or in store sales',
      driveOnlineActionOrVisits: 'Drive on line action or visits',
      other: 'other',
      raiseAwarenessOfMyBrandOrProduct: 'Raise awareness of my brand or product'
    },
    iabCategories: {
      IAB1: 'Arts & Entertainment',
      IAB10: 'Home & Garden',
      IAB10_1: 'Appliances',
      IAB10_2: 'Entertaining',
      IAB10_3: 'Environmental Safety',
      IAB10_4: 'Gardening',
      IAB10_5: 'Home Repair',
      IAB10_6: 'Home Theater',
      IAB10_7: 'Interior Decorating',
      IAB10_8: 'Landscaping',
      IAB10_9: 'Remodeling & Construction',
      IAB11: 'Law, Gov’t & Politics',
      IAB11_1: 'Immigration',
      IAB11_2: 'Legal Issues',
      IAB11_3: 'U.S. Government Resources',
      IAB11_4: 'Politics',
      IAB11_5: 'Commentary',
      IAB12: 'News',
      IAB12_1: 'International News',
      IAB12_2: 'National News',
      IAB12_3: 'Local News',
      IAB13: 'Personal Finance',
      IAB13_1: 'Beginning Investing',
      IAB13_10: 'Retirement Planning',
      IAB13_11: 'Stocks',
      IAB13_12: 'Tax Planning',
      IAB13_2: 'Credit/Debt & Loans',
      IAB13_3: 'Financial News',
      IAB13_4: 'Financial Planning',
      IAB13_5: 'Hedge Fund',
      IAB13_6: 'Insurance',
      IAB13_7: 'Investing',
      IAB13_8: 'Mutual Funds',
      IAB13_9: 'Options',
      IAB14: 'Society',
      IAB14_1: 'Dating',
      IAB14_2: 'Divorce Support',
      IAB14_3: 'Gay Life',
      IAB14_4: 'Marriage',
      IAB14_5: 'Senior Living',
      IAB14_6: 'Teens',
      IAB14_7: 'Weddings',
      IAB14_8: 'Ethnic Specific',
      IAB15: 'Science',
      IAB15_1: 'Astrology',
      IAB15_10: 'Weather',
      IAB15_2: 'Biology',
      IAB15_3: 'Chemistry',
      IAB15_4: 'Geology',
      IAB15_5: 'Paranormal Phenomena',
      IAB15_6: 'Physics',
      IAB15_7: 'Space/Astronomy',
      IAB15_8: 'Geography',
      IAB15_9: 'Botany',
      IAB16: 'Pets',
      IAB16_1: 'Aquariums',
      IAB16_2: 'Birds',
      IAB16_3: 'Cats',
      IAB16_4: 'Dogs',
      IAB16_5: 'Large Animals',
      IAB16_6: 'Reptiles',
      IAB16_7: 'Veterinary Medicine',
      IAB17: 'Sports',
      IAB17_1: 'Auto Racing',
      IAB17_10: 'Figure Skating',
      IAB17_11: 'Fly Fishing',
      IAB17_12: 'Football',
      IAB17_13: 'Freshwater Fishing',
      IAB17_14: 'Game & Fish',
      IAB17_15: 'Golf',
      IAB17_16: 'Horse Racing',
      IAB17_17: 'Horses',
      IAB17_18: 'Hunting/Shooting',
      IAB17_19: 'Inline Skating',
      IAB17_2: 'Baseball',
      IAB17_20: 'Martial Arts',
      IAB17_21: 'Mountain Biking',
      IAB17_22: 'NASCAR Racing',
      IAB17_23: 'Olympics',
      IAB17_24: 'Paintball',
      IAB17_25: 'Power & Motorcycles',
      IAB17_26: 'Pro Basketball',
      IAB17_27: 'Pro Ice Hockey',
      IAB17_28: 'Rodeo',
      IAB17_29: 'Rugby',
      IAB17_3: 'Bicycling',
      IAB17_30: 'Running/Jogging',
      IAB17_31: 'Sailing',
      IAB17_32: 'Saltwater Fishing',
      IAB17_33: 'Scuba Diving',
      IAB17_34: 'Skateboarding',
      IAB17_35: 'Skiing',
      IAB17_36: 'Snowboarding',
      IAB17_37: 'Surfing/Bodyboarding',
      IAB17_38: 'Swimming',
      IAB17_39: 'Table Tennis/Ping-Pong',
      IAB17_4: 'Bodybuilding',
      IAB17_40: 'Tennis',
      IAB17_41: 'Volleyball',
      IAB17_42: 'Walking',
      IAB17_43: 'Waterski/Wakeboard',
      IAB17_44: 'World Soccer',
      IAB17_5: 'Boxing',
      IAB17_6: 'Canoeing/Kayaking',
      IAB17_7: 'Cheerleading',
      IAB17_8: 'Climbing',
      IAB17_9: 'Cricket',
      IAB18: 'Style & Fashion',
      IAB18_1: 'Beauty',
      IAB18_2: 'Body Art',
      IAB18_3: 'Fashion',
      IAB18_4: 'Jewelry',
      IAB18_5: 'Clothing',
      IAB18_6: 'Accessories',
      IAB19: 'Technology & Computing',
      IAB19_1: '3-D Graphics',
      IAB19_10: 'Computer Reviews',
      IAB19_11: 'Data Centers',
      IAB19_12: 'Databases',
      IAB19_13: 'Desktop Publishing',
      IAB19_14: 'Desktop Video',
      IAB19_15: 'Email',
      IAB19_16: 'Graphics Software',
      IAB19_17: 'Home Video/DVD',
      IAB19_18: 'Internet Technology',
      IAB19_19: 'Java',
      IAB19_2: 'Animation',
      IAB19_20: 'JavaScript',
      IAB19_21: 'Mac Support',
      IAB19_22: 'MP3/MIDI',
      IAB19_23: 'Net Conferencing',
      IAB19_24: 'Net for Beginners',
      IAB19_25: 'Network Security',
      IAB19_26: 'Palmtops/PDAs',
      IAB19_27: 'PC Support',
      IAB19_28: 'Portable',
      IAB19_29: 'Entertainment',
      IAB19_3: 'Antivirus Software',
      IAB19_30: 'Shareware/Freeware',
      IAB19_31: 'Unix',
      IAB19_32: 'Visual Basic',
      IAB19_33: 'Web Clip Art',
      IAB19_34: 'Web Design/HTML',
      IAB19_35: 'Web Search',
      IAB19_36: 'Windows',
      IAB19_4: 'C/C++',
      IAB19_5: 'Cameras & Camcorders',
      IAB19_6: 'Cell Phones',
      IAB19_7: 'Computer Certification',
      IAB19_8: 'Computer Networking',
      IAB19_9: 'Computer Peripherals',
      IAB1_1: 'Books & Literature',
      IAB1_2: 'Celebrity Fan/Gossip',
      IAB1_3: 'Fine Art',
      IAB1_4: 'Humor',
      IAB1_5: 'Movies',
      IAB1_6: 'Music',
      IAB1_7: 'Television',
      IAB2: 'Automotive',
      IAB20: 'Travel',
      IAB20_1: 'Adventure Travel',
      IAB20_10: 'Canada',
      IAB20_11: 'Caribbean',
      IAB20_12: 'Cruises',
      IAB20_13: 'Eastern Europe',
      IAB20_14: 'Europe',
      IAB20_15: 'France',
      IAB20_16: 'Greece',
      IAB20_17: 'Honeymoons/Getaways',
      IAB20_18: 'Hotels',
      IAB20_19: 'Italy',
      IAB20_2: 'Africa',
      IAB20_20: 'Japan',
      IAB20_21: 'Mexico & Central America',
      IAB20_22: 'National Parks',
      IAB20_23: 'South America',
      IAB20_24: 'Spas',
      IAB20_25: 'Theme Parks',
      IAB20_26: 'Traveling with Kids',
      IAB20_27: 'United Kingdom',
      IAB20_3: 'Air Travel',
      IAB20_4: 'Australia & New Zealand',
      IAB20_5: 'Bed & Breakfasts',
      IAB20_6: 'Budget Travel',
      IAB20_7: 'Business Travel',
      IAB20_8: 'By US Locale',
      IAB20_9: 'Camping',
      IAB21: 'Real Estate',
      IAB21_1: 'Apartments',
      IAB21_2: 'Architects',
      IAB21_3: 'Buying/Selling Homes',
      IAB22: 'Shopping',
      IAB22_1: 'Contests & Freebies',
      IAB22_2: 'Couponing',
      IAB22_3: 'Comparison',
      IAB22_4: 'Engines',
      IAB23: 'Religion & Spirituality',
      IAB23_1: 'Alternative Religions',
      IAB23_10: 'Pagan/Wiccan',
      IAB23_2: 'Atheism/Agnosticism',
      IAB23_3: 'Buddhism',
      IAB23_4: 'Catholicism',
      IAB23_5: 'Christianity',
      IAB23_6: 'Hinduism',
      IAB23_7: 'Islam',
      IAB23_8: 'Judaism',
      IAB23_9: 'Latter-Day Saints',
      IAB24: 'Uncategorized',
      IAB25: 'Non-Standard Content',
      IAB25_1: 'Unmoderated UGC',
      IAB25_2: 'Extreme Graphic/Explicit Violence',
      IAB25_3: 'Pornography',
      IAB25_4: 'Profane Content',
      IAB25_5: 'Hate Content',
      IAB25_6: 'Under Construction',
      IAB25_7: 'Incentivized',
      IAB26: 'Illegal Content',
      IAB26_1: 'Illegal Content',
      IAB26_2: 'Warez',
      IAB26_3: 'Spyware/Malware',
      IAB26_4: 'Copyright Infringement',
      IAB2_1: 'Auto Parts',
      IAB2_10: 'Electric Vehicle',
      IAB2_11: 'Hatchback',
      IAB2_12: 'Hybrid',
      IAB2_13: 'Luxury',
      IAB2_14: 'MiniVan',
      IAB2_15: 'Mororcycles',
      IAB2_16: 'Off-Road Vehicles',
      IAB2_17: 'Performance Vehicles',
      IAB2_18: 'Pickup',
      IAB2_19: 'Road-Side Assistance',
      IAB2_2: 'Auto Repair',
      IAB2_20: 'Sedan',
      IAB2_21: 'Trucks & Accessories',
      IAB2_22: 'Vintage Cars',
      IAB2_23: 'Wagon',
      IAB2_3: 'Buying/Selling Cars',
      IAB2_4: 'Car Culture',
      IAB2_5: 'Certified Pre-Owned',
      IAB2_6: 'Convertible',
      IAB2_7: 'Coupe',
      IAB2_8: 'Crossover',
      IAB2_9: 'Diesel',
      IAB3: 'Business',
      IAB3_1: 'Advertising',
      IAB3_10: 'Logistics',
      IAB3_11: 'Marketing',
      IAB3_12: 'Metals',
      IAB3_2: 'Agriculture',
      IAB3_3: 'Biotech/Biomedical',
      IAB3_4: 'Business Software',
      IAB3_5: 'Construction',
      IAB3_6: 'Forestry',
      IAB3_7: 'Government',
      IAB3_8: 'Green Solutions',
      IAB3_9: 'Human Resources',
      IAB4: 'Careers',
      IAB4_1: 'Career Planning',
      IAB4_10: 'U.S. Military',
      IAB4_11: 'Career Advice',
      IAB4_2: 'College',
      IAB4_3: 'Financial Aid',
      IAB4_4: 'Job Fairs',
      IAB4_5: 'Job Search',
      IAB4_6: 'Resume Writing/Advice',
      IAB4_7: 'Nursing',
      IAB4_8: 'Scholarships',
      IAB4_9: 'Telecommuting',
      IAB5: 'Education',
      IAB5_1: '7-12 Education',
      IAB5_10: 'Homeschooling',
      IAB5_11: 'Homework/Study Tips',
      IAB5_12: 'K-6 Educators',
      IAB5_13: 'Private School',
      IAB5_14: 'Special Education',
      IAB5_15: 'Studying Business',
      IAB5_2: 'Adult Education',
      IAB5_3: 'Art History',
      IAB5_4: 'College Administration',
      IAB5_5: 'College Life',
      IAB5_6: 'Distance Learning',
      IAB5_7: 'English as a 2nd Language',
      IAB5_8: 'Language Learning',
      IAB5_9: 'Graduate School',
      IAB6: 'Family & Parenting',
      IAB6_1: 'Adoption',
      IAB6_2: 'Babies & Toddlers',
      IAB6_3: 'Daycare/Pre School',
      IAB6_4: 'Family Internet',
      IAB6_5: 'Parenting - K-6 Kids',
      IAB6_6: 'Parenting teens',
      IAB6_7: 'Pregnancy',
      IAB6_8: 'Special Needs Kids',
      IAB6_9: 'Eldercare',
      IAB7: 'Health & Fitness',
      IAB7_1: 'Exercise',
      IAB7_10: 'Brain Tumor',
      IAB7_11: 'Cancer',
      IAB7_12: 'Cholesterol',
      IAB7_13: 'Chronic Fatigue Syndrome',
      IAB7_14: 'Chronic Pain',
      IAB7_15: 'Cold & Flu',
      IAB7_16: 'Deafness',
      IAB7_17: 'Dental Care',
      IAB7_18: 'Depression',
      IAB7_19: 'Dermatology',
      IAB7_2: 'A.D.D.',
      IAB7_20: 'Diabetes',
      IAB7_21: 'Epilepsy',
      IAB7_22: 'GERD/Acid Reflux',
      IAB7_23: 'Headaches/Migraines',
      IAB7_24: 'Heart Disease',
      IAB7_25: 'Herbs for Health',
      IAB7_26: 'Holistic Healing',
      IAB7_27: 'IBS/Crohn’s Disease',
      IAB7_28: 'Incest/Abuse Support',
      IAB7_29: 'Incontinence',
      IAB7_3: 'AIDS/HIV',
      IAB7_30: 'Infertility',
      IAB7_31: 'Men’s Health',
      IAB7_32: 'Nutrition',
      IAB7_33: 'Orthopedics',
      IAB7_34: 'Panic/Anxiety Disorders',
      IAB7_35: 'Pediatrics',
      IAB7_36: 'Physical Therapy',
      IAB7_37: 'Psychology/Psychiatry',
      IAB7_38: 'Senior Health',
      IAB7_39: 'Sexuality',
      IAB7_4: 'Allergies',
      IAB7_40: 'Sleep Disorders',
      IAB7_41: 'Smoking Cessation',
      IAB7_42: 'Substance Abuse',
      IAB7_43: 'Thyroid Disease',
      IAB7_44: 'Weight Loss',
      IAB7_45: 'Women’s Health',
      IAB7_5: 'Alternative Medicine',
      IAB7_6: 'Arthritis',
      IAB7_7: 'Asthma',
      IAB7_8: 'Autism/PDD',
      IAB7_9: 'Bipolar Disorder',
      IAB8: 'Food & Drink',
      IAB8_1: 'American Cuisine',
      IAB8_10: 'Food Allergies',
      IAB8_11: 'French Cuisine',
      IAB8_12: 'Health/Lowfat Cooking',
      IAB8_13: 'Italian Cuisine',
      IAB8_14: 'Japanese Cuisine',
      IAB8_15: 'Mexican Cuisine',
      IAB8_16: 'Vegan',
      IAB8_17: 'Vegetarian',
      IAB8_18: 'Wine',
      IAB8_2: 'Barbecues & Grilling',
      IAB8_3: 'Cajun/Creole',
      IAB8_4: 'Chinese Cuisine',
      IAB8_5: 'Cocktails/Beer',
      IAB8_6: 'Coffee/Tea',
      IAB8_7: 'Cuisine-Specific',
      IAB8_8: 'Desserts & Baking',
      IAB8_9: 'Dining Out',
      IAB9: 'Hobbies & Interests',
      IAB9_1: 'Art/Technology',
      IAB9_10: 'Collecting',
      IAB9_11: 'Comic Books',
      IAB9_12: 'Drawing/Sketching',
      IAB9_13: 'Freelance Writing',
      IAB9_14: 'Genealogy',
      IAB9_15: 'Getting Published',
      IAB9_16: 'Guitar',
      IAB9_17: 'Home Recording',
      IAB9_18: 'Investors & Patents',
      IAB9_19: 'Jewelry Making',
      IAB9_2: 'Arts & Crafts',
      IAB9_20: 'Magic & Illusion',
      IAB9_21: 'Needlework',
      IAB9_22: 'Painting',
      IAB9_23: 'Photography',
      IAB9_24: 'Radio',
      IAB9_25: 'Roleplaying Games',
      IAB9_26: 'Sci-Fi & Fantasy',
      IAB9_27: 'Scrapbooking',
      IAB9_28: 'Screenwriting',
      IAB9_29: 'Stamps & Coins',
      IAB9_3: 'Beadwork',
      IAB9_30: 'Video & Computer Games',
      IAB9_31: 'Woodworking',
      IAB9_4: 'Birdwatching',
      IAB9_5: 'Board Games/Puzzles',
      IAB9_6: 'Candle & Soap Making',
      IAB9_7: 'Card Games',
      IAB9_8: 'Chess',
      IAB9_9: 'Cigars'
    },
    pollen: {
      high: 'high',
      low: 'low',
      medium: 'medium',
      none: 'none',
      veryHigh: 'very high',
      veryLow: 'very low'
    },
    purchaseTypes: {
      adServerGuaranteed: 'Ad server guaranteed',
      adServerNonGuaranteed: 'Ad server non-guaranteed',
      bonusBuy: 'Bonus buy',
      cadenceBuy: 'Cadence buy',
      cadenceGuaranteed: 'Cadence guaranteed',
      guaranteed: 'guaranteed',
      houseAd: 'House Ad',
      nonGuaranteed: 'non-guaranteed',
      nonGuaranteedPMP: 'non-guaranteed PMP',
      pmpDeal: 'PMP deal',
      programmaticGuaranteed: 'Programmatic guaranteed'
    },
    reportDefinition: {
      breakdown: {
        cumulative: 'cumulative',
        daily: 'daily',
        hourly: 'hourly',
        monthly: 'monthly',
        weekly: 'weekly'
      },
      dateRange: {
        custom: 'custom',
        last12Months: 'last 12 months',
        last24Hours: 'last 24 hours',
        last30Days: 'last 30 days',
        last3Months: 'last 3 months',
        last4Hours: 'last 4 hours',
        last60Days: 'last 60 days',
        last6Months: 'last 6 months',
        last7Days: 'last 7 days',
        last90Days: 'last 90 days',
        lastHour: 'last hour',
        lastMonth: 'last month',
        lastWeek: 'last week',
        lastYear: 'last year',
        lifetime: 'lifetime',
        yesterday: 'yesterday'
      },
      dimension: {
        SSP: 'SSP',
        account: 'Account',
        accountID: 'account ID',
        advertiser: 'advertiser',
        advertiserID: 'advertiser ID',
        appDomain: 'app domain',
        buyer: 'programmatic buyer',
        buyerID: 'programmatic buyer ID',
        buyingPlatform: 'buying platform',
        cadence: 'cadence',
        campaign: 'campaign',
        campaignBudget: 'campaign budget',
        campaignCustomFields: 'campaign custom fields',
        campaignEndDate: 'campaign end date',
        campaignID: 'campaign ID',
        campaignStartDate: 'campaign start date',
        city: 'city',
        creative: 'creative',
        creativeFile: 'creative file',
        creativeFileID: 'creative file ID',
        creativeID: 'creative ID',
        customAudiences: 'custom audiences',
        deal: 'deal',
        dealCustomFields: 'deal custom fields',
        dealID: 'deal ID',
        dimensionsWxH: 'dimensions W x H',
        height: 'height',
        lineItem: 'line item',
        lineItemBudget: 'line item budget',
        lineItemCustomFields: 'line item custom fields',
        lineItemEndDate: 'line item end date',
        lineItemID: 'line item ID',
        lineItemStartDate: 'line item start date',
        market: 'market',
        mediaOwner: 'media owner',
        mediaOwnerID: 'media owner ID',
        mediaType: 'media type',
        network: 'network',
        networkID: 'network ID',
        purchaseType: 'purchase type',
        region: 'region',
        revenueSource: 'revenue source',
        screen: 'screen',
        site: 'site',
        siteExternalID: 'site ID',
        spotLength: 'spot Length',
        timezone: 'time zone',
        unit: 'screen',
        unitExternalID: 'screen ID',
        unitID: 'unit ID',
        unitLatitude: 'screen latitude',
        unitLongitude: 'screen longitude',
        venueType: 'venue type',
        width: 'width'
      },
      format: {
        csv: 'CSV',
        xlsx: 'XLSX',
        xlsx_styled: 'styled XLSX'
      },
      metric: {
        advertiserCPM: 'advertiser CPM',
        advertiserSpend: 'advertiser Spend',
        audienceCPM: 'audience CPM',
        audienceImpressions: 'audience impressions',
        concentration: 'concentration',
        cpm: 'CPM',
        extraCosts: 'extra costs',
        fees: 'Fees',
        impressions: 'impressions',
        netReachFrequency: 'net reach & frequency',
        plays: 'plays',
        spend: 'spend'
      }
    },
    reportSchedule: {
      daily: 'daily',
      monthly: 'monthly',
      oneTime: 'one time',
      weekly: 'weekly'
    },
    roles: {
      MANAGER: 'manager',
      OWNER: 'owner',
      READ_ONLY: 'read only',
      REPORTING_ONLY: 'reporting only',
      SALES_MANAGER: 'sales manager',
      SALES_PLANNER: 'sales planner',
      SCHEDULER: 'scheduler'
    },
    rolesDescriptions: {
      MANAGER: 'Managers can fully manage the platform with the exception of managing users.',
      OWNER: 'Owners can fully manage everything, including users.',
      READ_ONLY: 'Read only users have view access across the platform, and can run reports. They cannot create, update, or delete anything in the system.',
      REPORTING_ONLY: 'Reporting only users can run and edit report definitions in addition to having read access.',
      SALES_MANAGER: 'Sales managers can plan and create campaigns and upload creatives. They cannot approve them to go live.',
      SCHEDULER: 'Schedulers have basic read and write access to the platform. They cannot approve creatives or line items, and they cannot manage users.'
    },
    selectiveListing: {
      adServer: 'ad server',
      deals: 'deals',
      openExchange: 'open exchange',
      storeFront: 'storefront'
    },
    sortDirection: {
      ascending: 'ascending',
      descending: 'descending'
    },
    tags: {
      description: {
        adult: 'Adult screens are in locations that are only suitable for mature and adult audiences',
        cannabis_shop: 'Those screens are in locations that are reported to relate to Cannabis consumption or sale'
      },
      names: {
        adult: 'adult',
        cannabis_shop: 'cannabis shop'
      }
    },
    temperatureLimits: {
      current: 'current temperature',
      high: 'Forecast high in next 9 to 12 hours',
      low: 'Forecast low in next 9 to 12 hours'
    },
    unit: {
      facingDirection: {
        E: 'E',
        N: 'N',
        NE: 'NE',
        NW: 'NW',
        RO: 'Rotating',
        S: 'S',
        SE: 'SE',
        SW: 'SW',
        W: 'W'
      }
    },
    uv: {
      extreme: 'extreme',
      high: 'high',
      low: 'low',
      moderate: 'moderate',
      veryHigh: 'very high'
    },
    venueTypes: {
      airports: 'Airports',
      apartmentbuildings: 'Apartment Buildings',
      banks: 'Banks',
      bars: 'Bars',
      billboards: 'Billboards',
      buses: 'buses',
      busshelters: 'Bus Shelters',
      cannabisdispensaries: 'Cannabis Dispensaries',
      casualdining: 'Casual Dining',
      collegesanduniversities: 'Colleges and Universities',
      conveniencestores: 'Convenience Stores',
      dmvs: 'DMVs',
      doctorsoffices: 'Doctor\'s Offices',
      education: 'Education',
      ferry: 'Ferry',
      financial: 'Financial',
      gasstations: 'Gas Stations',
      golfcarts: 'Golf Carts',
      government: 'Government',
      grocery: 'Grocery',
      gyms: 'gyms',
      healthbeauty: 'Health & Beauty',
      highenddining: 'High-End Dining',
      hotels: 'hotels',
      leisure: 'leisure',
      liquorstores: 'Liquor Stores',
      mall: 'Mall',
      militarybases: 'Military Bases',
      movietheaters: 'Movie Theaters',
      nightclubs: 'Night Clubs',
      officebuildings: 'Office Buildings',
      outdoor: 'Outdoor',
      parkinggarages: 'Parking Garages',
      pharmacies: 'Pharmacies',
      pointofcare: 'Point of Care',
      postoffices: 'Post Offices',
      qsr: 'QSR',
      recreationallocations: 'Recreational Locations',
      residential: 'Residential',
      retail: 'Retail',
      salons: 'salons',
      schools: 'Schools',
      spas: 'spas',
      sportsentertainment: 'Sports Entertainment',
      subway: 'subway',
      taxiridesharetop: 'Taxi & Rideshare Top',
      taxiridesharetv: 'Taxi & Rideshare TV',
      trainstations: 'Train Stations',
      transit: 'Transit',
      urbanpanels: 'Urban Panels',
      veterinaryoffices: 'Veterinary Offices'
    },
    weather: {
      clear: 'clear',
      cloudy: 'cloudy',
      raining: 'raining',
      snowing: 'snowing',
      sunny: 'sunny'
    }
  },
  prepositions: {
    of: 'of'
  },
  settings: {
    allowExchangeFeeOverride: 'Allow exchange fee override',
    audienceGeoStatisticsUrl: 'audience geo-statistics URL',
    availableLocationIDs: 'IDs of countries available in the location tree',
    cacheDspCreatives: 'cache DSP creatives',
    canEditExchangeLineItems: 'Allow editing of exchange line items',
    creativeProperties: 'Custom creative properties',
    currencySymbol: 'Currency symbol',
    defaultAdServerLogoUrl: 'default ad server logo URL',
    defaultAdServerName: 'default ad server name',
    dspBrandingImage: 'DSP logo file appearing in the app header',
    dspBrandingName: 'DSP name appearing in the app header',
    dspLineItemMaxStartDaysInAdvance: 'Maximum number of days a line item can be created in advance',
    exchangeBrandingImage: 'exchange branding image',
    exchangeBrandingName: 'exchange branding name',
    externalAvailsUrl: 'external avails URL',
    isDiscountEditingEnabled: 'Allow discount editing',
    minimumLineItemImpressionsToEnableMeasurementRequests: 'minimum line item impressions to enable measurement requests',
    packageCustomProperties: 'deal custom properties',
    reportPostProcessIsbaNetReachFrequency: 'report post-process ISBA net reach and frequency',
    sspBrandingImage: 'SSP logo file appearing in the app header',
    sspBrandingName: 'SSP name appearing in the app header',
    uiDSPAvailablePurchaseTypes: 'Purchase types available in the DSP',
    uiDefaultLineItemMapFilters: 'default line item map filters in edit mode',
    uiEnableAppDomainID: 'enable app domain ID',
    uiEnableAudienceCPM: 'enable audience CPM',
    uiEnableAudienceLogics: 'Enable custom audiences',
    uiEnableAuditTrails: 'Enable audit trails',
    uiEnableBetaFeatures: 'Enable beta features',
    uiEnableCompanionAd: 'Enable companion ad',
    uiEnableCustomAudienceExternalDemographics: 'enable custom audience external demographics',
    uiEnableDemoFeatures: 'enable demo features',
    uiEnableDisplayOfSiteIDNextToSiteName: 'Show site ID next to site name',
    uiEnableGeofenceGroupTargeting: 'Enable geofence group targeting',
    uiEnableGeofenceGroups: 'Enable geofence groups',
    uiEnableGeofenceGroupsRulesInAudienceLogics: 'Enable geofence group rules in custom audiences',
    uiEnableLineItemAdDuration: 'Enable line item ad duration',
    uiEnableLineItemCheckAvails: 'Enable check avails for line items',
    uiEnableLineItemDaypart: 'Enable line item daypart',
    uiEnableLineItemDemographics: 'Enable line item demographics',
    uiEnableLineItemMobileRetargeting: 'Enable line item mobile retargeting',
    uiEnableLineItemSiteTargeting: 'Enable line item site targeting',
    uiEnableLineItemUnitTargeting: 'Enable line item screen targeting',
    uiEnableMobileLineItems: 'enable mobile line items',
    uiEnablePMPDeals: 'Enable PMP deals',
    uiEnablePackageAdDuration: 'Enable deal ad duration',
    uiEnablePackageCheckAvails: 'Enable check avails for deals',
    uiEnablePackageDaypart: 'Enable deal daypart',
    uiEnablePreSaleHeatmaps: 'Enable proposal heatmaps',
    uiEnableReportDefinitionMetricForPlays: 'Enable report definition metric for plays',
    uiEnableRevenueStream: 'Enable revenue tream',
    uiEnableUpdatedInventoryExport: 'enable updated inventory export',
    uiForceNetworkSelectionInLineitemsAndDeals: 'force network selection in line items and deals',
    uiHideReportFees: 'hide report fees',
    uiHideUnitReporting: 'hide unit reporting',
    uiSSPAlwaysShowLineItemCreatives: 'Always show line item creatives in the SSP'
  },
  states: {
    above: 'above',
    accepted: 'accepted',
    active: 'active',
    added: 'added',
    after: 'after',
    approved: 'approved',
    archived: 'archived',
    assemblingReport: 'assembling report',
    audienceLogicCompleted: 'ready',
    audienceLogicSubmitted: 'processing',
    audienceLogicUnsubmitted: 'pending',
    available: 'available',
    before: 'before',
    below: 'below',
    buyerDefinable: 'buyer definable',
    cancelled: 'cancelled',
    completed: 'completed',
    customAudienceCompleted: 'custom audience data ready',
    customAudienceNotReady: 'custom audience submitted, not ready',
    customAudiencePartiallyReady: 'custom audience submitted, partially ready',
    customAudienceReady: 'custom audience ready',
    customAudienceSubmitted: 'custom audience submitted',
    customAudienceUnsubmitted: 'custom audience not yet submitted',
    customizable: 'customizable',
    disabled: 'disabled',
    discounted: 'discounted',
    done: 'done',
    doneAmend: 'amending complete',
    draft: 'draft',
    dv360Product: 'DV360 product',
    enableReportScheduling: 'Enable Report Scheduling',
    enabled: 'enabled',
    error: 'error',
    excluded: 'excluded',
    excluding: 'excluding',
    existing: 'existing',
    failAmend: 'amending failed',
    firstPrice: 'first price',
    fixed: 'fixed',
    fixedPrice: 'fixed price',
    flexible: 'flexible deal',
    good: 'good',
    high: 'high',
    inProgress: 'in progress',
    inactive: 'inactive',
    included: 'included',
    landscapeOrientation: 'landscape',
    live: 'live',
    loading: 'loading',
    locked: 'locked',
    loggingIn: 'logging in',
    low: 'low',
    maybeAvailable: 'maybe available',
    missing: 'missing',
    modified: 'modified',
    new: 'new',
    normal: 'normal',
    notAvailable: 'not available',
    off: 'off',
    on: 'on',
    overbookedReserved: 'overbooked reserved',
    partiallyApproved: 'partially approved',
    partiallyAvailable: 'partially available',
    partiallyRejected: 'partially rejected',
    paused: 'paused',
    pending: 'pending',
    pendingApproval: 'pending approval',
    percent: 'percent',
    perfect: 'perfect',
    playing: 'playing',
    portraitOrientation: 'portrait',
    predefined: 'predefined',
    processingPlaylogs: 'processing playlogs',
    published: 'published',
    queued: 'queued',
    readOnly: 'read only',
    ready: 'ready',
    rejected: 'rejected',
    relative: 'relative',
    reserved: 'reserved',
    resettingPassword: 'resetting password',
    restricted: 'restricted',
    retired: 'retired',
    running: 'running',
    saved: 'saved',
    searching: 'searching',
    selected: 'selected',
    stopped: 'stopped',
    submitted: 'submitted',
    syncToDV360: 'Sync to DV360',
    targeting: 'targeting',
    unreserved: 'unreserved',
    upcoming: 'upcoming',
    verifyingEmail: 'Verifying your email',
    visible: 'visible',
    waitAmend: 'Amending'
  },
  tooltips: {
    cantChangeLIDealTypeAfterSaving: 'You cannot switch between deal types after the Line Item has been saved',
    proximitySearchPlacesInput: 'Slight variation of keywords can lead to different results. For the most accurate results, search using “[KEYWORD] in [CITY/REGION]” to target the points of interest for one city/region at a time.'
  },
  validatorNames: {
    adDuration: 'ad duration',
    adDurationMin: 'ad duration',
    advertiserFilter: 'advertiser',
    advertiserID: 'advertiser',
    allowAudio: 'Allow audio',
    allowHtml: 'Allow HTML',
    allowImage: 'Allow Images',
    allowVideo: 'Allow Videos',
    allowZip: 'Allow Zip',
    audienceFileID: 'audience file',
    availableEndDate: 'date until which the package is available',
    availableForAdServer: 'Available for ad Server',
    availableForDeals: 'Available for deals',
    availableForOpenExchange: 'Available for open exchange',
    availableFrom: 'available from',
    availableStartDate: 'date from which the package is available',
    availableTo: 'available to',
    budget: 'total amount',
    budgetMax: 'maximum budget',
    budgetMin: 'minimum budget',
    buyerFilter: 'buyer',
    buyerOrganizationDSPs: 'buyers',
    buyingPlatformFilter: 'buying platform',
    campaignBudget: 'campaign budget',
    campaignFilter: 'campaign',
    campaignMarginName: 'campaign margin name',
    campaignMarginType: 'campaign margin type',
    campaignMarginValue: 'campaign margin value',
    campaignName: 'campaign name',
    candidateFrequency: 'minimum number of times observed',
    categoryName: 'category name',
    code: 'code',
    companionGroupName: 'companion ad group name',
    cpmFixed: 'CPM',
    cpmFromRateCard: 'rate card CPM',
    creativeFileFilter: 'creative file',
    creativeFileHeightFilter: 'creative file height',
    creativeFileWidthFilter: 'creative file width',
    creativeFilter: 'creative',
    currentPassword: 'current password',
    dailyCap: 'daily cap',
    dailyGoalCap: 'daily goal cap',
    dateOption: 'Date',
    daypart: 'daypart',
    dealFilter: 'deal',
    dealID: 'deal ID',
    dealIdFilter: 'deal ID',
    demographics: 'demographics',
    dimensions: 'dimensions',
    email: 'email',
    enabled: 'Active',
    endDate: 'end date',
    endDateMax: 'end date (max)',
    endDateMin: 'end date',
    exchangeFeeOverrideValue: 'exchange fee override value',
    externalDealIdExtra: 'deal ID',
    externalDemographicID: 'additional behavioral targeting',
    externalDspNameExtra: 'dsp name',
    externalID: 'external ID',
    facingDirection: 'facing direction',
    floorCPM: 'floor CPM',
    fromDate: 'from date',
    geofenceGroupID: 'geofence group',
    impressions: 'impressions',
    infiniteBudget: 'unlimited budget',
    isActive: 'enabled',
    key: 'key',
    latitude: 'latitude',
    lineItemFilter: 'line item',
    lineItemMarginName: 'line item margin name',
    lineItemMarginType: 'line item margin type',
    lineItemMarginValue: 'line item margin value',
    locationID: 'location',
    locationTargetIDs: 'locations',
    logicalExpression: 'logical expression',
    longitude: 'longitude',
    marketTargetedImpressionsMax: 'maximum targeted impressions',
    marketTargetedImpressionsMin: 'minimum targeted impressions',
    maxBidCPM: 'max bid CPM',
    maxNumberOfDays: 'maximum number of days',
    maxSpotLength: 'Maximum ad duration',
    mediaOwnerFilter: 'media owner',
    mediaOwnerIDs: 'Media owners',
    metrics: 'metrics',
    minAdDuration: 'ad duration',
    minBudget: 'minimum budget',
    minMinSecondsBetweenPlays: 'screen frequency cap',
    minNumberOfDays: 'minimum number of days',
    minSecondsBetweenPlays: 'Minimum seconds between plays',
    minSecondsBetweenPlaysMin: 'frequency cap',
    minSpotLength: 'Minimum ad duration',
    name: 'name',
    networkID: 'network',
    networks: 'networks',
    newAccountName: 'account name',
    newAdvertiserDomain: 'advertiser domain',
    newAdvertiserName: 'advertiser name',
    numberOfDays: 'number of days',
    numberOfDaysMax: 'maximum number of days',
    numberOfDaysMin: 'minimum number of days',
    pacingBudget: 'pacing budget',
    password: 'password',
    password2: 'password verification',
    periodType: 'time unit',
    physicalScreenHeight: 'physical screen height (cm)',
    physicalScreenWidth: 'physical screen width (cm)',
    physicalUnitCount: 'Overridden screen count',
    purchaseType: 'purchase type',
    revenueSourceFilter: 'revenue source',
    screenHeight: 'Screen height',
    screenWidth: 'Screen width',
    selectedAccount: 'account',
    selectedAdvertiser: 'advertiser',
    selectedSSP: 'SSP | SSPs',
    selectiveListing: 'selective listing',
    siteID: 'site ID',
    spotLength: 'Default ad duration',
    startDate: 'start date',
    startDateMax: 'start date (max)',
    startDateMin: 'start date',
    state: 'state',
    targetImpressions: 'impression goal',
    timePeriod: 'time period',
    timezone: 'timezone',
    toDate: 'to date',
    token: 'token',
    unitLanguages: 'languages',
    unitUUID: 'Ad request API UUID',
    visibleInMarketplaceEndDate: 'date until which the package is visible in the marketplace',
    visibleInMarketplaceStartDate: 'date from which the package is visible in the marketplace',
    weeklyImpressions: 'weekly impressions'
  }
}